/**
 * Veluna Add to Cart Handler
 *
 * VERIFY IN BROWSER CONSOLE (copy/paste this line):
 * [...document.scripts].filter(function(s){return s.src && s.src.indexOf('veluna')>-1;}).forEach(function(s){console.log(s.src);});
 * 
 * CURSOR_DEPLOY_V1
 */

// CURSOR_DEPLOY_V1
// ============================================================================
// BOOT: IMMEDIATE marker - runs before ANY other code
// ============================================================================
window.__VELUNA_DEPLOY_FP__ = window.__VELUNA_DEPLOY_FP__ || {};
window.__VELUNA_DEPLOY_FP__.addToCart = 'CURSOR_DEPLOY_V1';
window.__VELUNA_BOOT__ = {
  ts: Date.now(),
  href: location.href,
  host: location.host,
  top: window === window.top,
  designMode: !!(window.Shopify && window.Shopify.designMode)
};
window.__VELUNA_BOOT_ERROR__ = null;
console.log('[VELUNA] BOOT', window.__VELUNA_BOOT__);

// ============================================================================
// FLOATING CART CTA THUMBNAIL FIX
// Ensures the floating "Cart / Secure Checkout" CTA shows the correct image,
// especially for Subscribe & Save bundles where the cart contains component
// line items but the UI should show the bundle parent image.
// NOTE: Implemented here (asset) to bypass storefront HTML caching.
// ============================================================================
(function() {
  try {
    if (window.__VELUNA_FLOATING_CTA_THUMB_PATCHED) return;
    window.__VELUNA_FLOATING_CTA_THUMB_PATCHED = true;

    function normalizeImageUrl(img) {
      if (!img || typeof img !== 'string') return null;
      if (img.indexOf('//') === 0) return 'https:' + img;
      return img;
    }

    function pickBestThumbFromCart(cart) {
      try {
        var items = (cart && cart.items) || [];
        if (!items.length) return null;

        // Prefer subscription bundle parent image.
        for (var i = items.length - 1; i >= 0; i--) {
          var it = items[i];
          var props = it && it.properties ? it.properties : null;
          if (!props) continue;
          if (props._purchase_type === 'subscribe' && props._bundle_parent_handle && props._bundle_parent_image) {
            return normalizeImageUrl(String(props._bundle_parent_image));
          }
        }

        // Fallback: last item image.
        var item = items[items.length - 1] || items[0];
        var img = null;
        if (item && item.featured_image) img = item.featured_image.url || item.featured_image;
        img = img || (item ? item.image : null) || null;
        return normalizeImageUrl(img);
      } catch (e) {
        return null;
      }
    }

    function updateFloatingThumb(cart) {
      var imgEl = document.querySelector('.floating-quiz-cta__thumb-img');
      if (!imgEl) return;
      var url = pickBestThumbFromCart(cart);
      if (url) {
        if (imgEl.getAttribute('src') !== url) imgEl.setAttribute('src', url);
        imgEl.style.display = '';
      } else {
        imgEl.removeAttribute('src');
        imgEl.style.display = 'none';
      }
    }

    // Expose for other scripts/debug.
    window.__VELUNA_FLOATING_CTA_UPDATE = updateFloatingThumb;

    var inFlight = null;
    var lastAt = 0;
    function refresh(force) {
      if (!document.querySelector('.floating-quiz-cta')) return;
      var now = Date.now();
      if (!force && now - lastAt < 1500) return;
      lastAt = now;
      if (inFlight) return;
      inFlight = fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(cart) {
          if (!cart) return;
          // Give any other CTA logic a beat, then force-correct.
          setTimeout(function() { updateFloatingThumb(cart); }, 80);
        })
        .catch(function() {})
        .finally(function() { inFlight = null; });
    }

    // Initial + events.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() { refresh(true); }, 400);
      }, { once: true });
    } else {
      setTimeout(function() { refresh(true); }, 400);
    }

    // Try multiple event sources (some fire on window, some on document).
    window.addEventListener('cart:updated', function() { setTimeout(function() { refresh(true); }, 250); });
    window.addEventListener('cart:refresh', function() { setTimeout(function() { refresh(true); }, 250); });
    document.addEventListener('cart:updated', function() { setTimeout(function() { refresh(true); }, 250); });
    document.addEventListener('veluna:cart:added', function() { setTimeout(function() { refresh(true); }, 250); });
    document.addEventListener('visibilitychange', function() { if (!document.hidden) setTimeout(function() { refresh(false); }, 250); });

    // Keep slightly offset from other polling.
    setInterval(function() { refresh(false); }, 3100);
  } catch (e) {}
})();

// ============================================================================
// SIDE CART SELF-HEAL LOADER
// If the side cart script failed to parse/load (e.g. visitors served cached HTML
// that references an older broken build), dynamically reload the latest asset
// with a cache-busting URL.
// ============================================================================
(function() {
  try {
    if (window.__VELUNA_SIDE_CART_LOADED) return;
    if (window.__VELUNA_SIDE_CART_RELOAD_REQUESTED) return;
    window.__VELUNA_SIDE_CART_RELOAD_REQUESTED = true;

    function inject() {
      try {
        if (window.__VELUNA_SIDE_CART_LOADED) return;
        var existing = document.querySelector('script[src*="veluna-product-side-cart.js"]');
        if (!existing || !existing.src) return;
        var base = existing.src.split('?')[0];
        var src = base + '?cb=' + Date.now();
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = function() {
          // no-op; side cart script sets window.__VELUNA_SIDE_CART_LOADED
          if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
            console.log('[VELUNA_ATC] side cart script reloaded', src);
          }
        };
        s.onerror = function() {
          if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
            console.warn('[VELUNA_ATC] side cart script reload failed', src);
          }
        };
        (document.head || document.documentElement).appendChild(s);
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject, { once: true });
    } else {
      inject();
    }
  } catch (e) {}
})();

// ============================================================================
// PHASE 1: Deterministic build marker for proof of execution
// ============================================================================
window.__VELUNA_ATC_BUILD = "ATC_BUILD_20260103_182800";
try {
  if (document.documentElement) {
    document.documentElement.dataset.velunaAtcBuild = "ATC_BUILD_20260103_182800";
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      if (document.documentElement) {
        document.documentElement.dataset.velunaAtcBuild = "ATC_BUILD_20260103_182800";
      }
    }, { once: true });
  }
} catch(e) {}

// ============================================================================
// CART_DRAWER_STRESS_FIX_2026-01-16: Deterministic trace system for drawer open/close
// Debug-gated: Only active when window.VELUNA_DEBUG === true or ?veluna_debug=1
// ============================================================================
(function() {
  var urlParams = new URLSearchParams(window.location.search);
  var isDebugMode = window.VELUNA_DEBUG === true || window.VELUNA_ATC_DEBUG === true || urlParams.get('veluna_debug') === '1';
  
  if (!isDebugMode) return; // Trace disabled in production
  
  window.__VELUNA_DRAWER_TRACE = window.__VELUNA_DRAWER_TRACE || [];
  
  function traceDrawer(event, details) {
    if (!isDebugMode) return;
    var entry = {
      t: performance.now(),
      event: event,
      ts: new Date().toISOString()
    };
    if (details) {
      Object.assign(entry, details);
    }
    window.__VELUNA_DRAWER_TRACE.push(entry);
    // Keep only last 200 entries
    if (window.__VELUNA_DRAWER_TRACE.length > 200) {
      window.__VELUNA_DRAWER_TRACE.shift();
    }
  }
  
  window.__velunaDumpDrawerTrace = function() {
    return window.__VELUNA_DRAWER_TRACE.slice(-200);
  };
  
  // Expose trace function globally
  window.__velunaTraceDrawer = traceDrawer;
  
  traceDrawer('trace-system:init', { isDebugMode: isDebugMode });
})();

// ============================================================================
// PHASE 3B A: Network Tap Instrumentation (debug-gated)
// Monitors fetch, XMLHttpRequest, and sendBeacon for cart API calls
// ============================================================================
(function setupNetworkTap() {
  var urlParams = new URLSearchParams(window.location.search);
  var isDebugMode = window.VELUNA_DEBUG === true || window.VELUNA_ATC_DEBUG === true || urlParams.get('veluna_debug') === '1';
  
  if (!isDebugMode || window.__VELUNA_NETWORK_TAP_BOUND) return;
  window.__VELUNA_NETWORK_TAP_BOUND = true;
  
  var traceFn = window.__velunaTraceDrawer || function() {};
  
  // Check if URL matches cart API patterns
  function isCartApiUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return url.includes('/cart/add') || 
           url.includes('/cart/change') || 
           url.includes('/cart/update') || 
           url.endsWith('.js') && (url.includes('cart') || url.includes('add'));
  }
  
  // Safe payload subset (no PII)
  function getSafePayloadKeys(body) {
    if (!body) return {};
    try {
      if (typeof body === 'string') {
        var parsed = JSON.parse(body);
        if (parsed && typeof parsed === 'object') {
          return {
            hasId: 'id' in parsed,
            hasQuantity: 'quantity' in parsed,
            hasProperties: 'properties' in parsed,
            keys: Object.keys(parsed).slice(0, 10) // First 10 keys only
          };
        }
      }
    } catch(e) {}
    return {};
  }
  
  // 1. Patch window.fetch
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = Array.prototype.slice.call(arguments);
    var url = args[0];
    var options = args[1] || {};
    
    if (isCartApiUrl(url)) {
      var startTime = performance.now();
      var method = options.method || 'GET';
      
      traceFn('net:fetch:request', {
        method: method,
        url: url.substring(0, 200), // Truncate for safety
        hasBody: !!options.body,
        bodyKeys: getSafePayloadKeys(options.body)
      });
      
      if (isDebugMode) {
        console.log('[VELUNA_NET_TAP] fetch request:', { method: method, url: url.substring(0, 200) });
      }
      
      var fetchPromise = originalFetch.apply(this, args);
      
      fetchPromise.then(function(response) {
        var endTime = performance.now();
        var latency = Math.round(endTime - startTime);
        
        traceFn('net:fetch:response', {
          method: method,
          url: url.substring(0, 200),
          status: response.status,
          ok: response.ok,
          latencyMs: latency
        });
        
        if (isDebugMode) {
          console.log('[VELUNA_NET_TAP] fetch response:', { status: response.status, ok: response.ok, latency: latency });
        }
        
        return response;
      }).catch(function(error) {
        var endTime = performance.now();
        var latency = Math.round(endTime - startTime);
        
        traceFn('net:fetch:error', {
          method: method,
          url: url.substring(0, 200),
          errorType: error.name || 'Error',
          errorMessage: error.message ? error.message.substring(0, 100) : String(error),
          latencyMs: latency
        });
        
        if (isDebugMode) {
          console.error('[VELUNA_NET_TAP] fetch error:', error);
        }
        
        throw error;
      });
      
      return fetchPromise;
    }
    
    return originalFetch.apply(this, args);
  };
  
  // 2. Patch XMLHttpRequest
  var originalXHROpen = XMLHttpRequest.prototype.open;
  var originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function() {
    var method = arguments[0];
    var url = arguments[1];
    
    this.__velunaXhrMethod = method;
    this.__velunaXhrUrl = url;
    
    if (isCartApiUrl(url)) {
      this.__velunaXhrStartTime = performance.now();
    }
    
    return originalXHROpen.apply(this, arguments);
  };
  
  XMLHttpRequest.prototype.send = function() {
    var self = this;
    var body = arguments[0];
    
    if (this.__velunaXhrUrl && isCartApiUrl(this.__velunaXhrUrl)) {
      var method = this.__velunaXhrMethod || 'GET';
      var url = this.__velunaXhrUrl;
      
      traceFn('net:xhr:request', {
        method: method,
        url: url.substring(0, 200),
        hasBody: !!body,
        bodyKeys: getSafePayloadKeys(body)
      });
      
      if (isDebugMode) {
        console.log('[VELUNA_NET_TAP] XHR request:', { method: method, url: url.substring(0, 200) });
      }
      
      var originalOnReadyStateChange = this.onreadystatechange;
      this.onreadystatechange = function() {
        if (self.readyState === 4) {
          var endTime = performance.now();
          var latency = Math.round(endTime - (self.__velunaXhrStartTime || endTime));
          
          traceFn('net:xhr:response', {
            method: method,
            url: url.substring(0, 200),
            status: self.status,
            statusText: self.statusText,
            latencyMs: latency
          });
          
          if (isDebugMode) {
            console.log('[VELUNA_NET_TAP] XHR response:', { status: self.status, latency: latency });
          }
        }
        
        if (originalOnReadyStateChange) {
          return originalOnReadyStateChange.apply(this, arguments);
        }
      };
    }
    
    return originalXHRSend.apply(this, arguments);
  };
  
  // 3. Patch navigator.sendBeacon (optional)
  if (navigator.sendBeacon) {
    var originalSendBeacon = navigator.sendBeacon;
    navigator.sendBeacon = function(url, data) {
      if (isCartApiUrl(url)) {
        traceFn('net:beacon:request', {
          url: url.substring(0, 200),
          hasData: !!data
        });
        
        if (isDebugMode) {
          console.log('[VELUNA_NET_TAP] sendBeacon:', { url: url.substring(0, 200) });
        }
      }
      
      return originalSendBeacon.apply(this, arguments);
    };
  }
  
  if (isDebugMode) {
    console.log('[VELUNA_NET_TAP] Network tap instrumentation active');
  }
})();

// ============================================================================
// PHASE 2: Capture-phase click listener to log ATC clicks (debug-gated)
// ============================================================================
(function() {
  var urlParams = new URLSearchParams(window.location.search);
  var isDebugMode = window.VELUNA_DEBUG === true || window.VELUNA_ATC_DEBUG === true || urlParams.get('veluna_debug') === '1';
  
  if (!isDebugMode) return;
  
  window.__VELUNA_CLICK_TRACE = window.__VELUNA_CLICK_TRACE || [];
  
  document.addEventListener('click', function(e) {
    if (!isDebugMode) return;
    
    var target = e.target;
    var button = target.closest('button[data-veluna-atc], button[id*="add-to-cart"], form[action*="/cart/add"] button[type="submit"]');
    if (!button) {
      // Also check if target is inside a form that submits to /cart/add
      var form = target.closest('form[action*="/cart/add"]');
      if (form) {
        button = form.querySelector('button[type="submit"]');
      }
    }
    
    if (button) {
      var clickEvent = {
        t: performance.now(),
        ts: new Date().toISOString(),
        targetOuterHTML: button.outerHTML.substring(0, 200),
        buttonId: button.id || null,
        buttonType: button.type || null,
        buttonClass: button.className || null,
        dataVelunaAtc: button.getAttribute('data-veluna-atc') || null,
        dataVelunaAtcContext: button.getAttribute('data-veluna-atc-context') || null,
        formAction: button.closest('form') ? (button.closest('form').action || button.closest('form').getAttribute('action') || null) : null,
        dataset: {}
      };
      
      // Copy all data- attributes
      if (button.dataset) {
        for (var key in button.dataset) {
          if (button.dataset.hasOwnProperty(key)) {
            clickEvent.dataset[key] = button.dataset[key];
          }
        }
      }
      
      window.__VELUNA_CLICK_TRACE.push(clickEvent);
      if (window.__VELUNA_CLICK_TRACE.length > 100) {
        window.__VELUNA_CLICK_TRACE.shift();
      }
    }
  }, true); // Capture phase
})();

// ============================================================================
// CRASH CAPTURE: Wrap entire file in try/catch to catch any top-level exceptions
// ============================================================================
try {

// ============================================================================
// PARSE + EXECUTION PROOF: If you see this log, the script parsed and executed
// ============================================================================
console.log('[VELUNA_PROOF] atc top-level executed', new Date().toISOString());
window.__VELUNA_ATC_LOADED = (window.__VELUNA_ATC_LOADED || 0) + 1;
console.log('[VELUNA_PROOF] atc load count', window.__VELUNA_ATC_LOADED);

// ============================================================================
// CLICK-CHAIN PROOF: Capture-phase listeners that cannot be blocked
// ============================================================================
(function attachClickChainProof() {
  function getPath(e) {
    var path = e.composedPath ? e.composedPath() : [];
    return path.slice(0, 5).map(function(el) {
      return el.tagName ? (el.tagName + (el.id ? '#' + el.id : '') + (el.className ? '.' + String(el.className).split(' ')[0] : '')) : String(el);
    });
  }
  
  function isAtcTarget(el) {
    if (!el || typeof el.closest !== 'function') return false;
    // PHASE 3: Generic ATC target detection - no template-specific selectors
    return !!el.closest('[data-add-to-cart], [data-veluna-atc], button[name="add"], button[type="submit"][data-veluna-atc], form[data-veluna-product-form]');
  }
  
  // POINTERDOWN - fires before click, even if click is prevented
  window.addEventListener('pointerdown', function(e) {
    console.log('[VELUNA_PROOF] pointerdown', {
      tag: e.target && e.target.tagName,
      id: e.target && e.target.id,
      class: e.target && e.target.className,
      defaultPrevented: e.defaultPrevented,
      eventPhase: e.eventPhase,
      path: getPath(e),
      isAtc: isAtcTarget(e.target)
    });
  }, true);
  
  // CLICK - capture phase
  document.addEventListener('click', function(e) {
    console.log('[VELUNA_PROOF] click', {
      tag: e.target && e.target.tagName,
      id: e.target && e.target.id,
      class: e.target && e.target.className,
      defaultPrevented: e.defaultPrevented,
      eventPhase: e.eventPhase,
      path: getPath(e),
      isAtc: isAtcTarget(e.target)
    });
  }, true);
})();

// ============================================================================
// FETCH INSTRUMENTATION: Prove network calls are made
// ============================================================================
(function instrumentFetch() {
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = String(args[0] || '');
    if (url.indexOf('/cart/add') > -1) {
      console.log('[ATC FETCH]', { url: url, method: (args[1] && args[1].method) || 'GET', body: args[1] && args[1].body });
    }
    return originalFetch.apply(this, args);
  };
})();

// ============================================================================
// HARD-FORCE TEST: Bypass ALL guards and prove Shopify accepts the request
// Call: window.__VELUNA_FORCE_ADD__(variantId) from console
// ============================================================================
window.__VELUNA_FORCE_ADD__ = function(variantId) {
  console.log('[VELUNA_FORCE] Starting hard-force add for variantId:', variantId);
  var url = '/cart/add.js'; // VELUNA_FORCE: Use relative path (same-origin)
  var body = 'id=' + variantId + '&quantity=1';
  console.log('[VELUNA_FORCE] POST', url, body);
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
    body: body,
    credentials: 'include'
  }).then(function(r) {
    console.log('[VELUNA_FORCE] Response status:', r.status);
    return r.text();
  }).then(function(t) {
    console.log('[VELUNA_FORCE] Response body:', t.substring(0, 200));
    return t;
  }).catch(function(e) {
    console.error('[VELUNA_FORCE] Error:', e);
  });
};

// ============================================================================
// HARD TEST (JSON version): Minimal isolated test - NO guards, NO mutex, NO rate limit
// Call: window.__VELUNA_HARD_TEST_ADD__(variantId) from console
// ============================================================================
window.__VELUNA_HARD_TEST_ADD__ = async function(variantId) {
  console.log('[VELUNA_HARD_TEST] attempting add', variantId);
  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      credentials: 'same-origin'
    });
    var text = await res.text();
    var snippet = text.slice(0, 200);
    console.log('[VELUNA_HARD_TEST] status', res.status);
    console.log('[VELUNA_HARD_TEST] body', snippet);
    return { status: res.status, body: text };
  } catch (e) {
    console.error('[VELUNA_HARD_TEST] error', e);
    return { error: e && e.message ? e.message : String(e) };
  }
};

// ============================================================================
// AUTO-DETECT VARIANT: Get variant ID from page for testing
// Call: window.__VELUNA_GET_VARIANT__() from console
// ============================================================================
window.__VELUNA_GET_VARIANT__ = function() {
  var input = document.querySelector('input[name="id"]');
  var vid = input ? input.value : null;
  console.log('[VELUNA_GET_VARIANT]', vid);
  return vid;
};

// ============================================================================
// BUILD STAMP: Unmistakable identifier for this build version
// ============================================================================
var VELUNA_ATC_BUILD_ID = "2025-12-15T12:33:02Z-921cd8";
console.log("[VELUNA_ATC_BUILD] 2025-12-15T12:33:02Z build=921cd8");
window.__VELUNA_ATC_BUILD__ = "[VELUNA_ATC_BUILD] 2025-12-15T12:33:02Z build=921cd8";
console.log("[VELUNA_ATC_BUILD_ID]", VELUNA_ATC_BUILD_ID);
console.log("[VELUNA_ATC_MARKER] veluna-add-to-cart.js LOADED - version with global lock");

// ============================================================================
// GLOBAL MUTEX: MUST be created BEFORE any guards (always available)
// ============================================================================
if (!window.__VELUNA_CART_MUTEX__) {
  window.__VELUNA_CART_MUTEX__ = (function() {
    var queue = [];
    var processing = false;
    var jobCounter = 0;
    var JOB_TIMEOUT_MS = 10000;
    var diag = { queueLength: 0, processing: false, lastJobId: null, lastStartTs: null, lastEndTs: null, lastError: null, totalJobs: 0, timedOutJobs: 0 };
    
    function drainNext() {
      diag.queueLength = queue.length;
      diag.processing = processing;
      if (processing || queue.length === 0) return;
      processing = true;
      diag.processing = true;
      var item = queue.shift();
      var jobId = item.jobId;
      diag.lastJobId = jobId;
      diag.lastStartTs = Date.now();
      diag.queueLength = queue.length;
      console.log('[VELUNA_MUTEX] job start', { jobId: jobId, queueLength: queue.length });
      var timedOut = false;
      var timeoutHandle = setTimeout(function() {
        timedOut = true;
        diag.timedOutJobs++;
        console.error('[VELUNA_MUTEX] TIMEOUT jobId=' + jobId);
        processing = false;
        diag.processing = false;
        diag.lastEndTs = Date.now();
        diag.lastError = 'TIMEOUT';
        item.reject(new Error('[VELUNA_MUTEX] Job timed out'));
        drainNext();
      }, JOB_TIMEOUT_MS);
      Promise.resolve().then(function() {
        return item.fn();
      }).then(function(result) {
        if (!timedOut) { clearTimeout(timeoutHandle); item.resolve(result); }
      }).catch(function(err) {
        if (!timedOut) { clearTimeout(timeoutHandle); diag.lastError = err.message; item.reject(err); }
      }).finally(function() {
        if (!timedOut) { processing = false; diag.processing = false; diag.lastEndTs = Date.now(); drainNext(); }
      });
    }
    return {
      enqueue: function(fn) {
        var jobId = ++jobCounter;
        diag.totalJobs = jobCounter;
        console.log('[VELUNA_MUTEX] enqueue', { jobId: jobId, processing: processing, queueLength: queue.length });
        if (window.__VELUNA_DEBUG_BYPASS_MUTEX__ === true) {
          console.warn('[VELUNA_MUTEX] BYPASS');
          return Promise.resolve(fn());
        }
        return new Promise(function(resolve, reject) {
          queue.push({ fn: fn, resolve: resolve, reject: reject, jobId: jobId });
          drainNext();
        });
      },
      diag: diag,
      forceReset: function() { processing = false; diag.processing = false; queue.forEach(function(i) { i.reject(new Error('RESET')); }); queue = []; }
    };
  })();
  console.log('[VELUNA_MUTEX] INIT', { exists: !!window.__VELUNA_CART_MUTEX__ });
}

// ============================================================================
// ALWAYS-DEFINED GLOBALS: Initialize before guard to ensure they exist even if guard trips
// ============================================================================
window.__VELUNA_ATC_DIAG__ = window.__VELUNA_ATC_DIAG__ || {
  lastUrl: null,
  lastStatus: null,
  lastOk: null,
  lastContentType: null,
  lastRedirected: null,
  lastFinalUrl: null,
  lastWasHtml: false,
  lastError: null,
  lastSnippet: null
};

// ============================================================================
// DEBUG STATUS: Call window.__VELUNA_DEBUG_STATUS__() to inspect state
// ============================================================================
window.__VELUNA_DEBUG_STATUS__ = function() {
  return {
    boot: window.__VELUNA_BOOT__,
    bootError: window.__VELUNA_BOOT_ERROR__,
    hasDiag: !!window.__VELUNA_ATC_DIAG__,
    hasMutex: !!window.__VELUNA_CART_MUTEX__,
    inflight: window.__VELUNA_ATC_INFLIGHT__,
    bypassVerify: window.__VELUNA_DEBUG_BYPASS_VERIFY__,
    bypassMutex: window.__VELUNA_DEBUG_BYPASS_MUTEX__,
    href: location.href,
    host: location.host
  };
};

// ============================================================================
// WHERE: Quick diagnostic helper - MUST be defined BEFORE guard
// ============================================================================
window.__VELUNA_WHERE__ = function() {
  return {
    href: location.href,
    isTop: window === window.top,
    designMode: !!(window.Shopify && window.Shopify.designMode),
    hasBoot: !!window.__VELUNA_BOOT__,
    hasDiag: !!window.__VELUNA_ATC_DIAG__,
    hasHandlersAttached: !!window.__VELUNA_ATC_HANDLERS_ATTACHED__
  };
};

// ============================================================================
// HANDLER DEFINITIONS: Defined OUTSIDE guard so they always exist
// These reference functions that will be defined inside the guard
// ============================================================================
if (!document.__velunaAtcCaptureHandler) {
  document.__velunaAtcCaptureHandler = function(e) {
    try {
      // Safety check: ensure implementation function exists
      if (typeof window.__velunaResolveButton !== 'function' || typeof window.__velunaHandleAtcClick !== 'function') {
        return; // Functions not ready yet
      }
      
      var target = e.target;
      var button = window.__velunaResolveButton(target);
      
      // Check if this is OUR ATC button
      var isOurButton = button && (
        button.hasAttribute('data-veluna-atc') || 
        button.id === 'recovery-cream-add-to-cart' || 
        button.classList.contains('recovery-cream-hero__cross-sell-button') ||
        button.classList.contains('recovery-cream-cross-sell-item__button')
      );
      
      if (isOurButton) {
        // This is our button - ALWAYS stop propagation to prevent external guards
        e.stopImmediatePropagation();
        e.stopPropagation();
        
        // Also prevent default if it's a submit button or inside a form-like wrapper we manage
        var form = button.closest('form') || 
                   button.closest('.recovery-cream-hero__form') || 
                   button.closest('[data-product-form]') || 
                   button.closest('.product-form');
        if (button.type === 'submit' || form) {
          e.preventDefault();
        }
        
        // Process the click (may return false if inflight/disabled, but we still blocked propagation)
        window.__velunaHandleAtcClick(e, 'capture');
      }
    } catch (err) {
      console.error('VELUNA_ATC: capture handler error:', err);
      // Don't re-throw
    }
  };
}

if (!document.__velunaAtcBubbleHandler) {
  document.__velunaAtcBubbleHandler = function(e) {
    try {
      // Safety check: ensure implementation function exists
      if (typeof window.__velunaResolveButton !== 'function' || typeof window.__velunaHandleAtcClick !== 'function') {
        return; // Functions not ready yet
      }
      
      var target = e.target;
      
      // Resolve button using shared resolver (same logic as capture phase)
      var button = window.__velunaResolveButton(target);
      
      // Skip if no button, disabled, or already handled by capture phase
      if (!button || button.disabled || button.dataset.velunaAtcHandled === '1') {
        return;
      }
      
      // Verify product form context (same logic as capture phase)
      var form = button.closest('form');
      if (!form) {
        return;
      }
      
      var hasProductInput = form.querySelector('input[name="id"]');
      var hasVariantIdAttr = form.querySelector('[data-variant-id]');
      var hasProductContext = hasProductInput || hasVariantIdAttr || 
                                (form.action && form.action.indexOf('/cart/add') !== -1);
      
      if (hasProductContext) {
        // Capture phase didn't handle it, try bubble phase
        window.__velunaHandleAtcClick(e, 'bubble');
      }
    } catch (err) {
      console.error('VELUNA_ATC: bubble handler error:', err);
      // Don't re-throw - allow other handlers to process the click
    }
  };
}

console.log('[VELUNA_ATC] HANDLERS_READY');

// ============================================================================
// IDEMPOTENT HANDLER ATTACHMENT: Attach handlers OUTSIDE guard
// NOTE: This runs early but handlers check for implementation functions at runtime
// Final attachment happens after functions are exposed (see line ~2540)
// ============================================================================
(function attachHandlersIdempotently() {
  // Only attach once
  if (window.__VELUNA_ATC_HANDLERS_ATTACHED__) {
    return;
  }
  
  // Only attach if handlers are defined
  if (!document.__velunaAtcCaptureHandler || !document.__velunaAtcBubbleHandler) {
    return;
  }
  
  function attach() {
    if (window.__VELUNA_ATC_HANDLERS_ATTACHED__) {
      return;
    }
    
    try {
      document.addEventListener('click', document.__velunaAtcCaptureHandler, true);
      document.addEventListener('click', document.__velunaAtcBubbleHandler, false);
      window.__VELUNA_ATC_HANDLERS_ATTACHED__ = true;
      document.__velunaAtcClickBound = true;
      console.log('[VELUNA_ATC] HANDLERS_ATTACHED (early - will be functional after implementation functions exposed)');
    } catch (e) {
      console.error('[VELUNA_ATC] handler attachment failed:', e);
    }
  }
  
  // Defer attachment until DOM is ready AND implementation functions might be available
  // If DOM is already ready, wait a tick to allow guard block to execute
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Wait a tick to allow guard block to execute and expose functions
      setTimeout(attach, 0);
    });
  } else {
    // DOM already ready, wait a tick to allow guard block to execute
    setTimeout(attach, 0);
  }
})();

// ============================================================================
// GLOBAL GUARD: Prevent duplicate execution if script is loaded multiple times
// ============================================================================
if (window.__VELUNA_ATC_LOADED__) {
  console.warn('[VELUNA_ATC] Script already loaded, aborting duplicate execution');
  // Exit early - all code below is wrapped in else block
} else {
  window.__VELUNA_ATC_LOADED__ = true;

  // BOOT LOG: Proves script loaded (must appear before any parse errors)
  console.log('VELUNA_ATC: script loaded');

  // ============================================================================
  // SELF-TEST CHECKLIST (for developers)
  // ============================================================================
  // 1. Theme Editor Preview:
  //    - Click ATC → Network shows POST to https://<shop>.myshopify.com/cart/add.js (200)
  //    - Then GET /cart.js (200, JSON response)
  //    - Drawer opens with item
  // 2. Live Storefront:
  //    - Same as above with relative URLs (/cart/add.js, /cart.js)
  // 3. Password-protected store:
  //    - Console shows: "[VELUNA_ATC] CART_JSON_ERROR: Expected JSON, got HTML..."
  //    - Button resets to original state (not stuck on "Adding...")
  // 4. Double-click protection:
  //    - Rapid clicks only send ONE request
  // ============================================================================

  // ============================================================================
  // STOREFRONT CART ENDPOINTS (Theme Editor compatible)
  // Uses window.VELUNA_CART_ROUTES set by theme.liquid to ensure requests
  // go to the storefront domain, not admin.shopify.com
  // ============================================================================
  // ============================================================================
  // SAME-ORIGIN CART ENDPOINTS HELPER
  // PHASE 1: Always returns relative paths to enforce same-origin requests
  // Works across: custom domain, myshopify.com domain, theme editor/preview
  // ============================================================================
  function velunaGetCartEndpoints() {
    var r = window.VELUNA_CART_ROUTES || {};
    var cartAdd = r.cartAdd || '/cart/add';
    var cart = r.cart || '/cart';
    
    // PHASE 1: Always use relative paths (same-origin)
    // This ensures cart requests work on custom domain, myshopify.com, and theme editor
    var endpoints = {
      addJs: cartAdd + '.js',
      cartJs: cart + '.js'
    };
    
    // PHASE 1: Safety rewrite - ensure URLs are relative
    var traceFn = window.__velunaTraceDrawer || function() {};
    var pageOrigin = window.location ? window.location.origin : '';
    
  function ensureRelative(url) {
    if (!url || typeof url !== 'string') return url;
    
    // PHASE 1 HARDENING: Catch protocol-relative URLs (//domain/...)
    if (url.startsWith('//')) {
      // Protocol-relative URL - rewrite to relative path
      try {
        var urlObj = new URL(url, window.location.href);
        var relativeUrl = urlObj.pathname + (urlObj.search || '');
        traceFn('cart:url:rewritten', {
          from: url,
          to: relativeUrl,
          pageOrigin: pageOrigin,
          reason: 'protocol_relative'
        });
        return relativeUrl;
      } catch(e) {
        // Invalid URL - return as-is
      }
    }
    
    // Check if URL is absolute
    try {
      var urlObj = new URL(url, window.location.href);
      // If absolute (has origin), rewrite to pathname+search for consistency
      if (urlObj.origin && urlObj.origin !== 'null') {
        var relativeUrl = urlObj.pathname + (urlObj.search || '');
        if (urlObj.origin !== pageOrigin) {
          // Origin mismatch - definitely rewrite
          traceFn('cart:url:rewritten', {
            from: url,
            to: relativeUrl,
            pageOrigin: pageOrigin,
            urlOrigin: urlObj.origin,
            reason: 'origin_mismatch'
          });
        } else {
          // Same origin but absolute - rewrite for consistency (minimal trace)
          traceFn('cart:url:rewritten', {
            from: url,
            to: relativeUrl,
            pageOrigin: pageOrigin,
            reason: 'absolute_to_relative'
          });
        }
        return relativeUrl;
      }
    } catch(e) {
      // Invalid URL or already relative - return as-is
    }
    return url;
  }
    
    endpoints.addJs = ensureRelative(endpoints.addJs);
    endpoints.cartJs = ensureRelative(endpoints.cartJs);
    
    return endpoints;
  }

  // ============================================================================
  // LOCALE-AWARE PRODUCT URL HELPER
  // Uses window.Shopify.routes.root for locale-aware URLs (supports /en-CA, /fr-CA, etc.)
  // FORCES locale prefix to ensure region-specific data is pulled
  // ============================================================================
  function velunaGetProductUrl(productHandle) {
    var root = '';
    
    // PRIORITY 1: Try Shopify.routes.root first (locale-aware, e.g., '/en-CA' or '/fr-CA')
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    // PRIORITY 2: Try to detect locale from current URL
    else if (window.location && window.location.pathname) {
      var path = window.location.pathname;
      // Match locale patterns like /en-CA/, /fr-CA/, /en/, /fr/, etc.
      var localeMatch = path.match(/^\/([a-z]{2}(?:-[A-Z]{2})?)\//);
      if (localeMatch) {
        root = '/' + localeMatch[1] + '/';
      }
    }
    // PRIORITY 3: Removed - shopUrl is no longer set (same-origin fix)
    
    // Ensure root ends with / if it's not empty
    if (root && !root.endsWith('/')) {
      root = root + '/';
    }
    
    var url = root + 'products/' + productHandle + '.js';
    console.log('[VELUNA_ATC][LOCALE] Generated product URL:', url, 'from root:', root || '(none, using default)');
    return url;
  }

  // ============================================================================
  // ROBUST FETCH HELPER: Handles HTML responses gracefully (password page, redirects)
  // Why: Shopify can return HTML instead of JSON when:
  //   - Store is password protected
  //   - Theme Editor preview context
  //   - Cloudflare challenge page
  //   - Session expired / redirect to login
  // This helper reads text() first to detect HTML before attempting JSON parse.
  // NOTE: window.__VELUNA_ATC_DIAG__ is initialized outside guard (always defined)
  // ============================================================================

  function velunaFetchJson(url, options) {
    var diag = window.__VELUNA_ATC_DIAG__;
    options = options || {};
    options.credentials = options.credentials || 'include';
    
    // Variables to capture for diagnostics
    var status = null;
    var ok = null;
    var contentType = null;
    var redirected = null;
    var finalUrl = null;
    var raw = null;
    var isHtml = false;
    var errorMsg = null;
    
    function updateDiag() {
      diag.lastUrl = url;
      diag.lastStatus = status;
      diag.lastOk = ok;
      diag.lastContentType = contentType;
      diag.lastRedirected = redirected;
      diag.lastFinalUrl = finalUrl;
      diag.lastWasHtml = isHtml;
      diag.lastError = errorMsg;
      diag.lastSnippet = raw ? raw.substring(0, 200) : null;
    }
    
    return fetch(url, options).then(function(res) {
      status = res.status;
      ok = res.ok;
      contentType = res.headers.get('content-type') || '';
      redirected = res.redirected;
      finalUrl = res.url;
      
      return res.text();
    }).then(function(text) {
      raw = text;
      var rawTrim = (raw || '').trim().toLowerCase();
      isHtml = rawTrim.indexOf('<!doctype') === 0 || /<html[\s>]/i.test(rawTrim);
      var snippet = (raw || '').substring(0, 200);
      
      if (!ok) {
        errorMsg = 'HTTP ' + status;
        throw new Error('[VELUNA_ATC] HTTP ' + status + ' from ' + url + '. snippet=' + snippet);
      }
      
      if (isHtml) {
        errorMsg = 'Expected JSON but got HTML';
        throw new Error('[VELUNA_ATC] Expected JSON but got HTML. URL=' + url + ', snippet=' + snippet);
      }
      
      try {
        var parsed = JSON.parse(raw);
        errorMsg = null;
        updateDiag();
        return parsed;
      } catch (parseErr) {
        errorMsg = 'JSON parse failed: ' + parseErr.message;
        updateDiag();
        throw new Error('[VELUNA_ATC] JSON parse error from ' + url + '. snippet=' + snippet);
      }
    }).catch(function(err) {
      if (!errorMsg) errorMsg = err.message;
      updateDiag();
      throw err;
    });
  }
  
  // Expose globally for other scripts
  window.velunaFetchJson = velunaFetchJson;

  // ============================================================================
  // DEBUG TOGGLE: Set window.VELUNA_ATC_DEBUG = true to enable detailed logging
  // ============================================================================
  window.VELUNA_ATC_DEBUG = window.VELUNA_ATC_DEBUG || false;

  // ============================================================================
  // BIND COUNTER: Track how many times binding is attempted (for debugging)
  // Initialize at top-level to ensure it exists even if other scripts error
  // ============================================================================
  if (typeof window.__velunaAtcBindCount === 'undefined') {
    window.__velunaAtcBindCount = 0;
  }

  // ============================================================================
  // NO GLOBAL LOCKS: Double-click protection handled by button.disabled only
  // NOTE: Mutex is now defined BEFORE the global guard (always available)
  // ============================================================================

  // ============================================================================
  // DIAGNOSTIC: Intercept ALL fetch requests to detect API calls
  // Production-safe: Only active when VELUNA_ATC_DEBUG is true OR ?veluna_debug=1
  // ============================================================================
  (function() {
  if (window._velunaFetchInterceptor) return; // Only add once
  window._velunaFetchInterceptor = true;
  
  // Check if debug mode is enabled
  var urlParams = new URLSearchParams(window.location.search);
  var isDebugMode = window.VELUNA_ATC_DEBUG || urlParams.get('veluna_debug') === '1';
  
  var originalFetch = window.fetch;
  var apiCalls = [];
  var postCartAddTimestamps = []; // Track POST /cart/add.js timestamps for duplicate detection (var for reassignment)
  
  window.fetch = function(...args) {
    var url = args[0];
    var options = args[1] || {};
    
    // Only log POST /cart/add.js - ignore /cart.js GET polling and analytics endpoints
    var isCartAdd = typeof url === 'string' && url.includes('/cart/add.js') && (options.method || 'GET') === 'POST';
    var isExcluded = typeof url === 'string' && (url.includes('api/collect') || url.includes('analytics') || url.includes('track'));
    
    if (isCartAdd && !isExcluded) {
      var now = Date.now();
      
      // Production-safe diagnostic: Detect multiple POSTs within 1 second
      if (isDebugMode) {
        postCartAddTimestamps.push(now);
        // Keep only timestamps from last 2 seconds
        postCartAddTimestamps = postCartAddTimestamps.filter(function(ts) {
          return now - ts < 2000;
        });
        
        if (postCartAddTimestamps.length > 1) {
          console.error('🚨 [VELUNA_ATC_DEBUG] Multiple POST /cart/add.js detected within 1 second!');
          console.trace('Stack trace of duplicate POST:');
          console.log('Timestamps:', postCartAddTimestamps);
        }
      }
      
      var callInfo = {
        timestamp: now,
        time: new Date().toISOString(),
        url: url,
        method: options.method || 'GET',
        caller: 'UNKNOWN',
        stack: new Error().stack.split('\n').slice(2, 5).join(' → ')
      };
      
      // Try to identify caller from stack trace
      var stack = callInfo.stack;
      if (stack.includes('veluna')) {
        callInfo.caller = 'VELUNA CODE';
      } else if (stack.includes('theme')) {
        callInfo.caller = 'THEME SCRIPT';
      }
      
      if (isDebugMode) {
        apiCalls.push(callInfo);
        // Keep only last 20 calls
        if (apiCalls.length > 20) apiCalls.shift();
      }
      
      return originalFetch.apply(this, args).then(function(response) {
        if (isDebugMode) {
          callInfo.responseStatus = response.status;
          callInfo.responseTime = Date.now() - callInfo.timestamp;
          callInfo.isHTML = response.headers.get('content-type') && response.headers.get('content-type').includes('text/html');
          
          if (callInfo.isHTML || response.status === 429) {
            console.warn('⚠️ PROBLEMATIC RESPONSE:', callInfo);
          }
        }
        
        return response;
      }).catch(function(error) {
        if (isDebugMode) {
          callInfo.error = error.message;
          console.error('❌ API CALL FAILED:', callInfo);
        }
        throw error;
      });
    }
    
    return originalFetch.apply(this, args);
  };
  
  // Expose API call log for debugging (only in debug mode)
  if (isDebugMode) {
    window._velunaApiCallLog = function() {
      console.table(apiCalls);
      console.log('Total API calls:', apiCalls.length);
      return apiCalls;
    };
  }
  
    // Fetch interceptor active - logs POST /cart/add.js only (debug mode only)
  })();

  // Wrap in try-catch to prevent silent failures
  try {
  (function() {
  'use strict';
  
    // Initializing add-to-cart handler
  
  // ============================================================================
  // CART DRAWER OPENING
  // ============================================================================
  // CART_DRAWER_STRESS_FIX_2026-01-16: Canonical open contract application
  // Applies the canonical drawer open state to [data-cart-drawer] element
  // This is the single source of truth for "drawer is open" state
  function applyDrawerOpenContract(drawerRoot) {
    if (!drawerRoot) {
      drawerRoot = document.querySelector('[data-cart-drawer]');
      if (!drawerRoot) {
        console.error('[VELUNA_ATC] applyDrawerOpenContract: drawer element not found');
        return false;
      }
    }

    // Ensure premium drawer CSS is active (and safe if CSS isn't present)
    try {
      document.documentElement.classList.add('veluna-ux--arrae-drawer');
    } catch (e) {}
    
    // Reset inline styles from close handlers (close may set inline styles that override CSS)
    // Also remove closed-state classes, otherwise open class may not visually win.
    drawerRoot.classList.remove('veluna-cart-drawer--closed');
    drawerRoot.classList.remove('is-closed');
    try {
      drawerRoot.style.setProperty('display', 'block', 'important');
      drawerRoot.style.setProperty('position', 'fixed', 'important');
      drawerRoot.style.setProperty('top', '0', 'important');
      drawerRoot.style.setProperty('right', '0', 'important');
      drawerRoot.style.setProperty('left', 'auto', 'important');
      drawerRoot.style.setProperty('bottom', '0', 'important');
      drawerRoot.style.setProperty('visibility', 'visible', 'important');
      drawerRoot.style.setProperty('opacity', '1', 'important');
      drawerRoot.style.setProperty('pointer-events', 'auto', 'important');
      drawerRoot.style.setProperty('z-index', '999999', 'important');
    } catch (e) {
      drawerRoot.style.pointerEvents = '';
      drawerRoot.style.visibility = 'visible';
      drawerRoot.style.zIndex = '';
      drawerRoot.style.opacity = '';
      drawerRoot.style.display = '';
    }

    drawerRoot.setAttribute('aria-hidden', 'false');
    
    // Reset backdrop styles
    var backdrop = drawerRoot.querySelector('.veluna-cart-drawer__backdrop, [data-veluna-cart-overlay]');
    if (backdrop) {
      try {
        backdrop.style.setProperty('display', 'block', 'important');
        backdrop.style.setProperty('opacity', '1', 'important');
        backdrop.style.setProperty('visibility', 'visible', 'important');
        backdrop.style.setProperty('pointer-events', 'auto', 'important');
      } catch (e) {
        backdrop.style.pointerEvents = '';
        backdrop.style.display = '';
        backdrop.style.visibility = 'visible';
        backdrop.style.opacity = '';
        backdrop.style.zIndex = '';
      }

      backdrop.setAttribute('aria-hidden', 'false');
    }

    // Ensure panel is visible even if CSS is inactive or stale
    var panel = drawerRoot.querySelector('.veluna-cart-drawer__panel, [data-cart-drawer-panel]');
    if (panel) {
      try {
        panel.style.setProperty('display', 'flex', 'important');
        panel.style.setProperty('position', 'fixed', 'important');
        panel.style.setProperty('top', '0', 'important');
        panel.style.setProperty('bottom', '0', 'important');
        panel.style.setProperty('right', '0', 'important');
        panel.style.setProperty('transform', 'translateX(0)', 'important');
        panel.style.setProperty('visibility', 'visible', 'important');
        panel.style.setProperty('pointer-events', 'auto', 'important');
        panel.style.setProperty('z-index', '999999', 'important');
      } catch (e) {}
    }
    
    // Reset pointer-events on drawer children (close sets them to 'none')
    var drawerChildren = drawerRoot.querySelectorAll('*');
    drawerChildren.forEach(function(child) {
      if (child !== backdrop) {
        child.style.pointerEvents = '';
      }
    });
    
    // Apply canonical open contract: add open class to drawer root
    drawerRoot.classList.add('veluna-cart-drawer--open');
    drawerRoot.classList.add('is-open');
    
    // Apply canonical body classes
    // PHASE 5 FIX: Only add cart-drawer-open (not generic drawer-open) to prevent triggering other drawers
    document.body.classList.add('cart-drawer-open');
    
    // Prevent scroll (canonical scroll lock)
    var scrollY = window.scrollY;
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    
    return true;
  }
  
  function openCartDrawer() {
    var traceFn = window.__velunaTraceDrawer || function() {};
    
    traceFn('open-call', {
      usedThemeApi: !!(window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function'),
      themeApiExists: !!(window.theme && window.theme.cartDrawer),
      stack: new Error().stack.split('\n').slice(2, 6).join(' → ')
    });
    
    // Method 1: Try canonical API first (window.theme.cartDrawer.open)
    if (typeof window.theme !== 'undefined' && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
      try {
        traceFn('open-call:themeApi', { calling: 'window.theme.cartDrawer.open()' });
        var result = window.theme.cartDrawer.open();
        
        // Verify it opened (check canonical contract: open class on [data-cart-drawer])
        setTimeout(function() {
          var drawer = document.querySelector('[data-cart-drawer]');
          var hasOpenClass = drawer && drawer.classList.contains('veluna-cart-drawer--open');
          traceFn('open-call:themeApi:verify', {
            drawerFound: !!drawer,
            hasOpenClass: hasOpenClass,
            verified: hasOpenClass
          });
          
          if (drawer && hasOpenClass) {
            // Drawer opened successfully via canonical API
            return;
          } else {
            console.warn('[VELUNA_ATC] Drawer not open after theme.cartDrawer.open(), applying contract directly...');
            traceFn('open-call:themeApi:fallback', { reason: 'class_not_present_after_100ms' });
            applyDrawerOpenContract(drawer);
          }
        }, 100);
        
        return true;
      } catch (error) {
        console.error('[VELUNA_ATC] Error with window.theme.cartDrawer.open():', error);
        traceFn('open-call:themeApi:error', { error: error.message, stack: error.stack });
        // Fall through to apply contract directly
      }
    }
    
    // Method 2: Canonical API missing or failed - apply contract directly
    traceFn('open-call:fallback', { reason: 'themeApi_not_available_or_failed' });
    return applyDrawerOpenContract();
  }
  
  // CART_DRAWER_STRESS_FIX_2026-01-16: Deprecated - use applyDrawerOpenContract() instead
  // Kept for backward compatibility but should not be used directly
  function openCartDrawerManually() {
    console.warn('[VELUNA_ATC] openCartDrawerManually() is deprecated, use applyDrawerOpenContract() or window.theme.cartDrawer.open()');
    return applyDrawerOpenContract();
  }
  
  // PHASE 2: Fallback close handlers (ONLY if drawer controller is missing - strict debug gate)
  function setupDrawerCloseHandlers() {
    // Strict gate: only if drawer controller is completely missing
    if (window.__VELUNA_DRAWER_CONTROLLER || (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.close === 'function')) {
      if (window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] Drawer controller present, skipping fallback handlers');
      }
      return; // Drawer controller exists, don't set up fallback
    }
    
    if (window.__VELUNA_ATC_CLOSE_HANDLERS_BOUND) {
      return; // Already bound
    }
    window.__VELUNA_ATC_CLOSE_HANDLERS_BOUND = true;
    
    console.warn('[VELUNA_ATC] WARNING: Drawer controller missing, setting up emergency fallback close handlers');
    
    // X button close (robust selectors - check target directly first)
    document.addEventListener('click', function(e) {
      var target = e.target;
      
      // Check if target itself is close button
      var isCloseBtn = false;
      if (target.tagName === 'BUTTON') {
        if (target.className && (target.className.indexOf('close') > -1 || target.className.indexOf('veluna-cart-drawer__close') > -1)) {
          isCloseBtn = true;
        } else if (target.getAttribute && target.getAttribute('aria-label')) {
          var ariaLabel = target.getAttribute('aria-label').toLowerCase();
          if (ariaLabel.indexOf('close') > -1) {
            isCloseBtn = true;
          }
        }
      }
      
      // Also check if target is inside close button
      var closeBtn = target.closest('[data-cart-drawer-close]') ||
                    target.closest('button[aria-label*="Close" i]') ||
                    target.closest('button[aria-label*="close" i]') ||
                    target.closest('.cart-drawer__close') ||
                    target.closest('.drawer__close') ||
                    target.closest('.veluna-cart-drawer__close');
      
      if (isCloseBtn || closeBtn) {
        var drawer = document.querySelector('[data-cart-drawer], .veluna-cart-drawer, [data-veluna-cart-drawer]');
        if (drawer && drawer.classList.contains('veluna-cart-drawer--open')) {
          e.preventDefault();
          e.stopPropagation();
          console.log('[VELUNA_ATC] Close button clicked, closing drawer', {
            isCloseBtn: isCloseBtn,
            closeBtn: !!closeBtn,
            targetTag: target.tagName,
            targetClass: target.className
          });
          closeDrawerManually();
        }
      }
    }, true);
    
    // CART_REMOVE_HARDEN_2026-06-29: always-on remove delegate. Fires
    // regardless of drawer open-state detection so the remove button is
    // never blocked. Bound once at document level.
    if (!window.__velRemoveBound) {
      window.__velRemoveBound = true;
      document.addEventListener('click', function(e) {
        var removeBtn = e.target.closest('[data-cart-remove]');
        if (!removeBtn) return;
        e.preventDefault(); e.stopPropagation();
        var key = removeBtn.getAttribute('data-cart-remove');
        if (!key) return;
        removeBtn.disabled = true; removeBtn.style.opacity='0.4';
        fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: 0 }) })
          .then(function(r){ return r.json(); })
          .then(function(cart){ try{ updateCartDrawerContent(cart); }catch(e2){} try{ if(window.updateCartItemCountCache) window.updateCartItemCountCache(cart.item_count); }catch(e3){} })
          .catch(function(){ removeBtn.disabled=false; removeBtn.style.opacity='1'; });
      }, true);
    }

    // Overlay close (use composedPath for robust detection)
    document.addEventListener('click', function(e) {
      var drawer = document.querySelector('[data-cart-drawer], .veluna-cart-drawer, [data-veluna-cart-drawer]');
      if (!drawer || !drawer.classList.contains('veluna-cart-drawer--open')) {
        return;
      }
      
      // Don't close if clicking on close button (already handled above)
      var target = e.target;
      var isCloseBtn = target.closest('[data-cart-drawer-close]') ||
                      target.closest('.veluna-cart-drawer__close') ||
                      (target.tagName === 'BUTTON' && target.className && target.className.indexOf('close') > -1);
      if (isCloseBtn) {
        return; // Already handled by close button handler
      }
      // Remove handled by always-on delegate above; skip here.
      if (target.closest('[data-cart-remove]')) { return; }
      
      var panel = drawer.querySelector('.veluna-cart-drawer__panel, [data-cart-drawer-panel]');
      var path = e.composedPath ? e.composedPath() : [];
      var clickedOnPanel = panel && (panel.contains(target) || path.some(function(el) { return el === panel || (el && panel.contains(el)); }));
      
      if (!clickedOnPanel) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[VELUNA_ATC] Overlay clicked, closing drawer');
        closeDrawerManually();
      }
    }, true);
    
    // ESC close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var drawer = document.querySelector('[data-cart-drawer], .veluna-cart-drawer');
        if (drawer && drawer.classList.contains('veluna-cart-drawer--open')) {
          var activeEl = document.activeElement;
          var isInput = activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA' || activeEl.tagName === 'SELECT' || activeEl.isContentEditable);
          if (!isInput) {
            e.preventDefault();
            e.stopPropagation();
            closeDrawerManually();
          }
        }
      }
    }, true);
  }
  
  function closeDrawerManually() {
    var drawer = document.querySelector('[data-cart-drawer], .veluna-cart-drawer');
    if (!drawer) {
      console.warn('[VELUNA_ATC] closeDrawerManually: drawer not found');
      return;
    }
    
    console.log('[VELUNA_ATC] closeDrawerManually called, drawer found:', !!drawer);
    
    // Remove open class - CSS handles the hide transition via removing --open class
    drawer.classList.remove('veluna-cart-drawer--open');
    drawer.classList.remove('is-open');
    drawer.classList.add('veluna-cart-drawer--closed');
    drawer.setAttribute('aria-hidden', 'true');
    // NOTE: Do NOT set inline display:none or visibility:hidden on the drawer/panel/backdrop.
    // The CSS `.veluna-cart-drawer` (without --open) already positions it off-screen (right: -100%).
    // Setting inline display:none would require explicit clearing in openCartDrawer(), creating fragile coupling.
    
    // PHASE 2: Remove scroll locks from BOTH html and body
    var htmlEl = document.documentElement;
    var bodyEl = document.body;
    var scrollLockClasses = ['cart-drawer-open', 'drawer-open', 'veluna-drawer-open', 'overflow-hidden', 'no-scroll'];
    scrollLockClasses.forEach(function(className) {
      htmlEl.classList.remove(className);
      bodyEl.classList.remove(className);
    });
    
    // Restore body styles (critical for scroll lock removal)
    if (bodyEl.style.top) {
      var scrollY = bodyEl.style.top.replace('px', '').replace('-', '');
      bodyEl.style.top = '';
      bodyEl.style.position = '';
      bodyEl.style.width = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY, 10));
      }
    }
    bodyEl.style.pointerEvents = '';
    bodyEl.style.overflow = '';
    
    // Remove inert and aria-hidden from main
    var mainEl = document.querySelector('main, [role="main"]');
    if (mainEl) {
      mainEl.style.pointerEvents = '';
      if (mainEl.hasAttribute('inert')) {
        mainEl.removeAttribute('inert');
      }
      if (mainEl.getAttribute('aria-hidden') === 'true') {
        mainEl.removeAttribute('aria-hidden');
      }
    }
    
    console.log('[VELUNA_ATC] drawer closed manually', {
      hasOpenClass: drawer.classList.contains('veluna-cart-drawer--open'),
      ariaHidden: drawer.getAttribute('aria-hidden'),
      scrollLockOnBody: bodyEl.classList.contains('cart-drawer-open'),
      scrollLockOnHtml: htmlEl.classList.contains('cart-drawer-open')
    });
  }
  
  function updateCartDrawerContent(cart) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var emptyState = drawer.querySelector('[data-cart-empty]');
        var itemsContainer = drawer.querySelector('[data-cart-items]');
        var footer = drawer.querySelector('[data-cart-footer]');
        var subtotal = drawer.querySelector('[data-cart-subtotal]');
    
    if (cart.item_count === 0) {
      if (emptyState) emptyState.style.display = 'block';
      if (itemsContainer) itemsContainer.style.display = 'none';
      if (footer) footer.style.display = 'none';
    } else {
          if (emptyState) emptyState.style.display = 'none';
          if (itemsContainer) {
            itemsContainer.style.display = 'block';
            // Sort: subscriptions first, then their bonus gift directly under
            // them, then any other items. This keeps the visual hierarchy
            // (subscription → its bonus → next subscription → its bonus …).
            var _sortedItems = (function () {
              var items = (cart.items || []).slice();
              var subs = [];
              var giftsByParent = {};
              var others = [];
              items.forEach(function (it) {
                var isGift = !!(it.properties && (it.properties._gift === 'true' || it.properties._gift === true));
                if (isGift) {
                  var parent = (it.properties && it.properties._bonus_for) || '__orphan__';
                  (giftsByParent[parent] = giftsByParent[parent] || []).push(it);
                } else if (it.selling_plan_allocation) {
                  subs.push(it);
                } else {
                  others.push(it);
                }
              });
              var ordered = [];
              subs.forEach(function (s) {
                ordered.push(s);
                var g = giftsByParent[s.handle];
                if (g) { ordered = ordered.concat(g); delete giftsByParent[s.handle]; }
              });
              ordered = ordered.concat(others);
              // Append any orphan gifts last (defensive)
              Object.keys(giftsByParent).forEach(function (k) { ordered = ordered.concat(giftsByParent[k]); });
              return ordered;
            })();
            itemsContainer.innerHTML = _sortedItems.map(function(item) {
              // ----------------------------------------------------------------
              // BONUS GIFT RENDERING (strikethrough $47 → FREE, no controls)
              // ----------------------------------------------------------------
              var _isGift = !!(item.properties && (item.properties._gift === 'true' || item.properties._gift === true));
              if (_isGift) {
                // COMPACT BONUS LINE, rewritten 2026-09-21.
                // The struck-through "$47.00" is gone. It came from
                // `item.compare_at_price || 4700`, and the 4700 was hardcoded
                // here, so clearing compare_at_price on the gift SKUs would not
                // have removed it on its own. The guides have never been sold at
                // any price, so a struck-through $47 is a former price that
                // never existed. Never reintroduce a reference price here.
                var _giftTitle = (item.product_title || 'Bonus guide')
                  .replace(/\s*\(pdf\)/ig, '')
                  .replace(/:\s*free with subscription/ig, '')
                  .trim();
                return '<div class="veluna-cart-drawer__item veluna-cart-drawer__item--gift" data-cart-item="' + item.key + '" data-veluna-gift-line="true">' +
                  (item.image ? '<img class="veluna-cart-drawer__gift-thumb" src="' + item.image + '" alt="" width="88" height="88" loading="lazy" decoding="async">' : '<span class="veluna-cart-drawer__gift-mark" aria-hidden="true"></span>') +
                  '<div class="veluna-cart-drawer__item-details">' +
                    '<h3 class="veluna-cart-drawer__gift-title">' + _giftTitle + '</h3>' +
                    '<p class="veluna-cart-drawer__gift-note">Yours with this subscription.</p>' +
                  '</div>' +
                '</div>';
              }

              // BUNDLE_CART_FIX_2026-02-24: Improved cart drawer rendering
              var subscriptionHTML = '';
              var priceHTML = '';
              
              // VOLUME_DISCOUNT_FIX: Detect ALL discounts including cart-level volume discounts
              // Cart-level discounts: item.discounts[] has amount+title, item.line_price is discounted
              // Line-level discounts: item.line_level_discount_allocations[], item.final_line_price is discounted
              var originalLinePrice = item.original_line_price || (item.price * item.quantity);
              var actualLinePrice = item.line_price || item.final_line_price || (item.price * item.quantity);
              var discountAmount = 0;
              if (item.discounts && item.discounts.length > 0) {
                for (var _di = 0; _di < item.discounts.length; _di++) {
                  discountAmount += (item.discounts[_di].amount || 0);
                }
              } else if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
                for (var _dj = 0; _dj < item.line_level_discount_allocations.length; _dj++) {
                  discountAmount += (item.line_level_discount_allocations[_dj].amount || 0);
                }
              } else if (originalLinePrice > actualLinePrice) {
                discountAmount = originalLinePrice - actualLinePrice;
              }
              var hasDiscount = discountAmount > 0;
              
              if (item.selling_plan_allocation) {
                var spa = item.selling_plan_allocation;
                var planName = (spa.selling_plan && spa.selling_plan.name) || '';
                var discount = (spa.selling_plan && spa.selling_plan.price_adjustments && spa.selling_plan.price_adjustments[0]) ? spa.selling_plan.price_adjustments[0].value : 0;
                var nameLower = planName.toLowerCase();
                var months = nameLower.indexOf('6 month') !== -1 ? '6' : (nameLower.indexOf('3 month') !== -1 ? '3' : '1');
                
                if (discount > 0) {
                  subscriptionHTML = '<div style="display:flex;align-items:center;gap:4px;margin-top:2px;"><span style="font-size:0.7rem;font-weight:600;color:#8A5518;background:rgba(138,85,24,0.10);padding:1px 6px;border-radius:3px;white-space:nowrap;">Save ' + discount + '%</span></div>';
                }
                
                var compareAt = spa.compare_at_price;
                var salePrice = spa.price;
                if (compareAt && compareAt > salePrice) {
                  priceHTML = '<span style="color: #8A5518; font-weight: 600;">$' + (salePrice / 100).toFixed(2) + '</span> <span style="text-decoration: line-through; color: #999; font-size: 0.8125rem;">$' + (compareAt / 100).toFixed(2) + '</span>';
                } else {
                  priceHTML = '$' + (salePrice / 100).toFixed(2);
                }
              } else if (hasDiscount) {
                // Volume or line-level discount - show sale price with original crossed out
                var _saleLinePrice = originalLinePrice - discountAmount;
                var _saleUnitPrice = Math.round(_saleLinePrice / (item.quantity || 1));
                var _origUnitPrice = item.original_price || item.price || Math.round(originalLinePrice / (item.quantity || 1));
                priceHTML = '<span style="color: #8A5518; font-weight: 600;">$' + (_saleUnitPrice / 100).toFixed(2) + '</span> <span style="text-decoration: line-through; color: #999; font-size: 0.8125rem;">$' + (_origUnitPrice / 100).toFixed(2) + '</span>';
                // Add savings badge for non-subscription discounts
                var _savePct = Math.round(discountAmount * 100 / originalLinePrice);
                if (_savePct > 0) {
                  subscriptionHTML = '<div style="display:flex;align-items:center;gap:4px;margin-top:2px;"><span style="font-size:0.7rem;font-weight:600;color:#8A5518;background:rgba(138,85,24,0.10);padding:1px 6px;border-radius:3px;white-space:nowrap;">Save ' + _savePct + '%</span></div>';
                }
              } else {
                priceHTML = '$' + (actualLinePrice / 100).toFixed(2);
              }
              
              // Build properties display (Pack, Type, Plan - not internal _ properties)
              var propsHTML = '';
              if (item.properties) {
                var propKeys = Object.keys(item.properties);
                for (var pi = 0; pi < propKeys.length; pi++) {
                  var pk = propKeys[pi];
                  var pv = item.properties[pk];
                  if (pk && pv && pk.charAt(0) !== '_') {
                    propsHTML += '<p class="veluna-body-sm" style="color:#57514A;font-weight:500;margin:2px 0 0;">' + pk + ': ' + pv + '</p>';
                  }
                }
              }
              
              // Determine what to show as the variant subtitle
              // If we have Pack property, prefer that over the raw variant_title  
              var packProp = item.properties && item.properties['Pack'];
              var typeProp = item.properties && item.properties['Type'];
              var variantDisplayHTML = '';
              if (packProp) {
                variantDisplayHTML = '<p class="veluna-body-sm" style="font-weight:500;color:#333;">' + packProp + (typeProp ? ' - ' + typeProp : '') + '</p>';
              } else if (item.variant_title) {
                // ONETIME_LABEL_FIX: If variant is "X Month Delivery" with no selling_plan, show computed label
                if (!item.selling_plan_allocation && item.variant_title.indexOf('Month Delivery') !== -1) {
                  var _qty = item.quantity || 1;
                  variantDisplayHTML = '<p class="veluna-body-sm" style="font-weight:500;color:#8A5518;">' + _qty + (_qty === 1 ? ' Set' : ' Sets') + ' - One Time Purchase</p>';
                } else {
                  variantDisplayHTML = '<p class="veluna-body-sm">' + item.variant_title + '</p>';
                }
              }
              
              // GUIDE_LABEL_2026-06-29: never show "PDF" on front-facing surfaces; treat as a digital Guide
              var _isGuide = /\bguide\b/i.test(item.product_title || '') || /\bpdf\b/i.test(item.product_title || '');
              var _displayTitle = (item.product_title || '').replace(/\s*\(pdf\)/ig, '').replace(/\s*-\s*pdf\b/ig, '').trim();
              // Fallback artwork for the digital guide (no product photo) so the cart line never looks broken
              var _guideArt = "data:image/svg+xml;utf8," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120"><rect width="120" height="120" fill="#F4ECDD"/><rect x="36" y="26" width="48" height="68" rx="4" fill="#fff" stroke="#C9A86A" stroke-width="2"/><line x1="46" y1="42" x2="74" y2="42" stroke="#C9A86A" stroke-width="2"/><line x1="46" y1="54" x2="74" y2="54" stroke="#D8C29A" stroke-width="2"/><line x1="46" y1="66" x2="68" y2="66" stroke="#D8C29A" stroke-width="2"/><text x="60" y="108" text-anchor="middle" font-family="sans-serif" font-size="11" fill="#9A8455">Guide</text></svg>');
              var _imgSrc = item.image || (_isGuide ? _guideArt : '');
              var _itemHTML = '<div class="veluna-cart-drawer__item" data-cart-item="' + item.key + '" style="position:relative;">' +
                '<div class="veluna-cart-drawer__item-image">' +
                  '<img src="' + _imgSrc + '" alt="' + _displayTitle + '" loading="lazy">' +
                '</div>' +
                '<div class="veluna-cart-drawer__item-details">' +
                  '<h3 class="veluna-heading-sm">' + _displayTitle + '</h3>' +
                  variantDisplayHTML +
                  subscriptionHTML +
                  '<div class="veluna-cart-drawer__item-quantity">' +
                    '<span>Qty: ' + (item.quantity || 1) + '</span>' +
                  '</div>' +
                  '<div class="veluna-body-sm" style="margin-top: var(--space-2);">' + priceHTML + '</div>' +
                  '<button type="button" class="veluna-cart-drawer__item-remove" data-cart-remove="' + item.key + '" aria-label="Remove item" style="position:absolute;top:8px;right:8px;width:24px;height:24px;display:flex;align-items:center;justify-content:center;background:none;border:none;padding:0;color:#b3b3b3;font-size:1.25rem;line-height:1;cursor:pointer;font-family:inherit;">&times;</button>' +
                '</div>' +
              '</div>';

              // ----------------------------------------------------------------
              // BONUS PERKS CARD: render under each subscription line item.
              // Lists the 4 non-product subscription perks (savings, free
              // shipping, mystery discount, flexibility) so the customer
              // visualizes everything they get with their subscription.
              // The PDF Gift Guide is a separate $0 line item handled above.
              // ----------------------------------------------------------------
              if (item.selling_plan_allocation && window.VelunaBonusGift && window.VelunaBonusGift.PERKS) {
                var _perksItems = window.VelunaBonusGift.PERKS.map(function (p) {
                  return '<li style="display:flex;gap:8px;align-items:flex-start;padding:4px 0;">' +
                    '<span style="font-size:0.95rem;line-height:1.2;width:18px;text-align:center;flex-shrink:0;">' + p.icon + '</span>' +
                    '<div style="flex:1;min-width:0;">' +
                      '<span style="font-weight:600;color:#3a3a3a;font-size:0.8125rem;">' + p.label + '</span> ' +
                      '<span style="color:#777;font-size:0.78rem;">' + p.detail + '</span>' +
                    '</div>' +
                  '</li>';
                }).join('');
                _itemHTML += '<div class="veluna-cart-drawer__bonus-perks" data-veluna-bonus-perks="' + (item.handle || '') + '" style="margin:6px 0 4px;padding:10px 12px;background:linear-gradient(180deg,#F8F4EC 0%, #FCF8F0 100%);border-radius:8px;border-left:3px solid #C9A86A;">' +
                  '<div style="font-size:0.65rem;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:#7B5E1C;margin-bottom:6px;">Subscription Perks Included</div>' +
                  '<ul style="list-style:none;margin:0;padding:0;">' + _perksItems + '</ul>' +
                '</div>';
              }

              return _itemHTML;
            }).join('');
          }
          if (footer) footer.style.display = 'block';
      if (subtotal) {
        // Show total after all discounts
        var totalFormatted = '$' + (cart.total_price / 100).toFixed(2);
        subtotal.textContent = totalFormatted;
      }
    }
  }

  // Expose so the bonus-gift script can repaint the drawer after async
  // gift reconciliation completes.
  try { window.__VELUNA_UPDATE_DRAWER__ = updateCartDrawerContent; } catch (e) {}
  
  function openDrawerAfterAdd(cart) {
    var traceFn = window.__velunaTraceDrawer || function() {};
    
    // PHASE 3A: Trace entry
    try {
      traceFn('openDrawerAfterAdd:enter', {
        itemCount: cart ? cart.item_count : null,
        url: location.href
      });
    } catch(traceErr) {}
    
    // Determine source (primary vs cross-sell)
    var source = 'unknown';
    var button = document.activeElement;
    if (button && button.hasAttribute('data-veluna-atc')) {
      var context = button.getAttribute('data-veluna-atc-context');
      source = context === 'cross-sell' ? 'cross-sell' : (context === 'hero' ? 'primary' : 'unknown');
    }
    
    traceFn('open-intent', {
      source: source,
      reason: 'afterAdd',
      url: location.href,
      itemCount: cart.item_count,
      buttonId: button ? (button.id || null) : null
    });
    
    console.log('[VELUNA_ATC] openDrawerAfterAdd called', { item_count: cart.item_count });
    
    var getDrawerEl = function() {
      return document.querySelector('.veluna-cart-drawer, [data-veluna-cart-drawer], [data-cart-drawer], #CartDrawer, .cart-drawer');
    };
    var isDrawerOpen = function() {
      var el = getDrawerEl();
      if (!el) return false;
      return el.classList.contains('veluna-cart-drawer--open') || el.classList.contains('is-open') || el.getAttribute('aria-hidden') === 'false';
    };
    
    // Step 1: Update drawer content
    try { updateCartDrawerContent(cart); } catch (e) { console.warn('[VELUNA_ATC] updateCartDrawerContent error:', e.message); }
    
    // Step 2: Open drawer - try methods in order
    var didOpen = false;
    var method = 'none';
    
    // Method A: theme.cartDrawer
    if (!didOpen && window.theme && window.theme.cartDrawer) {
      try {
        // Prefer open() over openWithRefresh() since we already have cart data and updated drawer content
        if (typeof window.theme.cartDrawer.open === 'function') { 
          traceFn('openDrawerAfterAdd:themeApi', { calling: 'window.theme.cartDrawer.open()' });
          window.theme.cartDrawer.open(); 
          // Give it a moment to apply, then check
          // PHASE 1: Track setTimeout for instrumentation
          if (window.__VELUNA_DRAWER_TRACE) {
            window.__VELUNA_DRAWER_TRACE.push({
              timestamp: Date.now(),
              event: 'openAfterAdd:setTimeout',
              data: { delay: 50, method: 'theme.cartDrawer' }
            });
          }
          var openAfterAddTimer = setTimeout(function() {
            if (window.__VELUNA_DRAWER_TRACE) {
              window.__VELUNA_DRAWER_TRACE.push({
                timestamp: Date.now(),
                event: 'openAfterAdd:timeoutFired',
                data: { didOpen: didOpen, isDrawerOpen: isDrawerOpen() }
              });
            }
            if (!didOpen && isDrawerOpen()) { didOpen = true; method = 'theme.cartDrawer'; }
          }, 50);
          // Store timer reference for cleanup
          if (window.__VELUNA_DRAWER_TRACE && window.__VELUNA_DRAWER_TRACE.activeTimers) {
            window.__VELUNA_DRAWER_TRACE.activeTimers.openAfterAdd = openAfterAddTimer;
          }
          if (isDrawerOpen()) { didOpen = true; method = 'theme.cartDrawer'; }
        } else if (typeof window.theme.cartDrawer.openWithRefresh === 'function') { 
          traceFn('openDrawerAfterAdd:themeApi', { calling: 'window.theme.cartDrawer.openWithRefresh()' });
          // openWithRefresh is async - call it but don't wait, fall through to Method C if needed
          window.theme.cartDrawer.openWithRefresh(); 
        }
      } catch (e) { console.warn('[VELUNA_ATC] theme.cartDrawer failed:', e.message); }
    }
    
    // Method B: VelunaCartDrawer
    if (!didOpen && window.VelunaCartDrawer) {
      try {
        // Prefer open() over openWithRefresh() since we already have cart data and updated drawer content
        if (typeof window.VelunaCartDrawer.open === 'function') { 
          window.VelunaCartDrawer.open(); 
          // Give it a moment to apply, then check
          setTimeout(function() {
            if (!didOpen && isDrawerOpen()) { didOpen = true; method = 'VelunaCartDrawer'; }
          }, 50);
          if (isDrawerOpen()) { didOpen = true; method = 'VelunaCartDrawer'; }
        } else if (typeof window.VelunaCartDrawer.openWithRefresh === 'function') { 
          // openWithRefresh is async - call it but don't wait, fall through to Method C if needed
          window.VelunaCartDrawer.openWithRefresh(); 
        }
      } catch (e) { console.warn('[VELUNA_ATC] VelunaCartDrawer failed:', e.message); }
    }
    
    // Method C: Direct DOM (ALWAYS try this as fallback, even if A/B were attempted)
    var drawer = getDrawerEl();
    if (drawer && !didOpen) {
      try {
        drawer.classList.add('veluna-cart-drawer--open');
        drawer.removeAttribute('aria-hidden');
        drawer.style.display = 'block';
        drawer.style.visibility = 'visible';
        if (document.body) {
          // PHASE 5 FIX: Only add cart-drawer-open (not generic drawer-open) to prevent triggering other drawers
    document.body.classList.add('cart-drawer-open');
        }
        // Verify it actually opened
        if (drawer.classList.contains('veluna-cart-drawer--open')) {
          didOpen = true; method = 'direct DOM';
        }
      } catch (e) { console.warn('[VELUNA_ATC] Direct DOM method failed:', e.message); }
    }
    
    // Step 3: Dispatch events
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (didOpen) document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (e) { /* ignore */ }
    
    // PHASE 2: Safety valve - if drawer didn't open, remove scroll locks after 300ms
    var drawerOpenCheckTimeout = null;
    if (!didOpen) {
      // PHASE 1: Track setTimeout for instrumentation
      if (window.__VELUNA_DRAWER_TRACE) {
        window.__VELUNA_DRAWER_TRACE.push({
          timestamp: Date.now(),
          event: 'drawerOpenCheck:setTimeout',
          data: { delay: 300, reason: 'safety_valve' }
        });
      }
      drawerOpenCheckTimeout = setTimeout(function() {
        if (window.__VELUNA_DRAWER_TRACE) {
          window.__VELUNA_DRAWER_TRACE.push({
            timestamp: Date.now(),
            event: 'drawerOpenCheck:timeoutFired',
            data: { didOpen: didOpen }
          });
        }
        var drawer = getDrawerEl();
        var isDrawerOpen = drawer && (drawer.classList.contains('veluna-cart-drawer--open') || 
                                      window.getComputedStyle(drawer).display !== 'none');
        
        if (!isDrawerOpen) {
          console.warn('[VELUNA_ATC] Drawer did not open within 300ms - removing scroll locks (safety valve)');
          
          // Remove scroll locks from both html and body
          var htmlEl = document.documentElement;
          var bodyEl = document.body;
          var scrollLockClasses = ['cart-drawer-open', 'drawer-open', 'veluna-drawer-open', 'overflow-hidden', 'no-scroll'];
          scrollLockClasses.forEach(function(className) {
            htmlEl.classList.remove(className);
            bodyEl.classList.remove(className);
          });
          
          // Restore body styles
          htmlEl.style.overflow = '';
          bodyEl.style.overflow = '';
          bodyEl.style.pointerEvents = '';
          if (bodyEl.style.top) {
            var scrollY = bodyEl.style.top.replace('px', '').replace('-', '');
            bodyEl.style.top = '';
            bodyEl.style.position = '';
            bodyEl.style.width = '';
            if (scrollY) {
              window.scrollTo(0, parseInt(scrollY, 10));
            }
          }
          
          // Remove inert and aria-hidden
          var mainEl = document.querySelector('main, [role="main"]');
          if (mainEl) {
            mainEl.style.pointerEvents = '';
            if (mainEl.hasAttribute('inert')) {
              mainEl.removeAttribute('inert');
            }
            if (mainEl.getAttribute('aria-hidden') === 'true') {
              mainEl.removeAttribute('aria-hidden');
            }
          }
        }
      }, 300);
    }
    
    if (didOpen) {
      console.log('[VELUNA_ATC] DRAWER_OPENED', { method: method });
      // Clear safety valve timeout if drawer opened
      if (drawerOpenCheckTimeout) {
        clearTimeout(drawerOpenCheckTimeout);
      }
    } else {
      var drawerEl = getDrawerEl();
      if (!drawerEl) {
        console.log('[VELUNA_ATC] DRAWER_MISSING');
        // Redirect to /cart on live storefront (not in design mode)
        var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
        if (!isDesignMode && cart.item_count > 0) {
          console.log('[VELUNA_ATC] Redirecting to /cart (drawer missing)');
          window.location.href = '/cart';
        }
      } else {
        console.log('[VELUNA_ATC] DRAWER_FAILED_TO_OPEN', { 
          element: !!drawerEl,
          hasThemeCartDrawer: !!(window.theme && window.theme.cartDrawer),
          hasVelunaCartDrawer: !!window.VelunaCartDrawer,
          drawerClasses: drawerEl.className,
          drawerHasOpenClass: drawerEl.classList.contains('veluna-cart-drawer--open')
        });
        // Final fallback: Force open via direct DOM manipulation
        try {
          drawerEl.classList.add('veluna-cart-drawer--open');
          drawerEl.removeAttribute('aria-hidden');
          drawerEl.style.display = 'block';
          drawerEl.style.visibility = 'visible';
          if (document.body) {
            // PHASE 5 FIX: Only add cart-drawer-open (not generic drawer-open) to prevent triggering other drawers
    document.body.classList.add('cart-drawer-open');
          }
          console.log('[VELUNA_ATC] FORCED_OPEN_VIA_FALLBACK');
          didOpen = true; method = 'forced fallback';
        } catch (e) {
          console.error('[VELUNA_ATC] Fallback open failed:', e);
        }
      }
    }
  }
  
  function checkCartAndOpenDrawer() {
    var endpoints = velunaGetCartEndpoints();
    return velunaFetchJson(endpoints.cartJs)
      .then(function(cart) {
        if (cart.item_count > 0) {
          openDrawerAfterAdd(cart);
        }
        return cart;
      })
      .catch(function(error) {
        console.error('[VELUNA_ATC] CART_JSON_ERROR', error.message);
        setTimeout(function() {
          openCartDrawer();
        }, 300);
      });
  }
  
  // ============================================================================
  // ADD TO CART
  // ============================================================================
  // Normalize variant ID to integer - single source of truth
  function normalizeVariantId(variantId) {
    var num = Number(variantId);
    if (!Number.isInteger(num) || num <= 0) {
      throw new Error('Invalid variant ID: must be a positive integer');
    }
    return num;
  }
  
  // Tile 8: Global variant-level inflight lock (shared across all surfaces)
  window.__VELUNA_VARIANT_INFLIGHT__ = window.__VELUNA_VARIANT_INFLIGHT__ || Object.create(null);
  
  // ============================================================================
  // DEBUG-ONLY INSTRUMENTATION: Track disabled state mutations on ATC buttons
  // ============================================================================
  // Monkeypatches disabled setter and setAttribute/removeAttribute to catch re-disable after drawer close
  // Only active when VELUNA_ATC_DEBUG or VELUNA_DEBUG is true
  (function setupDisabledStateInstrumentation() {
    if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
      return; // Instrumentation disabled in production
    }
    
    // Only set up once
    if (window.__VELUNA_ATC_DISABLED_INSTRUMENTATION_SETUP__) {
      return;
    }
    window.__VELUNA_ATC_DISABLED_INSTRUMENTATION_SETUP__ = true;
    
    // Drawer lifecycle marker
    window.__VELUNA_DRAWER_CLOSED_AT = null;
    
    // Track when drawer close begins/ends
    var originalCloseCartDrawer = window.theme && window.theme.cartDrawer && window.theme.cartDrawer.close;
    if (typeof originalCloseCartDrawer === 'function') {
      window.theme.cartDrawer.close = function() {
        window.__VELUNA_DRAWER_CLOSED_AT = Date.now();
        var result = originalCloseCartDrawer.apply(this, arguments);
        // Mark close completion after a delay
        setTimeout(function() {
          window.__VELUNA_DRAWER_CLOSED_AT = Date.now() + 1000; // Mark as "closed and should be unlocked"
        }, 500);
        return result;
      };
    }
    
    // Helper to check if button is an ATC button
    function isATCButton(button) {
      if (!button || button.nodeType !== 1) return false;
      return button.hasAttribute('data-veluna-atc') ||
             (button.id && (button.id.includes('add-to-cart') || button.id.includes('atc'))) ||
             (button.type === 'submit' && button.closest('form') && button.closest('form').action && button.closest('form').action.includes('/cart/add'));
    }
    
    // Helper to get stack trace
    function getStackTrace() {
      var stack = new Error().stack;
      return stack ? stack.split('\n').slice(2, 10).join('\n') : 'No stack';
    }
    
    // Monkeypatch disabled setter for ATC buttons
    function instrumentButton(button) {
      if (!button || button.__velunaDisabledInstrumented || !isATCButton(button)) return;
      button.__velunaDisabledInstrumented = true;
      
      // Store original disabled descriptor
      var originalDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(button), 'disabled');
      if (!originalDescriptor) return;
      
      var originalGetter = originalDescriptor.get;
      var originalSetter = originalDescriptor.set;
      
      // Override disabled setter
      Object.defineProperty(button, 'disabled', {
        get: function() {
          return originalGetter.call(this);
        },
        set: function(value) {
          var oldValue = originalGetter.call(this);
          var drawerClosedRecently = window.__VELUNA_DRAWER_CLOSED_AT && 
                                     (Date.now() - window.__VELUNA_DRAWER_CLOSED_AT) < 5000; // 5 second window
          
          // Warn if setting disabled=true after drawer close
          if (value === true && oldValue === false && drawerClosedRecently) {
            console.warn('[VELUNA_ATC_DISABLED_INSTRUMENTATION] ⚠️ ATC button re-disabled after drawer close!', {
              button: {
                id: this.id,
                className: this.className,
                hasDataAtcLabel: !!this.querySelector('[data-atc-label]')
              },
              drawerClosedAt: new Date(window.__VELUNA_DRAWER_CLOSED_AT).toISOString(),
              timeSinceClose: Date.now() - window.__VELUNA_DRAWER_CLOSED_AT + 'ms',
              stack: getStackTrace()
            });
          }
          
          // Always allow the mutation
          originalSetter.call(this, value);
        },
        configurable: true,
        enumerable: true
      });
      
      // Monkeypatch setAttribute('disabled')
      var originalSetAttribute = button.setAttribute;
      button.setAttribute = function(name, value) {
        if (name === 'disabled' && value !== false && value !== null) {
          var drawerClosedRecently = window.__VELUNA_DRAWER_CLOSED_AT && 
                                     (Date.now() - window.__VELUNA_DRAWER_CLOSED_AT) < 5000;
          if (drawerClosedRecently) {
            console.warn('[VELUNA_ATC_DISABLED_INSTRUMENTATION] ⚠️ ATC button setAttribute("disabled") after drawer close!', {
              button: {
                id: this.id,
                className: this.className
              },
              value: value,
              drawerClosedAt: new Date(window.__VELUNA_DRAWER_CLOSED_AT).toISOString(),
              timeSinceClose: Date.now() - window.__VELUNA_DRAWER_CLOSED_AT + 'ms',
              stack: getStackTrace()
            });
          }
        }
        return originalSetAttribute.apply(this, arguments);
      };
      
      // Monkeypatch removeAttribute('disabled')
      var originalRemoveAttribute = button.removeAttribute;
      button.removeAttribute = function(name) {
        if (name === 'disabled') {
          var drawerClosedRecently = window.__VELUNA_DRAWER_CLOSED_AT && 
                                     (Date.now() - window.__VELUNA_DRAWER_CLOSED_AT) < 5000;
          if (drawerClosedRecently && window.VELUNA_ATC_DEBUG) {
            console.log('[VELUNA_ATC_DISABLED_INSTRUMENTATION] ✓ removeAttribute("disabled") after drawer close', {
              button: {
                id: this.id,
                className: this.className
              },
              timeSinceClose: Date.now() - window.__VELUNA_DRAWER_CLOSED_AT + 'ms'
            });
          }
        }
        return originalRemoveAttribute.apply(this, arguments);
      };
    }
    
    // Instrument buttons when they're found or created
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                instrumentButton(node);
                if (node.querySelectorAll) {
                  var atcButtons = node.querySelectorAll('[data-veluna-atc], button[type="submit"][id*="add-to-cart"], button[type="submit"][id*="atc"]');
                  Array.from(atcButtons).forEach(instrumentButton);
                }
              }
            });
          }
        });
      });
      
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          if (document.body) {
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
          }
        });
      }
    }
    
    // Instrument existing buttons on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        var existingButtons = document.querySelectorAll('[data-veluna-atc], button[type="submit"][id*="add-to-cart"], button[type="submit"][id*="atc"]');
        Array.from(existingButtons).forEach(instrumentButton);
      });
    } else {
      var existingButtons = document.querySelectorAll('[data-veluna-atc], button[type="submit"][id*="add-to-cart"], button[type="submit"][id*="atc"]');
      Array.from(existingButtons).forEach(instrumentButton);
    }
    
    if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
      console.log('[VELUNA_ATC] Disabled state instrumentation active - will warn on re-disable after drawer close');
    }
  })();
  
  // ============================================================================
  // DEBUG-ONLY REGRESSION GUARD: Detect textContent mutations on ATC buttons
  // ============================================================================
  // Monkeypatches button.textContent setter to warn if any code directly mutates it
  // Only active when VELUNA_ATC_DEBUG or VELUNA_DEBUG is true
  (function setupRegressionGuard() {
    if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
      return; // Guard disabled in production
    }
    
    // Only set up once
    if (window.__VELUNA_ATC_REGRESSION_GUARD_SETUP__) {
      return;
    }
    window.__VELUNA_ATC_REGRESSION_GUARD_SETUP__ = true;
    
    // Watch for ATC buttons and guard their textContent setter
    function guardButtonTextContent(button) {
      if (!button || button.__velunaTextContentGuarded || button.nodeType !== 1) return;
      button.__velunaTextContentGuarded = true;
      
      // Check if this is an ATC button
      var isATCButton = button.hasAttribute('data-veluna-atc') ||
                       (button.id && (button.id.includes('add-to-cart') || button.id.includes('atc'))) ||
                       (button.type === 'submit' && button.closest('form') && button.closest('form').action && button.closest('form').action.includes('/cart/add'));
      
      if (!isATCButton) return;
      
      // Store original textContent descriptor
      var originalDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(button), 'textContent');
      if (!originalDescriptor || !originalDescriptor.set) return;
      
      var originalGetter = originalDescriptor.get;
      var originalSetter = originalDescriptor.set;
      
      // Override textContent setter
      Object.defineProperty(button, 'textContent', {
        get: function() {
          return originalGetter.call(this);
        },
        set: function(value) {
          var oldValue = originalGetter.call(this);
          if (value !== oldValue) {
            // Stack trace capture
            var stack = new Error().stack;
            console.warn('[VELUNA_ATC_REGRESSION_GUARD] ⚠️ textContent mutation detected on ATC button!', {
              button: {
                id: this.id,
                className: this.className,
                hasDataAtcLabel: !!this.querySelector('[data-atc-label]')
              },
              oldValue: oldValue ? oldValue.substring(0, 50) : '',
              newValue: value ? value.substring(0, 50) : '',
              stack: stack ? stack.split('\n').slice(0, 5).join('\n') : 'No stack'
            });
            console.warn('[VELUNA_ATC_REGRESSION_GUARD] Use setButtonLoadingState() or setButtonTemporaryLabel() instead of button.textContent');
          }
          
          // Still allow the mutation (don't block, just warn)
          originalSetter.call(this, value);
        },
        configurable: true,
        enumerable: true
      });
    }
    
    // Guard buttons when they're found or created
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                // Guard the node itself if it's an ATC button
                guardButtonTextContent(node);
                // Guard any ATC buttons within the node
                if (node.querySelectorAll) {
                  var atcButtons = node.querySelectorAll('[data-veluna-atc], button[type="submit"][id*="add-to-cart"], button[type="submit"][id*="atc"]');
                  Array.from(atcButtons).forEach(guardButtonTextContent);
                }
              }
            });
          }
        });
      });
      
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      } else {
        // Wait for body
        document.addEventListener('DOMContentLoaded', function() {
          if (document.body) {
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
          }
        });
      }
    }
    
    // Guard existing buttons on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        var existingButtons = document.querySelectorAll('[data-veluna-atc], button[type="submit"][id*="add-to-cart"], button[type="submit"][id*="atc"]');
        Array.from(existingButtons).forEach(guardButtonTextContent);
      });
    } else {
      var existingButtons = document.querySelectorAll('[data-veluna-atc], button[type="submit"][id*="add-to-cart"], button[type="submit"][id*="atc"]');
      Array.from(existingButtons).forEach(guardButtonTextContent);
    }
    
    if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
      console.log('[VELUNA_ATC] Regression guard active - will warn on textContent mutations');
    }
  })();
  
  // ============================================================================
  // HELPER: Find first non-empty text node (template-safe)
  // ============================================================================
  function findFirstNonEmptyTextNode(element) {
    if (!element) return null;
    for (var i = 0; i < element.childNodes.length; i++) {
      var node = element.childNodes[i];
      // nodeType 3 = TEXT_NODE, filter whitespace-only nodes
      if (node.nodeType === 3 && node.textContent && node.textContent.trim().length > 0) {
        return node;
      }
    }
    return null;
  }
  
  // ============================================================================
  // HELPER: Capture baseline label once (never overwritten)
  // ============================================================================
  function captureBaselineLabel(button) {
    if (!button || button.dataset.velunaAtcBaselineLabel) return; // Already captured
    
    // PRIORITY 1: Capture from [data-atc-label] if available
    var labelEl = button.querySelector('[data-atc-label]');
    if (labelEl && labelEl.textContent) {
      button.dataset.velunaAtcBaselineLabel = labelEl.textContent.trim();
      return;
    }
    
    // PRIORITY 2: Capture from first non-empty text node
    var firstTextNode = findFirstNonEmptyTextNode(button);
    if (firstTextNode && firstTextNode.textContent) {
      button.dataset.velunaAtcBaselineLabel = firstTextNode.textContent.trim();
      return;
    }
    
    // PRIORITY 3: Capture from button.textContent as fallback
    if (button.textContent) {
      button.dataset.velunaAtcBaselineLabel = button.textContent.trim();
    }
  }
  
  // ============================================================================
  // REMOVED: captureOriginalHTMLIfReady() - No longer needed
  // ============================================================================
  // Controller uses deterministic sub-element updates, not innerHTML restore
  
  // ============================================================================
  // ATC CONTROLLER: Single source of truth for button state and rendering
  // ============================================================================
  // NON-NEGOTIABLE: ONLY this controller may set disabled, aria-busy, loading classes, label/price UI
  // All other files must call controller API; no direct mutations
  var VelunaATCController = (function() {
    'use strict';
    
    // Global mutex: tracks in-flight requests per button (key: variantId + sectionId)
    var inflightRequests = {};
    
    // ============================================================================
    // getButtons() → returns Array.from(document.querySelectorAll('[data-veluna-atc]'))
    // ============================================================================
    function getButtons() {
      return Array.from(document.querySelectorAll('[data-veluna-atc]'));
    }
    
    // ============================================================================
    // normalizeButton(btn) → ensures btn type=button, removes disabled attr if state says ready, removes aria-busy when not loading, strips known stuck classes
    // ============================================================================
    function normalizeButton(btn) {
      if (!btn || btn.nodeType !== 1) return;
      
      // Ensure type=button (not submit, which can cause form submission)
      if (btn.tagName === 'BUTTON' && !btn.type) {
        btn.type = 'button';
      }
      
      // Remove known stuck classes (but preserve legitimate ones)
      btn.classList.remove('is-loading', 'loading', 'disabled', 'btn--loading');
      
      // Note: disabled/aria-busy are managed by setState, not here
    }
    
    // ============================================================================
    // computeState(btn, context) → returns 'ready' | 'loading' | 'locked' | 'error'
    // ============================================================================
    function computeState(btn, context) {
      context = context || {};
      
      if (!btn) return 'error';
      
      // Check for in-flight request (global mutex)
      var variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
      var sectionId = btn.closest('[data-section-id]')?.dataset.sectionId || 'unknown';
      var mutexKey = variantId + '_' + sectionId;
      
      if (inflightRequests[mutexKey]) {
        return 'loading';
      }
      
      // Check for explicit loading indicators
      if (btn.getAttribute('aria-busy') === 'true' || btn.classList.contains('is-loading')) {
        return 'loading';
      }
      
      // Check for locked state (truly not purchasable)
      // - Missing/invalid variant ID
      // - Product unavailable
      // - Explicit locked attribute
      if (btn.hasAttribute('data-veluna-locked') || btn.dataset.velunaLocked === '1') {
        return 'locked';
      }
      
      if (!variantId || variantId === '0' || variantId === '') {
        // No variant selected - but don't lock if we're in a context where variant might be injected
        if (context.allowNoVariant !== true) {
          return 'locked';
        }
      }
      
      // Default: ready
      return 'ready';
    }
    
    // ============================================================================
    // render(btn, {state, labelText, priceText, savingsText}) → updates ONLY sub-elements
    // ============================================================================
    function render(btn, options) {
      if (!btn) return;
      
      options = options || {};
      var state = options.state || 'ready';
      var labelText = options.labelText;
      var priceText = options.priceText;
      var savingsText = options.savingsText;
      
      // PHASE 1 PROOF GAP: Capture button structure BEFORE render
      if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && btn) {
        var beforeLabelSpan = btn.querySelector('[data-atc-label]');
        var beforePriceSpan = btn.querySelector('[data-cta-price]');
        btn.__PROOF_HAD_SPANS_BEFORE_RENDER__ = !!(beforeLabelSpan && beforePriceSpan);
      }
      
      // Update label: [data-atc-label] (canonical) OR .recovery-cream-hero__cta-text (fallback for Recovery Cream)
      if (labelText !== undefined) {
        var labelEl = btn.querySelector('[data-atc-label]') || 
                     btn.querySelector('.recovery-cream-hero__cta-text');
        if (labelEl) {
          labelEl.textContent = labelText;
        } else {
          // Fallback: find first non-empty text node
          var firstTextNode = findFirstNonEmptyTextNode(btn);
          if (firstTextNode) {
            firstTextNode.textContent = labelText;
          }
        }
      }
      
      // Update price: [data-cta-price] (canonical) OR .recovery-cream-hero__cta-price (fallback for Recovery Cream)
      if (priceText !== undefined) {
        var priceEl = btn.querySelector('[data-cta-price]') || 
                     btn.querySelector('.recovery-cream-hero__cta-price');
        if (priceEl) {
          priceEl.textContent = priceText;
        }
      }
      
      // Update savings: [data-atc-savings] (if exists)
      if (savingsText !== undefined) {
        var savingsEl = btn.querySelector('[data-atc-savings]');
        if (savingsEl) {
          savingsEl.textContent = savingsText;
          savingsEl.style.display = savingsText ? '' : 'none';
        }
      }
      
      // NEVER assign btn.innerHTML as a restore mechanism
      
      // PHASE 1 PROOF GAP: Log if render() modifies innerHTML structure
      if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && btn) {
        var afterLabelSpan = btn.querySelector('[data-atc-label]');
        var afterPriceSpan = btn.querySelector('[data-cta-price]');
        // Only log if structure changed (spans added/removed)
        var hadSpansBefore = btn.__PROOF_HAD_SPANS_BEFORE_RENDER__;
        if (hadSpansBefore !== undefined) {
          var hasSpansAfter = !!(afterLabelSpan && afterPriceSpan);
          if (hadSpansBefore !== hasSpansAfter) {
            console.warn('[PROOF_GAP_RENDER] render() changed button structure:', {
              buttonId: btn.id,
              hadSpansBefore: hadSpansBefore,
              hasSpansAfter: hasSpansAfter,
              state: state,
              innerHTMLAfter: btn.innerHTML.substring(0, 120)
            });
          }
        }
      }
      
      // PHASE 1 PROOF GAP: Log if render() modifies innerHTML structure
      if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && btn) {
        var afterLabelSpan = btn.querySelector('[data-atc-label]');
        var afterPriceSpan = btn.querySelector('[data-cta-price]');
        // Only log if structure changed (spans added/removed)
        var hadSpansBefore = btn.__PROOF_HAD_SPANS_BEFORE_RENDER__;
        if (hadSpansBefore !== undefined) {
          var hasSpansAfter = !!(afterLabelSpan && afterPriceSpan);
          if (hadSpansBefore !== hasSpansAfter) {
            console.warn('[PROOF_GAP_RENDER] render() changed button structure:', {
              buttonId: btn.id,
              hadSpansBefore: hadSpansBefore,
              hasSpansAfter: hasSpansAfter,
              state: state,
              innerHTMLAfter: btn.innerHTML.substring(0, 120)
            });
          }
        }
        btn.__PROOF_HAD_SPANS_BEFORE_RENDER__ = !!(afterLabelSpan && afterPriceSpan);
      }
    }
    
    // ============================================================================
    // setState(btn, state, meta) → calls render + applies attrs/classes for that state
    // ============================================================================
    function setState(btn, state, meta) {
      if (!btn) return;
      
      meta = meta || {};
      state = state || 'ready';
      
      // Normalize button first
      normalizeButton(btn);
      
      // Apply state-specific attributes and classes
      if (state === 'loading') {
        btn.setAttribute('aria-busy', 'true');
        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.removeAttribute('disabled'); // Remove attribute, but keep disabled property
        // Actually, we want the disabled attribute too for accessibility
        btn.setAttribute('disabled', 'disabled');
        
        // Track in-flight request
        var variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
        var sectionId = btn.closest('[data-section-id]')?.dataset.sectionId || 'unknown';
        var mutexKey = variantId + '_' + sectionId;
        inflightRequests[mutexKey] = true;
        
        // Render loading label
        render(btn, {
          state: state,
          labelText: meta.labelText || 'Adding...'
        });
      } else if (state === 'ready') {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.removeAttribute('disabled');
        
        // Clear in-flight request
        var variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
        var sectionId = btn.closest('[data-section-id]')?.dataset.sectionId || 'unknown';
        var mutexKey = variantId + '_' + sectionId;
        delete inflightRequests[mutexKey];
        
        // Render ready label (restore baseline if available)
        var baselineLabel = btn.dataset.velunaAtcBaselineLabel || 'Add to Cart';
        render(btn, {
          state: state,
          labelText: meta.labelText || baselineLabel,
          priceText: meta.priceText,
          savingsText: meta.savingsText
        });
      } else if (state === 'locked') {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
        btn.disabled = true;
        btn.setAttribute('disabled', 'disabled');
        
        render(btn, {
          state: state,
          labelText: meta.labelText || 'Not Available'
        });
      } else if (state === 'error') {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.removeAttribute('disabled');
        
        render(btn, {
          state: state,
          labelText: meta.labelText || 'Error - Try Again'
        });
      }
    }
    
    // ============================================================================
    // clearInflight(btn) → clears in-flight request for button
    // ============================================================================
    function clearInflight(btn) {
      if (!btn) return;
      var variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
      var sectionId = btn.closest('[data-section-id]')?.dataset.sectionId || 'unknown';
      var mutexKey = variantId + '_' + sectionId;
      delete inflightRequests[mutexKey];
    }
    
    // Public API
    return {
      getButtons: getButtons,
      normalizeButton: normalizeButton,
      computeState: computeState,
      render: render,
      setState: setState,
      clearInflight: clearInflight
    };
  })();
  
  // ============================================================================
  // DEBUG-GATED LIFECYCLE INSTRUMENTATION: Emit structured log per lifecycle event
  // ============================================================================
  function emitLifecycleLog(event, context) {
    if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
      return; // Only log in debug mode
    }
    
    var inDesignMode = window.Shopify && window.Shopify.designMode === true;
    var topEqWindow = window.top === window;
    var href = window.location.href;
    var atcButtons = VelunaATCController.getButtons();
    var atcCount = atcButtons.length;
    
    var atcButtonData = atcButtons.map(function(btn) {
      var rect = btn.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;
      var el = document.elementFromPoint(centerX, centerY);
      var computedStyle = window.getComputedStyle(btn);
      
      return {
        id: btn.id || null,
        className: btn.className || null,
        disabled: btn.disabled,
        ariaBusy: btn.getAttribute('aria-busy'),
        loading: btn.classList.contains('is-loading'),
        pointerEvents: computedStyle.pointerEvents,
        zIndex: computedStyle.zIndex,
        elementAtPointOk: el === btn || (el && btn.contains(el))
      };
    });
    
    var log = {
      event: event,
      frame: {
        topEqWindow: topEqWindow,
        inDesignMode: inDesignMode,
        href: href
      },
      atcCount: atcCount,
      atcButtons: atcButtonData,
      context: context || {}
    };
    
    console.log('[VELUNA_ATC_LIFECYCLE]', JSON.stringify(log, null, 2));
  }
  
  // ============================================================================
  // IDEMPOTENT ENTRY POINT: Ensure ATC buttons are ready (DOM-resilient)
  // ============================================================================
  // Single authoritative function to ensure all ATC buttons are enabled and ready
  // Always queries fresh buttons - never uses cached references
  // Safe to call repeatedly (idempotent)
  // Uses ATC Controller as single source of truth
  function ensureATCReady(reason) {
    reason = reason || 'unknown';
    var allAtcButtons = VelunaATCController.getButtons();
    var count = allAtcButtons.length;
    
    if (count === 0) {
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] ensureATCReady: No ATC buttons found', { reason: reason });
      }
      return count;
    }
    
    Array.from(allAtcButtons).forEach(function(btn) {
      // Normalize button (removes stuck classes, ensures proper type)
      VelunaATCController.normalizeButton(btn);
      
      // Compute current state
      var currentState = VelunaATCController.computeState(btn, { allowNoVariant: true });
      
      // If not loading and should be ready, force ready state WITH baseline label
      if (currentState !== 'loading' && currentState !== 'locked') {
        var baselineLabel = btn.dataset.velunaAtcBaselineLabel || 'Add to Cart';
        VelunaATCController.setState(btn, 'ready', { labelText: baselineLabel });
      }
    });
    
    if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
      console.log('[VELUNA_ATC] ensureATCReady: Ensured', count, 'button(s) ready', { reason: reason });
    }
    
    // Emit lifecycle log (debug-gated)
    var eventName = reason.split('-')[0] || reason;
    emitLifecycleLog(eventName, { reason: reason });
    
    return count;
  }
  
  // ============================================================================
  // HELPER: Unlock all current ATC buttons (DOM-resilient)
  // ============================================================================
  // Always queries fresh buttons - never uses cached references
  // Used by drawer close and Theme Editor section rerender hooks
  // Calls ensureATCReady() as part of full unlock
  function unlockAllCurrentATCButtons(reason) {
    reason = reason || 'unknown';
    
    // First ensure buttons are ready (lightweight, idempotent)
    ensureATCReady(reason);
    
    // Then perform full unlock if unlockATCButton is available
    var allAtcButtons = document.querySelectorAll('[data-veluna-atc]');
    var count = allAtcButtons.length;
    
    if (count === 0) {
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] unlockAllCurrentATCButtons: No ATC buttons found', { reason: reason });
      }
      return count;
    }
    
    Array.from(allAtcButtons).forEach(function(btn) {
      if (window.VelunaAddToCart && typeof window.VelunaAddToCart.unlockATCButton === 'function') {
        window.VelunaAddToCart.unlockATCButton(btn, reason);
      }
    });
    
    if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
      console.log('[VELUNA_ATC] unlockAllCurrentATCButtons: Unlocked', count, 'button(s)', { reason: reason });
    }
    
    return count;
  }
  
  // ============================================================================
  // AUTHORITATIVE UNLOCK FUNCTION: Unlock ATC button after drawer close
  // ============================================================================
  // Single source of truth for unlocking ATC buttons
  // Ensures button is always enabled after drawer close unless there's a real in-flight add
  function unlockATCButton(button, reason) {
    if (!button) return;
    
    reason = reason || 'unknown';
    
    // Check if there's a real in-flight add request
    var hasRealInflight = button.dataset.velunaInflight === '1' && 
                          button.dataset.velunaInflightAt &&
                          (Date.now() - parseInt(button.dataset.velunaInflightAt, 10)) < 10000; // 10 second timeout
    
    // If there's a real in-flight request, don't unlock (let the request complete)
    if (hasRealInflight) {
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] unlockATCButton: Skipping unlock - real in-flight request detected', {
          button: button.id,
          reason: reason,
          inflightAt: button.dataset.velunaInflightAt
        });
      }
      return;
    }
    
    // Clear all disabled/locking state
    button.disabled = false;
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('aria-busy');
    button.removeAttribute('inert');
    button.removeAttribute('aria-hidden');
    
    // Remove loading classes
    button.classList.remove('is-loading', 'loading', 'disabled', 'btn--loading');
    
    // Clear inline styles that might block interaction
    button.style.opacity = '';
    button.style.cursor = '';
    button.style.pointerEvents = '';
    button.style.zIndex = '';
    button.style.position = '';
    button.style.visibility = '';
    button.style.display = '';
    
    // Clear locking dataset attributes
    delete button.dataset.velunaInflight;
    delete button.dataset.velunaInflightAt;
    delete button.dataset.velunaInflightNonce;
    delete button.dataset.velunaAtcHandled;
    delete button.__velunaInflightPromise;
    
    // Reset temporary label to baseline
    if (typeof resetButtonTemporaryLabel === 'function') {
      resetButtonTemporaryLabel(button);
    }
    
    // Ensure form is not blocking
    var productForm = button.closest('form');
    if (productForm) {
      productForm.style.pointerEvents = '';
      productForm.style.zIndex = '';
    }
    
    if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
      console.log('[VELUNA_ATC] unlockATCButton: Button unlocked', {
        button: button.id,
        reason: reason,
        disabled: button.disabled,
        hasDisabledAttr: button.hasAttribute('disabled'),
        ariaBusy: button.getAttribute('aria-busy'),
        hasLoadingClass: button.classList.contains('is-loading')
      });
    }
  }
  
  // ============================================================================
  // BUTTON STATE HELPER: Template-safe loading state (uses ATC Controller)
  // ============================================================================
  // DEPRECATED: Use VelunaATCController.setState() directly
  // Kept for backward compatibility during migration
  function setButtonLoadingState(button, isLoading) {
    if (!button) return;
    
    // Capture baseline label once (never overwritten)
    captureBaselineLabel(button);
    
    // Use controller to set state
    if (isLoading) {
      VelunaATCController.setState(button, 'loading', {
        labelText: 'Adding...'
      });
    } else {
      // Restore to ready state
      var baselineLabel = button.dataset.velunaAtcBaselineLabel || 'Add to Cart';
      VelunaATCController.setState(button, 'ready', {
        labelText: baselineLabel
      });
    }
  }
  
  // ============================================================================
  // TEMPORARY LABEL STATE HELPER: Set temporary label (Added!, In Cart, etc.)
  // ============================================================================
  // Ensures temporary states are reset on drawer close, variant change, etc.
  // NEVER overwrites baseline label - uses baseline for restore
  function setButtonTemporaryLabel(button, temporaryText, resetAfterMs) {
    if (!button) return;
    
    // Ensure baseline is captured (never overwrite it)
    captureBaselineLabel(button);
    
    // Store that we're in a temporary state
    button.dataset.velunaTemporaryLabel = '1';
    
    // PRIORITY 1: Use [data-atc-label] if available
    var labelEl = button.querySelector('[data-atc-label]');
    if (labelEl) {
      labelEl.textContent = temporaryText;
    } else {
      // PRIORITY 2: Find first non-empty text node (filters whitespace)
      var firstTextNode = findFirstNonEmptyTextNode(button);
      if (firstTextNode) {
        firstTextNode.textContent = temporaryText;
      }
    }
    
    // Auto-reset after delay if specified
    if (resetAfterMs && resetAfterMs > 0) {
      setTimeout(function() {
        resetButtonTemporaryLabel(button);
      }, resetAfterMs);
    }
  }
  
  // ============================================================================
  // RESET TEMPORARY LABEL: Restore baseline label state deterministically
  // ============================================================================
  function resetButtonTemporaryLabel(button) {
    if (!button) return;
    
    delete button.dataset.velunaTemporaryLabel;
    
    // Always restore from baseline (never overwritten, captured once)
    if (!button.dataset.velunaAtcBaselineLabel) {
      captureBaselineLabel(button);
    }
    
    // PRIORITY 1: Restore [data-atc-label] from baseline
    var labelEl = button.querySelector('[data-atc-label]');
    if (labelEl && button.dataset.velunaAtcBaselineLabel) {
      labelEl.textContent = button.dataset.velunaAtcBaselineLabel;
    } else {
      // PRIORITY 2: Restore first non-empty text node from baseline
      var firstTextNode = findFirstNonEmptyTextNode(button);
      if (firstTextNode && button.dataset.velunaAtcBaselineLabel) {
        firstTextNode.textContent = button.dataset.velunaAtcBaselineLabel;
      }
    }
    
    // Also ensure loading state is cleared
    button.removeAttribute('aria-busy');
    button.classList.remove('is-loading');
  }
  
  // ============================================================================
  // DEBUG LOGGING: Capture button state at key checkpoints (gated by debug flag)
  // ============================================================================
  function logButtonState(checkpoint, button) {
    if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) return;
    if (!button) {
      console.log('[VELUNA_ATC_DEBUG]', checkpoint, 'button not found');
      return;
    }
    
    var rect = button.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var centerY = rect.top + rect.height / 2;
    var elementAtPoint = document.elementFromPoint(centerX, centerY);
    var computedStyle = window.getComputedStyle(button);
    
    var drawer = document.querySelector('[data-cart-drawer]');
    var backdrop = drawer ? drawer.querySelector('.veluna-cart-drawer__backdrop, [data-veluna-cart-overlay]') : null;
    
    console.log('[VELUNA_ATC_DEBUG]', checkpoint, {
      button: {
        id: button.id,
        disabled: button.disabled,
        ariaDisabled: button.getAttribute('aria-disabled'),
        ariaBusy: button.getAttribute('aria-busy'),
        classList: Array.from(button.classList),
        inlineStyle: {
          pointerEvents: button.style.pointerEvents,
          opacity: button.style.opacity,
          cursor: button.style.cursor
        },
        computedStyle: {
          pointerEvents: computedStyle.pointerEvents,
          opacity: computedStyle.opacity,
          zIndex: computedStyle.zIndex
        },
        innerHTML: button.innerHTML.substring(0, 100),
        hasLabelSpan: !!button.querySelector('[data-atc-label]')
      },
      overlay: {
        drawerExists: !!drawer,
        backdropExists: !!backdrop,
        backdropPointerEvents: backdrop ? window.getComputedStyle(backdrop).pointerEvents : null,
        backdropZIndex: backdrop ? window.getComputedStyle(backdrop).zIndex : null
      },
      elementAtPoint: {
        tagName: elementAtPoint ? elementAtPoint.tagName : null,
        id: elementAtPoint ? elementAtPoint.id : null,
        className: elementAtPoint ? elementAtPoint.className : null,
        isButton: elementAtPoint === button,
        isButtonChild: elementAtPoint ? button.contains(elementAtPoint) : false
      }
    });
  }
  
  // Tile 8: Helper to sync UI state for all buttons tied to a variant
  function syncVariantButtonState(variantId, state) {
    // state: 'inflight' | 'restore'
    if (!variantId) return;
    
    var variantIdStr = String(variantId);
    
    // Find all buttons that add this variant
    var buttons = [];
    
    // PDP cross-sell buttons
    var crossSellButtons = document.querySelectorAll('.recovery-cream-hero__cross-sell-button[data-variant-id="' + variantIdStr + '"]');
    buttons = buttons.concat(Array.from(crossSellButtons));
    
    // Drawer upsell buttons
    var upsellButtons = document.querySelectorAll('[data-upsell-add="' + variantIdStr + '"]');
    buttons = buttons.concat(Array.from(upsellButtons));
    
    // Main ATC button (if variant matches)
    var mainAtcButton = document.querySelector('#recovery-cream-add-to-cart[data-variant-id="' + variantIdStr + '"]');
    if (mainAtcButton) buttons.push(mainAtcButton);
    
    // Other Veluna ATC buttons with matching variant
    var otherAtcButtons = document.querySelectorAll('[data-veluna-atc][data-variant-id="' + variantIdStr + '"]');
    buttons = buttons.concat(Array.from(otherAtcButtons));
    
    buttons.forEach(function(btn) {
      if (state === 'inflight') {
        // Apply inflight state using controller
        VelunaATCController.setState(btn, 'loading', {
          labelText: 'Adding...'
        });
        logButtonState('syncVariantButtonState-inflight', btn);
      } else if (state === 'restore') {
        // Restore using controller
        var baselineLabel = btn.dataset.velunaAtcBaselineLabel || 'Add to Cart';
        VelunaATCController.setState(btn, 'ready', {
          labelText: baselineLabel
        });
        logButtonState('syncVariantButtonState-restore', btn);
      }
    });
  }
  
  // Tile 6: Get subscription context from cart (same logic as drawer)
  function getSubscriptionContextFromCart(cart) {
    if (!cart || !cart.items) return null;
    
    // Find Recovery Cream item
    var recoveryCreamItem = cart.items.find(function(item) {
      var handle = item.handle || '';
      var title = item.product_title || '';
      return handle.toLowerCase().includes('recovery-cream') ||
             title.toLowerCase().includes('recovery cream');
    });
    
    if (!recoveryCreamItem) return null;
    
    var properties = recoveryCreamItem.properties || {};
    if (properties._subscription_plan) {
      return {
        plan: properties._subscription_plan,
        frequency: properties._subscription_frequency || '',
        discount: properties._subscription_discount || ''
      };
    }
    
    return null;
  }
  
  // Get subscription payload - returns empty object for one-time, properties object for VelunaSub
  function getSubscriptionPayload(velunasubProperties) {
    if (!velunasubProperties) {
      return {};
    }
    
    var payload = {};
    if (velunasubProperties.plan) {
      payload['properties[_subscription_plan]'] = String(velunasubProperties.plan);
    }
    if (velunasubProperties.frequency) {
      payload['properties[_subscription_frequency]'] = String(velunasubProperties.frequency);
    }
    if (velunasubProperties.discount) {
      payload['properties[_subscription_discount]'] = String(velunasubProperties.discount);
    }
    return payload;
  }
  
  function addToCart(variantId, quantity, velunasubProperties, abortController, options) {
    options = options || {};
    var button = options.button || null;
    
    console.log('[VELUNA_ATC] addToCart() called', { variantId: variantId, quantity: quantity });
    
    // NOTE: Inflight lock check REMOVED - the lock is set by handleAddToCartClick BEFORE
    // calling this function, so checking it here would always block the request.
    // Double-click protection is handled by button.disabled and handleAddToCartClick guards.
    
    // Normalize quantity only - variant ID normalization happens in makeAddToCartRequest()
    var normalizedQuantity = Math.max(1, parseInt(quantity || 1, 10));
    
    // Create the request promise
    var requestPromise = makeAddToCartRequest(variantId, normalizedQuantity, velunasubProperties, abortController, options);
    
    // Store promise for idempotent behavior
    if (button) {
      button.__velunaInflightPromise = requestPromise;
    }
    window.__VELUNA_ATC_PROMISE__ = requestPromise;
    
    // Clear stored promise when done (success or failure)
    var clearPromise = function() {
      if (button) {
        delete button.__velunaInflightPromise;
      }
      window.__VELUNA_ATC_PROMISE__ = null;
    };
    
    // Wrap promise to ensure cleanup on completion
    var wrappedPromise = requestPromise.then(function(result) {
      clearPromise();
      return result;
    }).catch(function(error) {
      clearPromise();
      // IDEMPOTENT: If error is "already in progress" and we have active inflight, suppress it
      var isAlreadyInProgress = error && error.message && 
        (error.message.toLowerCase().includes('already in progress') ||
         error.message.toLowerCase().includes('request already'));
      var hasActiveInflight = window.__VELUNA_ATC_INFLIGHT__ === true ||
                             (button && button.dataset.velunaInflight === '1');
      
      if (isAlreadyInProgress && hasActiveInflight) {
        // Return suppressed success instead of throwing
        if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
          console.log('[VELUNA_ATC] ATC_SUPPRESSED_ALREADY_IN_PROGRESS (promise wrapper)', { hasActiveInflight: true });
        }
        return { success: true, data: null, suppressed: true };
      }
      
      // All other errors - rethrow
      throw error;
    });
    
    return wrappedPromise;
  }
  
  
  // Helper: Detect if response is HTML (Cloudflare challenge or rate limit page)
  function isHTMLResponse(responseOrText) {
    if (typeof responseOrText === 'string') {
      // Check if text starts with HTML doctype or common HTML tags
      var trimmed = responseOrText.trim();
      return trimmed.startsWith('<!DOCTYPE') || 
             trimmed.startsWith('<html') || 
             trimmed.startsWith('<body') ||
             trimmed.toLowerCase().includes('cloudflare') ||
             trimmed.toLowerCase().includes('challenge') ||
             trimmed.toLowerCase().includes('access denied');
    } else if (responseOrText && responseOrText.headers) {
      // Check Content-Type header
      var contentType = responseOrText.headers.get('content-type') || '';
      return contentType.toLowerCase().includes('text/html');
    }
    return false;
  }
  
  // Helper: Minimal rate limiting - ensures minimum time between API requests
  // This prevents Cloudflare challenges from rapid requests without blocking legitimate usage
  var lastRequestTime = 0;
  var minRequestInterval = 500; // 500ms minimum between requests (light throttling)
  
  function waitForMinRequestInterval() {
    // DEBUG BYPASS: Skip rate limiting if flag is set
    if (window.__VELUNA_DEBUG_BYPASS_MUTEX__ === true) {
      console.warn('[VELUNA_RATE_LIMIT] BYPASS active - skipping rate limit');
      return Promise.resolve();
    }
    
    var now = Date.now();
    var timeSinceLastRequest = now - lastRequestTime;
    var waitTime = minRequestInterval - timeSinceLastRequest;
    
    if (waitTime > 0) {
      console.log('[VELUNA_RATE_LIMIT] waiting', waitTime, 'ms');
      return new Promise(function(resolve) {
        setTimeout(function() {
          lastRequestTime = Date.now();
          resolve();
        }, waitTime);
      });
          } else {
      lastRequestTime = now;
      return Promise.resolve();
    }
  }
  
  // Helper: Verify variant availability via product API
  // FAIL-OPEN: Never blocks /cart/add.js - times out after 1s, returns {ok:true} on any failure
  function verifyVariantAvailability(variantId) {
    var VERIFY_TIMEOUT_MS = 1000;
    var result = { ok: true, verified: false, reason: null, timeoutHit: false };
    
    console.log('[VELUNA_ATC][VERIFY] checking variant', variantId);
    
    if (window.__VELUNA_DEBUG_BYPASS_VERIFY__ === true) {
      result.reason = 'BYPASS_FLAG';
      console.warn('[VELUNA_ATC][VERIFY] BYPASS active');
      return Promise.resolve(result);
    }
    
    var pathParts = window.location.pathname.split('/');
    var productHandle = pathParts[pathParts.length - 1].split('?')[0];
    
    if (!productHandle || productHandle === '') {
      result.reason = 'NO_HANDLE';
      console.log('[VELUNA_ATC] VERIFY_FAIL_OPEN', result);
      return Promise.resolve(result);
    }
    
    var controller = new AbortController();
    var timeoutId = setTimeout(function() { controller.abort(); }, VERIFY_TIMEOUT_MS);
    
    // Use locale-aware product URL (supports /en-CA, /fr-CA, etc.)
    var productUrl = velunaGetProductUrl(productHandle);
    console.log('[VELUNA_ATC][DEBUG] Fetching product from locale-aware URL:', productUrl);
    
    return fetch(productUrl, {
      credentials: 'same-origin',
      signal: controller.signal
    })
      .then(function(response) {
      clearTimeout(timeoutId);
        if (!response.ok) {
        result.reason = 'HTTP_' + response.status;
        console.log('[VELUNA_ATC] VERIFY_FAIL_OPEN', result);
        return result;
        }
      return response.json().then(function(product) {
        console.log('[VELUNA_ATC][DEBUG] Product data from AJAX API:', {
          productTitle: product ? product.title : 'null',
          hasVariants: product && product.variants ? product.variants.length : 0,
          variantIds: product && product.variants ? product.variants.map(function(v) { return v.id; }) : [],
          searchingFor: variantId
        });
        
        if (!product || !product.variants || product.variants.length === 0) {
          result.reason = 'NO_VARIANTS';
          console.error('[VELUNA_ATC] VERIFY_FAIL_OPEN: Product has no variants', {
            product: product ? product.title : 'null',
            hasProduct: !!product,
            hasVariants: product && product.variants ? product.variants.length : 0
          });
          return result;
        }
        
        // Try to find variant by ID (exact match first)
        var variant = product.variants.find(function(v) {
          return v.id === variantId || String(v.id) === String(variantId);
        });
        
        // Fallback: if variant not found, use first variant (primary variant)
        if (!variant && product.variants.length > 0) {
          console.warn('[VELUNA_ATC] Variant ID', variantId, 'not found in product variants. Using first variant as fallback.');
          variant = product.variants[0];
          console.log('[VELUNA_ATC] Using fallback variant:', {
            id: variant.id,
            title: variant.title,
            available: variant.available,
            inventory_policy: variant.inventory_policy
          });
        }
        
        if (!variant) {
          result.reason = 'VARIANT_NOT_FOUND';
          console.error('[VELUNA_ATC] VERIFY_FAIL_OPEN: Variant not found and no fallback available', {
            searchingFor: variantId,
            availableVariants: product.variants.map(function(v) { return v.id; })
          });
          return result;
        }
        // DEBUG: Log variant availability data from AJAX API
        console.log('[VELUNA_ATC][DEBUG] Variant data from AJAX API:', {
          variantId: variant.id,
          available: variant.available,
          inventory_policy: variant.inventory_policy,
          inventory_quantity: variant.inventory_quantity,
          willBlock: variant.available === false && variant.inventory_policy === 'deny'
        });
        
        // OVERRIDE GUARD: If inventory_policy is 'continue', ignore available: false from AJAX API
        // The AJAX API may return incorrect availability for certain regions, but if the
        // inventory policy is 'continue', we should allow the purchase regardless of AJAX API's available flag
        // Handle both boolean false and string 'false' values
        var isAvailable = variant.available;
        if (typeof isAvailable === 'string') {
          isAvailable = isAvailable.toLowerCase() !== 'false' && isAvailable !== '0';
        }
        var isAvailableFalse = isAvailable === false || isAvailable === null || isAvailable === undefined;
        var isPolicyDeny = variant.inventory_policy === 'deny';
        var isPolicyContinue = variant.inventory_policy === 'continue';
        
        if (isAvailableFalse && isPolicyDeny) {
          result.ok = false;
          result.verified = true;
          result.reason = 'OUT_OF_STOCK';
          console.log('[VELUNA_ATC][VERIFY] unavailable (policy: deny)', result);
          return result;
        } else if (isAvailableFalse && isPolicyContinue) {
          // FORCE ENABLE: AJAX API says unavailable, but policy is 'continue' - override it
          console.warn('[VELUNA_ATC][OVERRIDE] AJAX API returned available: false, but inventory_policy is "continue" - FORCING ENABLE');
          result.ok = true;
          result.verified = true;
          result.reason = 'VERIFIED_OK_OVERRIDE';
          console.log('[VELUNA_ATC][VERIFY] Override: allowing despite AJAX API saying unavailable (policy: continue)', result);
          return result;
        }
        
        result.verified = true;
        result.reason = 'VERIFIED_OK';
        return result;
      }).catch(function() {
        result.reason = 'JSON_PARSE_FAIL';
        console.log('[VELUNA_ATC] VERIFY_FAIL_OPEN', result);
        return result;
      });
      })
      .catch(function(err) {
      clearTimeout(timeoutId);
      result.timeoutHit = err.name === 'AbortError';
      result.reason = result.timeoutHit ? 'TIMEOUT' : 'FETCH_ERROR';
      console.log('[VELUNA_ATC] VERIFY_FAIL_OPEN', result);
      return result;
      });
  }
  
  // Track network calls for debugging
  var _networkCallCount = 0;
  var _lastNetworkCallTime = 0;
  
  // ============================================================================
  // Get subscription selection from DOM (tolerant with fallbacks)
  // ============================================================================
  function getSubscriptionSelection() {
    // Primary: Try data-velunasub-purchase-type
    var purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
    var purchaseTypeRaw = null;
    var isSubscriptionSelected = false;
    var cadenceSourceSelector = null;
    
    if (purchaseTypeRadio) {
      purchaseTypeRaw = purchaseTypeRadio.value || purchaseTypeRadio.getAttribute('value') || '';
      isSubscriptionSelected = purchaseTypeRaw === 'subscribe';
      cadenceSourceSelector = '[data-velunasub-purchase-type]:checked';
    } else {
      // Fallback: Try other common selectors
      var fallbackSelectors = [
        'input[name="purchase_option"]:checked',
        'input[name="selling_plan"]:checked',
        'input[name="purchaseType"]:checked'
      ];
      
      for (var i = 0; i < fallbackSelectors.length; i++) {
        var el = document.querySelector(fallbackSelectors[i]);
        if (el) {
          purchaseTypeRadio = el;
          purchaseTypeRaw = el.value || el.getAttribute('value') || '';
          cadenceSourceSelector = fallbackSelectors[i];
          
          // Determine subscription if value includes subscribe/subscription OR it's a selling-plan radio
          var valueLower = purchaseTypeRaw.toLowerCase();
          isSubscriptionSelected = valueLower.includes('subscribe') || 
                                   valueLower.includes('subscription') ||
                                   el.name === 'selling_plan';
          break;
        }
      }
    }
    
    // Get cadence - primary selector
    var frequencyInput = document.querySelector('[data-velunasub-frequency-input]');
    var cadenceRaw = '';
    var sellingPlanIdRaw = null;
    
    // CTA_FIX_2026-09-11: the PDP schedule card (recovery-cream-hero.liquid) is rendered from the
    // selected variant's selling_plan_allocations and carries the plan id + cadence. Prefer it over
    // text parsing so the plan sent is exactly the one shown for the variant in the form.
    var scheduleCardRadio = document.querySelector('[data-velunasub-frequency]:checked[data-selling-plan-id]');
    if (scheduleCardRadio && String(scheduleCardRadio.getAttribute('data-selling-plan-id') || '').trim()) {
      sellingPlanIdRaw = String(scheduleCardRadio.getAttribute('data-selling-plan-id')).trim();
      cadenceRaw = String(scheduleCardRadio.getAttribute('data-plan-months') || scheduleCardRadio.value || '').trim();
      cadenceSourceSelector = (cadenceSourceSelector ? cadenceSourceSelector + ' + ' : '') + '[data-velunasub-frequency]:checked[data-selling-plan-id]';
    } else if (frequencyInput) {
      cadenceRaw = (frequencyInput.value || frequencyInput.textContent || '').trim();
      cadenceSourceSelector = cadenceSourceSelector ? cadenceSourceSelector + ' + [data-velunasub-frequency-input]' : '[data-velunasub-frequency-input]';
    } else {
      // Fallback: Try other cadence sources
      var cadenceSelect = document.querySelector('select[name="selling_plan"]');
      if (cadenceSelect && cadenceSelect.selectedOptions && cadenceSelect.selectedOptions[0]) {
        cadenceRaw = (cadenceSelect.selectedOptions[0].text || cadenceSelect.selectedOptions[0].value || '').trim();
        cadenceSourceSelector = 'select[name="selling_plan"]';
        sellingPlanIdRaw = (cadenceSelect.value || '').trim();
      } else {
        var cadenceRadio = document.querySelector('input[name="selling_plan"]:checked');
        if (cadenceRadio) {
          // Try to get label text
          var label = cadenceRadio.closest('label') || document.querySelector('label[for="' + cadenceRadio.id + '"]');
          cadenceRaw = label ? (label.textContent || '').trim() : (cadenceRadio.value || '').trim();
          cadenceSourceSelector = 'input[name="selling_plan"]:checked';
          sellingPlanIdRaw = (cadenceRadio.value || '').trim();
        } else {
          // Last resort: search subscription widget for cadence text
          var subscriptionWidget = document.querySelector('.recovery-cream-hero__velunasub, [data-velunasub-purchase-type]')?.closest('[class*="velunasub"], [class*="subscription"]');
          if (subscriptionWidget) {
            var widgetText = subscriptionWidget.textContent || '';
            // Look for "1 Month", "3 Month", "6 Month" patterns
            var monthMatch = widgetText.match(/(\d+)\s*month/i);
            if (monthMatch) {
              cadenceRaw = monthMatch[1] + ' month';
              cadenceSourceSelector = 'subscription widget text';
            }
          }
        }
      }
    }
    
    // PDP fallback: Treat explicit subscription toggles as subscription intent
    // (Some templates use a checkbox and/or a line-item property instead of a selling_plan picker.)
    try {
      var pdpToggle = document.getElementById('pdp-subscription-toggle');
      if (!isSubscriptionSelected && pdpToggle && pdpToggle.checked) {
        isSubscriptionSelected = true;
        cadenceSourceSelector = cadenceSourceSelector || '#pdp-subscription-toggle:checked';
      }
      var legacyProperty = document.querySelector('input[name="properties[subscription]"]');
      if (!isSubscriptionSelected && legacyProperty && String(legacyProperty.value || '').toLowerCase() === 'true') {
        isSubscriptionSelected = true;
        cadenceSourceSelector = cadenceSourceSelector || 'input[name="properties[subscription]"]';
      }
    } catch (e) {}

    // Normalize cadence to "1 month" | "3 month" | "6 month" | null
    // Handles both "6 month" text AND bare numeric "6" from frequency-input
    var cadenceNormalized = null;
    if (cadenceRaw) {
      var cadenceLower = cadenceRaw.toLowerCase().replace(/[\s-]/g, '').trim();
      // Bare numeric: '1', '3', '6' from data-velunasub-frequency-input
      if (cadenceLower === '1') {
        cadenceNormalized = '1 month';
      } else if (cadenceLower === '3') {
        cadenceNormalized = '3 month';
      } else if (cadenceLower === '6') {
        cadenceNormalized = '6 month';
      } else if (cadenceLower.includes('1') && (cadenceLower.includes('month') || cadenceLower.includes('monthly'))) {
        cadenceNormalized = '1 month';
      } else if (cadenceLower.includes('3') && (cadenceLower.includes('month') || cadenceLower.includes('quarter'))) {
        cadenceNormalized = '3 month';
      } else if (cadenceLower.includes('6') && (cadenceLower.includes('month') || cadenceLower.includes('semi'))) {
        cadenceNormalized = '6 month';
      }
    }

    // If the DOM provides an explicit selling_plan id, prefer it.
    var sellingPlanId = null;
    try {
      if (sellingPlanIdRaw && String(sellingPlanIdRaw).trim()) {
        var sp = parseInt(String(sellingPlanIdRaw).trim(), 10);
        if (sp && !Number.isNaN(sp)) sellingPlanId = String(sp);
      }
    } catch (e) {}
    
    return {
      isSubscriptionSelected: isSubscriptionSelected,
      cadence: cadenceNormalized || cadenceRaw,
      purchaseTypeRaw: purchaseTypeRaw,
      cadenceRaw: cadenceRaw,
      cadenceNormalized: cadenceNormalized,
      cadenceSourceSelector: cadenceSourceSelector,
      sellingPlanId: sellingPlanId
    };
  }

  // ==========================================================================
  // Product JSON helpers (cache + prepay variant override)
  // ==========================================================================
  var __VELUNA_PRODUCT_JSON_CACHE__ = window.__VELUNA_PRODUCT_JSON_CACHE__ || {};
  window.__VELUNA_PRODUCT_JSON_CACHE__ = __VELUNA_PRODUCT_JSON_CACHE__;

  function fetchProductJsonCached(productHandle) {
    if (!productHandle) return Promise.resolve(null);
    var key = String(productHandle).trim().toLowerCase();
    if (!key) return Promise.resolve(null);
    if (__VELUNA_PRODUCT_JSON_CACHE__[key]) return __VELUNA_PRODUCT_JSON_CACHE__[key];

    var productUrl = velunaGetProductUrl(key);
    __VELUNA_PRODUCT_JSON_CACHE__[key] = fetch(productUrl, { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function() { return null; });

    return __VELUNA_PRODUCT_JSON_CACHE__[key];
  }

  function isBundleSetHandle(productHandle) {
    if (!productHandle) return false;
    var s = String(productHandle).toLowerCase();
    return s.indexOf('ritual-set') !== -1 || s.indexOf('starter-set') !== -1 || s.indexOf('booster-set') !== -1 || s.indexOf('starter-pack') !== -1 || s.indexOf('booster-pack') !== -1 || s.indexOf('stater-set') !== -1 || s.indexOf('booster-pack-cycle') !== -1;
  }

  function parseMonthsFromText(text) {
    var t = String(text || '').toLowerCase();
    if (t.indexOf('6 month') !== -1) return 6;
    if (t.indexOf('3 month') !== -1) return 3;
    if (t.indexOf('1 month') !== -1) return 1;
    if (t.indexOf('month delivery') !== -1) {
      var m = t.match(/(\d+)\s*month\s*delivery/);
      if (m && m[1]) {
        var n = parseInt(m[1], 10);
        if (n === 1 || n === 3 || n === 6) return n;
      }
    }
    /* Shopify Subscriptions labels the 1-month option "Deliver every month" -
       no digit - so none of the checks above can match it. */
    if (/every\s+month\b/.test(t)) return 1;
    return null;
  }

  function cadenceFromMonths(months) {
    if (months === 1) return '1 month';
    if (months === 3) return '3 month';
    if (months === 6) return '6 month';
    return null;
  }

  function findBaseVariantIdFromProductJson(productJson) {
    var variants = productJson && Array.isArray(productJson.variants) ? productJson.variants : [];
    if (!variants.length) return null;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var title = (v && v.title ? String(v.title) : '').toLowerCase().trim();
      if (title.indexOf('1 month delivery') !== -1 || title === '1 jar') {
        return v.id;
      }
    }

    return variants[0].id;
  }

  function findVariantTitleById(productJson, variantId) {
    var variants = productJson && Array.isArray(productJson.variants) ? productJson.variants : [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var vId = v && (v.id || v.variant_id);
      if (String(vId) === String(variantId)) {
        return v && v.title ? String(v.title) : '';
      }
    }
    return '';
  }

  // Bundle ritual/tier -> component product handles (shippable SKUs)
  var BUNDLE_COMPONENT_HANDLES = {
    circadian_reset: {
      starter: ['magnesium-glycinate', 'sleep-formula'],
      booster: ['ayurvedic-complex', 'sleep-formula'],
      full: ['ayurvedic-complex', 'magnesium-glycinate', 'sleep-formula', 'sleep-strips']
    },
    mind_calm: {
      starter: ['ashwagandha', 'magnesium-glycinate'],
      booster: ['sleep-formula', 'sleep-strips'],
      full: ['ashwagandha', 'magnesium-glycinate', 'sleep-formula', 'sleep-strips']
    },
    deep_restore: {
      starter: ['magnesium-glycinate', 'vs1-recovery-cream'],
      booster: ['sleep-formula', 'grass-fed-collagen-peptides-powder-chocolate'],
      full: ['magnesium-glycinate', 'sleep-formula', 'grass-fed-collagen-peptides-powder-chocolate', 'vs1-recovery-cream']
    },
    sacred_soothe: {
      starter: ['hyaluronic-acid-serum', 'sleep-plus-collagen-cream'],
      booster: ['ashwagandha', 'grass-fed-collagen-peptides-powder-chocolate'],
      full: ['ashwagandha', 'sleep-formula', 'grass-fed-collagen-peptides-powder-chocolate', 'hyaluronic-acid-serum']
    }
  };

  function getComponentHandlesForBundle(ritualType, ritualTier) {
    var type = String(ritualType || '').trim().toLowerCase();
    var tier = String(ritualTier || '').trim().toLowerCase();
    if (!type || !tier) return null;
    type = type.replace(/-/g, '_');
    var byTier = BUNDLE_COMPONENT_HANDLES[type];
    if (!byTier) return null;
    return byTier[tier] || null;
  }
  
  // ============================================================================
  // Resolve selling_plan ID from product JSON for subscription purchases
  // ============================================================================
  function resolveSellingPlanId(params) {
    var productHandle = params.productHandle;
    var variantId = params.variantId;
    var cadence = params.cadence || '';
    
    if (!productHandle || !variantId) {
      console.warn('[VELUNA_ATC] Cannot resolve selling_plan: missing productHandle or variantId');
      return Promise.resolve(null);
    }
    
    return fetchProductJsonCached(productHandle)
      .then(function(product) {
        if (!product || !product.selling_plan_groups || !Array.isArray(product.selling_plan_groups)) {
          console.warn('[VELUNA_ATC] Product has no selling_plan_groups');
          return null;
        }
        
        // Shopify product.js does NOT include plan->variant applicability.
        // The authoritative mapping is variant.selling_plan_allocations.
        var variants = product.variants && Array.isArray(product.variants) ? product.variants : [];
        var selectedVariant = null;
        for (var vi = 0; vi < variants.length; vi++) {
          if (String(variants[vi].id) === String(variantId)) {
            selectedVariant = variants[vi];
            break;
          }
        }

        if (!selectedVariant) {
          console.warn('[VELUNA_ATC] Variant not found in product JSON:', variantId);
          return null;
        }

        var allocations = selectedVariant.selling_plan_allocations && Array.isArray(selectedVariant.selling_plan_allocations)
          ? selectedVariant.selling_plan_allocations
          : [];

        if (!allocations.length) {
          console.warn('[VELUNA_ATC] Variant has no selling_plan_allocations:', variantId);
          return null;
        }

        // Build planId -> plan metadata map from selling_plan_groups
        var planById = {};
        for (var gi = 0; gi < product.selling_plan_groups.length; gi++) {
          var group = product.selling_plan_groups[gi];
          var plans = group && group.selling_plans && Array.isArray(group.selling_plans) ? group.selling_plans : [];
          for (var pj = 0; pj < plans.length; pj++) {
            var pl = plans[pj];
            if (pl && pl.id != null) {
              planById[String(pl.id)] = { plan: pl, groupName: group ? group.name : '' };
            }
          }
        }

        // Candidate plans are the allocation selling_plan_ids for this variant
        var candidates = [];
        for (var ai = 0; ai < allocations.length; ai++) {
          var alloc = allocations[ai];
          if (!alloc || alloc.selling_plan_id == null) continue;
          var spid = String(alloc.selling_plan_id);
          var meta = planById[spid];
          var planObj = meta && meta.plan ? meta.plan : null;

          var optionsText = '';
          if (planObj && planObj.options && Array.isArray(planObj.options)) {
            optionsText = planObj.options.map(function(opt) {
              return (opt.name || '') + ' ' + (opt.value || '');
            }).join(' ').toLowerCase();
          }

          var planName = (planObj && planObj.name ? String(planObj.name) : '').toLowerCase().trim();
          var planDescription = (planObj && planObj.description ? String(planObj.description) : '').toLowerCase().trim();
          var planText = (planName + ' ' + planDescription + ' ' + optionsText).trim();

          candidates.push({
            id: Number(alloc.selling_plan_id),
            groupName: meta ? meta.groupName : '',
            name: planObj && planObj.name ? planObj.name : String(alloc.selling_plan_id),
            optionsText: optionsText,
            planText: planText
          });
        }
        
        if (candidates.length === 0) {
          console.warn('[VELUNA_ATC] No selling_plans found for variant:', variantId);
          return null;
        }
        
        function monthsFromText(raw) {
          var t = String(raw || '').toLowerCase();
          var m = t.match(/(\d+)\s*month/);
          if (m && m[1]) {
            var n = parseInt(m[1], 10);
            if (n === 1 || n === 3 || n === 6) return n;
          }
          /* "Deliver every month" (Shopify Subscriptions) carries no digit. */
          if (/every\s+month\b/.test(t)) return 1;
          if (t.includes('monthly')) return 1;
          if (t.includes('quarter')) return 3;
          if (t.includes('semi') || t.includes('biannual')) return 6;
          // Days-based wording
          if (t.includes('30') && t.includes('day')) return 1;
          if (t.includes('90') && t.includes('day')) return 3;
          if (t.includes('180') && t.includes('day')) return 6;
          return null;
        }

        // Match cadence deterministically
        var matchedCandidate = null;
        var usedFallback = false;

        // Prefer exact months match when possible
        var desiredMonths = monthsFromText(cadence);
        if (desiredMonths) {
          for (var cm = 0; cm < candidates.length; cm++) {
            var candM = candidates[cm];
            var candMonths = monthsFromText(candM.planText);
            if (candMonths === desiredMonths) {
              matchedCandidate = candM;
              break;
            }
          }
        }
        
        if (!matchedCandidate && cadence === '1 month') {
          // Match: plan text contains "1" and "month" OR contains "monthly"
          for (var c1 = 0; c1 < candidates.length; c1++) {
            var cand = candidates[c1];
            if ((cand.planText.includes('1') && cand.planText.includes('month')) || 
                cand.planText.includes('monthly')) {
              matchedCandidate = cand;
              break;
            }
          }
        } else if (!matchedCandidate && cadence === '3 month') {
          // Match: plan text contains "3" and "month" OR contains "quarter"
          for (var c3 = 0; c3 < candidates.length; c3++) {
            var cand3 = candidates[c3];
            if ((cand3.planText.includes('3') && cand3.planText.includes('month')) || 
                cand3.planText.includes('quarter')) {
              matchedCandidate = cand3;
              break;
            }
          }
        } else if (!matchedCandidate && cadence === '6 month') {
          // Match: plan text contains "6" and "month" OR contains "semi"
          for (var c6 = 0; c6 < candidates.length; c6++) {
            var cand6 = candidates[c6];
            if ((cand6.planText.includes('6') && cand6.planText.includes('month')) || 
                cand6.planText.includes('semi')) {
              matchedCandidate = cand6;
              break;
            }
          }
        }
        
        // If no cadence match but subscription selected, fail-open to first candidate
        if (!matchedCandidate && candidates.length > 0) {
          matchedCandidate = candidates[0];
          usedFallback = true;
          console.log('[VELUNA_ATC] SELLING_PLAN_FALLBACK_FIRST', {
            cadence: cadence,
            pickedId: matchedCandidate.id,
            pickedName: matchedCandidate.name,
            groupName: matchedCandidate.groupName
          });
        }
        
        if (matchedCandidate) {
          return {
            id: Number(matchedCandidate.id),
            name: matchedCandidate.name,
            groupName: matchedCandidate.groupName,
            usedFallback: usedFallback
          };
        }
        
        console.warn('[VELUNA_ATC] No matching selling_plan found for variant:', variantId, 'cadence:', cadence);
        return null;
      })
      .catch(function(error) {
        console.warn('[VELUNA_ATC] Error resolving selling_plan:', error.message);
        return null;
      });
  }
  
  function makeAddToCartRequest(variantId, quantity, velunasubProperties, abortController, options) {
    console.log('[VELUNA_ATC] makeAddToCartRequest() ENTRY', { variantId: variantId, quantity: quantity });
    
    options = options || {};
    var allowSuppress = options.allowSuppress || false;
    var button = options.button || null;
    var nonce = options.nonce || null;
    
    // Normalize variant ID FIRST - single source of truth for entire function
    var normalizedVariantId = normalizeVariantId(variantId);
    console.log('[VELUNA_ATC] normalized variantId:', normalizedVariantId);
    
    // HARD ERROR if variant ID is invalid
    if (!normalizedVariantId || isNaN(normalizedVariantId)) {
      console.error('[VELUNA_ATC] FATAL: Invalid variant ID after normalization:', variantId, '->', normalizedVariantId);
      return Promise.reject(new Error('Invalid variant ID: ' + variantId));
    }
    
    if (window.VELUNA_ATC_DEBUG) {
      console.log('[DEBUG] Normalized variant ID:', normalizedVariantId);
    }
    
    // Step 1: Verify variant is available (using normalized ID) - FAIL-OPEN
    console.log('[VELUNA_ATC][7] verify start', { variantId: normalizedVariantId });
    
    // Store inventory_policy from verification step for 422 error handler
    var _inventoryPolicyFromVerify = null;
    
    return verifyVariantAvailability(normalizedVariantId)
      .then(function(verifyResult) {
        console.log('[VELUNA_ATC][8] verify result', { verified: verifyResult.verified, ok: verifyResult.ok, reason: verifyResult.reason, timeoutHit: verifyResult.timeoutHit });
        
        // Store inventory_policy if available in verifyResult
        if (verifyResult && verifyResult.inventory_policy) {
          _inventoryPolicyFromVerify = verifyResult.inventory_policy;
          console.log('[VELUNA_ATC][8] Stored inventory_policy from verify:', _inventoryPolicyFromVerify);
        }
        
        // Only block if explicitly verified as out of stock
        if (verifyResult && verifyResult.ok === false && verifyResult.verified === true) {
          throw new Error('Variant is not available (verified out of stock)');
        }
        
        // Store verifyResult for DISPATCH_ADD log
        var _verifyResult = verifyResult;
        
        // Step 2: Get subscription selection from DOM
        var subscriptionSelection = getSubscriptionSelection();
        var isSubscriptionSelected = subscriptionSelection.isSubscriptionSelected;
        var cadence = subscriptionSelection.cadence;
        var cadenceNormalized = subscriptionSelection.cadenceNormalized;

        // If subscription is selected but cadence is unknown, default to 1 month.
        var inferCadencePromise = Promise.resolve(cadenceNormalized);
        if (isSubscriptionSelected && !cadenceNormalized) {
          // Best-effort: infer cadence from selected variant title on PDPs that don't expose cadence UI
          if (urlHandle) {
            inferCadencePromise = fetchProductJsonCached(urlHandle).then(function(pJson) {
              if (!pJson) return null;
              var selectedTitle = findVariantTitleById(pJson, normalizedVariantId);
              var months = parseMonthsFromText(selectedTitle);
              var inferred = months ? cadenceFromMonths(months) : null;
              return inferred || null;
            });
          }
        }
        
        // Store subscription state for 422 error logging (accessible in error handler)
        var _subscriptionState = {
          isSubscriptionSelected: isSubscriptionSelected,
          cadenceNormalized: cadenceNormalized
        };
        
        // Log selection snapshot before resolving selling_plan
        console.log('[VELUNA_ATC] SUB_SELECTION', {
          purchaseTypeRaw: subscriptionSelection.purchaseTypeRaw,
          isSubscriptionSelected: isSubscriptionSelected,
          cadenceRaw: subscriptionSelection.cadenceRaw,
          cadenceNormalized: cadenceNormalized,
          cadenceSourceSelector: subscriptionSelection.cadenceSourceSelector,
          sellingPlanId: subscriptionSelection.sellingPlanId
        });
        
        // Derive product handle and form context (for PDP + bundle handling)
        var pathParts = window.location.pathname.split('/');
        var urlHandle = pathParts[pathParts.length - 1].split('?')[0];
        var originForm = (options && options.button && options.button.closest) ? (options.button.closest('form[action*="/cart/add"], form')) : null;
        var formHandle = originForm ? (originForm.getAttribute('data-product-handle') || originForm.getAttribute('data-jarvis-product-handle')) : null;
        var productHandle = (formHandle || urlHandle || '').trim();
        var bundleLike = isBundleSetHandle(productHandle);

        // PDP prepay override: If selected variant is a "3/6 Month Delivery" variant, add BASE variant
        // with quantity=months (keeps Supliful fulfillment on base SKU).
        var prepayOverridePromise = Promise.resolve({ months: null, baseVariantId: null });
        if (isSubscriptionSelected && originForm && originForm.id === 'pdp-add-to-cart-form' && productHandle) {
          prepayOverridePromise = fetchProductJsonCached(productHandle).then(function(productJson) {
            if (!productJson) return { months: null, baseVariantId: null };
            var selectedTitle = findVariantTitleById(productJson, normalizedVariantId);
            var months = parseMonthsFromText(selectedTitle);
            if (!months) return { months: null, baseVariantId: null };
            var baseId = findBaseVariantIdFromProductJson(productJson);
            return { months: months, baseVariantId: baseId };
          });
        }

        return inferCadencePromise.then(function(inferredCadence) {
          if (isSubscriptionSelected) {
            cadenceNormalized = inferredCadence || cadenceNormalized || '1 month';
          }

        // DEPRECATED 2025-01-08: Bundle component decomposition removed.
        // All bundle variants now support selling_plan directly.
        // Bundles are added as the parent variant + selling_plan (same as side cart).
        // The old component decomposition code was dead anyway since recovery-cream-hero
        // forms lack data-ritual-type/data-ritual-tier attributes.
        if (false && bundleLike && isSubscriptionSelected) {
          var ritualType = originForm ? (originForm.getAttribute('data-ritual-type') || '') : '';
          var ritualTier = originForm ? (originForm.getAttribute('data-ritual-tier') || '') : '';

          var componentHandles = getComponentHandlesForBundle(ritualType, ritualTier);
          if (!componentHandles || !componentHandles.length) {
            console.warn('[VELUNA_ATC] Bundle subscription selected but missing component mapping', { productHandle: productHandle, ritualType: ritualType, ritualTier: ritualTier });
          } else {
            var monthsFromPdpVariantPromise = Promise.resolve(null);
            if (originForm && originForm.id === 'pdp-add-to-cart-form' && productHandle) {
              monthsFromPdpVariantPromise = fetchProductJsonCached(productHandle).then(function(pJson) {
                if (!pJson) return null;
                var selectedTitle = findVariantTitleById(pJson, normalizedVariantId);
                return parseMonthsFromText(selectedTitle);
              });
            }

            return monthsFromPdpVariantPromise.then(function(monthsFromPdpVariant) {
              // If cadence came from UI text, try parsing numeric months.
              var monthsForBundle = monthsFromPdpVariant || null;
              if (!monthsForBundle && cadenceNormalized) monthsForBundle = parseMonthsFromText(cadenceNormalized);
              if (!monthsForBundle) monthsForBundle = 1;
              var cadenceForBundle = cadenceFromMonths(monthsForBundle) || (monthsForBundle + ' month');

              return Promise.all(componentHandles.map(function(h) {
                return fetchProductJsonCached(h).then(function(pJson) {
                  var baseId = findBaseVariantIdFromProductJson(pJson);
                  if (!baseId) throw new Error('Missing base variant for bundle component: ' + h);
                  return resolveSellingPlanId({ productHandle: h, variantId: baseId, cadence: cadenceForBundle }).then(function(plan) {
                    var planId = plan && plan.id ? Number(plan.id) : null;
                    if (!planId) {
                      throw new Error('Missing selling_plan for bundle component: ' + h + ' cadence=' + cadenceForBundle);
                    }
                    return { id: Number(baseId), quantity: monthsForBundle, selling_plan: planId };
                  });
                });
              }))
                .then(function(items) {
                  return waitForMinRequestInterval().then(function() {
                    return fetch('/cart/add.js', {
                      method: 'POST',
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                      },
                      body: JSON.stringify({ items: items })
                    });
                  });
                })
                .then(function(res) {
                  if (!res.ok) {
                    return res.text().then(function(t) {
                      throw new Error(t || ('Failed to add bundle subscription (HTTP ' + res.status + ')'));
                    });
                  }
                  return res.text().then(function(t) {
                    try { return JSON.parse(t); } catch (e) { return { ok: true, raw: t }; }
                  });
                })
                .then(function(data) {
                  return { success: true, data: data };
                });
            });
          }
        }

        return prepayOverridePromise.then(function(override) {
          if (isSubscriptionSelected && override && override.baseVariantId && override.months) {
            normalizedVariantId = normalizeVariantId(override.baseVariantId);
            quantity = override.months;
            if (isSubscriptionSelected) {
              cadenceNormalized = cadenceFromMonths(override.months) || cadenceNormalized;
            }
          }

          // Step 3: Resolve selling_plan ID if subscription is selected
          var sellingPlanPromise = Promise.resolve(null);
          if (isSubscriptionSelected && subscriptionSelection.sellingPlanId) {
            // CTA_FIX_2026-09-11: verify the DOM plan is an allocation of the variant being added;
            // otherwise resolve from the product JSON instead of sending a mismatched plan.
            sellingPlanPromise = fetchProductJsonCached(productHandle).then(function(pJson) {
              var okPlan = false;
              try {
                var vs = (pJson && Array.isArray(pJson.variants)) ? pJson.variants : [];
                for (var vx = 0; vx < vs.length; vx++) {
                  if (String(vs[vx].id) !== String(normalizedVariantId)) continue;
                  var als = Array.isArray(vs[vx].selling_plan_allocations) ? vs[vx].selling_plan_allocations : [];
                  for (var ax = 0; ax < als.length; ax++) {
                    if (String(als[ax].selling_plan_id) === String(subscriptionSelection.sellingPlanId)) okPlan = true;
                  }
                }
              } catch (e) {}
              if (okPlan || !pJson) return { id: subscriptionSelection.sellingPlanId, source: 'dom' };
              console.warn('[VELUNA_ATC] DOM selling_plan not allocated to variant, resolving from product JSON', {
                domPlan: subscriptionSelection.sellingPlanId, variantId: normalizedVariantId
              });
              return resolveSellingPlanId({ productHandle: productHandle, variantId: normalizedVariantId, cadence: cadenceNormalized || cadence });
            });
          } else if (isSubscriptionSelected && productHandle) {
            sellingPlanPromise = resolveSellingPlanId({
              productHandle: productHandle,
              variantId: normalizedVariantId,
              cadence: cadenceNormalized || cadence
            });
          }

          return sellingPlanPromise.then(function(sellingPlanResult) {
          // Step 4: Build request payload (using normalized variant ID)
          // Use simple format: { id: Number(variantId), quantity: 1, selling_plan: <ID> }
          var payload = {
          id: Number(normalizedVariantId),
          quantity: quantity || 1
        };
        
          // Add selling_plan ONLY if subscription is selected and ID was resolved
          // For one-time purchase: sellingPlanResult is null, so no selling_plan is added
          var sellingPlanId = sellingPlanResult ? sellingPlanResult.id : null;
          var usedFallback = sellingPlanResult ? (sellingPlanResult.usedFallback || false) : false;
          
          if (sellingPlanId) {
            // Ensure selling_plan is a number (will be converted to string in URLSearchParams)
            payload.selling_plan = Number(sellingPlanId);
          }
          
          // Log if subscription selected but selling_plan missing
          if (isSubscriptionSelected && !sellingPlanId) {
            console.warn('[VELUNA_ATC] SELLING_PLAN_MISSING', {
              cadenceNormalized: cadenceNormalized,
              variantId: normalizedVariantId
            });
          }
          
          // NOTE: Never send custom subscription properties - selling_plan handles subscription allocation
          
          // Debug log before POST
          console.log('[VELUNA_ATC] SELLING_PLAN_RESOLVED', {
            isSubscriptionSelected: isSubscriptionSelected,
            cadenceNormalized: cadenceNormalized,
            variantId: normalizedVariantId,
            sellingPlanId: sellingPlanId,
            planName: sellingPlanResult ? sellingPlanResult.name : null,
            groupName: sellingPlanResult ? sellingPlanResult.groupName : null,
            usedFallback: usedFallback
          });
        
        if (window.VELUNA_ATC_DEBUG) {
          console.log('[DEBUG] Payload being sent:', JSON.stringify(payload, null, 2));
        }
        
          // Step 5: Add to cart (with rate limiting and mutex)
          // Use storefront endpoints (Theme Editor compatible)
          var endpoints = velunaGetCartEndpoints();
          console.log('[VELUNA_ATC][9] calling waitForMinRequestInterval');
          
          // Store subscription state and selling plan ID for 422 error logging (accessible in error handler)
          var _requestBodyForError = null;
          var _sellingPlanIdForError = sellingPlanId;
          
          // Note: _inventoryPolicyPromise removed - using hardcoded check for Recovery Cream
          // and stored policy from verification step instead of fetching from API
          
        return waitForMinRequestInterval()
          .then(function() {
            console.log('[VELUNA_ATC][10] rate limit passed, entering mutex');
            // Track network call
            _networkCallCount++;
            _lastNetworkCallTime = Date.now();
            if (window.VELUNA_ATC_DEBUG) {
              console.log('[DEBUG] Network call #' + _networkCallCount + ' to ' + endpoints.addJs);
            }
            
            // Wrap fetch in mutex to serialize cart mutations
            // CRITICAL: Mutex enqueue returns a promise that ALWAYS resolves/rejects
            // Lock release happens in finally block of outer promise chain
            if (window.__VELUNA_DEBUG__ === true) {
              console.log('[VELUNA_ATC_LOCK] Request starting (entering mutex)', {
                variantId: normalizedVariantId,
                timestamp: Date.now()
              });
            }
            return window.__VELUNA_CART_MUTEX__.enqueue(function() {
              console.log('[VELUNA_ATC][11] inside mutex, building request');
              // Build request body using URLSearchParams (more reliable than JSON for Shopify)
              var params = new URLSearchParams();
              params.set('id', String(normalizedVariantId));
              params.set('quantity', String(quantity || 1));
              
              // Add selling_plan if subscription is selected (must be numeric digits)
              if (payload.selling_plan) {
                // Ensure selling_plan is numeric string (Shopify requires integer)
                params.set('selling_plan', String(Number(payload.selling_plan)));
              }
              
              // BUNDLE_CART_FIX_2026-02-24: Add line item properties for one-time bundles
              // These display in cart drawer, checkout, and order confirmation
              if (!payload.selling_plan) {
                var _onetimeRadio = document.querySelector('[data-velunasub-onetime-qty]:checked');
                if (_onetimeRadio) {
                  var _sets = parseInt(_onetimeRadio.value, 10) || 1;
                  params.set('properties[Pack]', _sets + (_sets === 1 ? ' Set' : ' Sets'));
                  params.set('properties[Type]', 'One Time Purchase');
                }
              } else {
                // For subscriptions, add cadence info
                var _cadenceLabel = '';
                var _freqRadio = document.querySelector('[data-velunasub-frequency]:checked');
                if (_freqRadio) {
                  var _freqVal = _freqRadio.value;
                  if (_freqVal === '1' || _freqVal.indexOf('1 month') !== -1) _cadenceLabel = '1 Month';
                  else if (_freqVal === '3' || _freqVal.indexOf('3 month') !== -1) _cadenceLabel = '3 Months';
                  else if (_freqVal === '6' || _freqVal.indexOf('6 month') !== -1) _cadenceLabel = '6 Months';
                }
                if (_cadenceLabel) {
                  params.set('properties[Plan]', 'Subscribe & Save - ' + _cadenceLabel);
                }
              }
              
              var requestBody = params.toString();
              
              // Store request body for 422 error logging
              _requestBodyForError = requestBody;
              var requestHeaders = {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                  'Accept': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
              };
              
              if (window.VELUNA_DEBUG_CART) {
                console.log('[VELUNA_DEBUG_CART] POST request', {
                  url: endpoints.addJs,
                  method: 'POST',
                  body: requestBody,
                  variantId: normalizedVariantId,
                  quantity: quantity || 1
                });
              }
              console.log('[VELUNA_ATC] DISPATCH_ADD', {
                variantId: normalizedVariantId,
                verifyResult: _verifyResult ? _verifyResult.reason : 'unknown',
                bypassVerifyFlag: window.__VELUNA_DEBUG_BYPASS_VERIFY__ === true,
                timeoutHit: _verifyResult ? _verifyResult.timeoutHit : false
              });
              console.log('[VELUNA_ATC] DISPATCHING_ADD_NOW', {
                variantId: normalizedVariantId,
                url: endpoints.addJs,
                qty: quantity || 1,
                sellingPlan: payload.selling_plan || null
              });
              
              return fetch(endpoints.addJs, {
                method: 'POST',
                body: requestBody,
                credentials: 'include',
                signal: abortController ? abortController.signal : undefined,
                headers: requestHeaders
              }).then(function(response) {
                // Clone response so we can read body for diagnostics AND return it
                var clonedRes = response.clone();
                return clonedRes.text().then(function(bodyText) {
                  // LOG ADD_RES with key diagnostics
                  console.log('[VELUNA_ATC] ADD_RES', {
                    status: response.status,
                    redirected: response.redirected,
                    contentType: response.headers.get('content-type') || '',
                    bodySnippet: (bodyText || '').substring(0, 120)
                  });
                  
                  if (window.VELUNA_DEBUG_CART || window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
                    console.log('[VELUNA_DEBUG_CART] POST response', { url: endpoints.addJs, status: response.status, ok: response.ok });
                }
                if (!response.ok) {
                    console.log('[VELUNA_ATC] FETCH_DONE error response:', bodyText.substring(0, 200));
                    return new Response(bodyText, {
                      status: response.status,
                      statusText: response.statusText,
                      headers: response.headers
                  });
                }
                return response;
                });
              }).catch(function(error) {
                if (error.name === 'AbortError') {
                  console.warn('[VELUNA_ATC] FETCH_DONE ABORTED (timeout or manual abort)');
                } else {
                  console.error('[VELUNA_ATC] FETCH_DONE error:', error);
                }
                throw error;
              });
            });
          })
    .then(function(response) {
      // Check for HTML response (Cloudflare challenge or rate limit)
      if (isHTMLResponse(response)) {
        var errorMsg = 'Rate limit or security challenge detected. Please wait a moment and try again.';
        console.warn('⚠️ HTML response detected (likely Cloudflare challenge):', response.status);
        throw new Error(errorMsg);
      }
      
      if (!response.ok) {
        return response.text().then(function(text) {
          // Check if response text is HTML
          if (isHTMLResponse(text)) {
            var errorMsg = 'Rate limit or security challenge detected. Please wait a moment and try again.';
            console.warn('⚠️ HTML response detected in error text (likely Cloudflare challenge)');
            throw new Error(errorMsg);
          }
          
          var error;
          try {
              error = JSON.parse(text);
          } catch (e) {
              error = { message: text, description: text };
            }
            
            var errorMsg = error.description || error.message || 'Failed to add to cart';
            
            // Log 422 errors with subscription context
            if (response.status === 422) {
              console.error('[VELUNA_ATC] ADD_422', {
                bodySent: _requestBodyForError || 'unknown',
                isSubscriptionSelected: _subscriptionState ? _subscriptionState.isSubscriptionSelected : false,
                cadenceNormalized: _subscriptionState ? _subscriptionState.cadenceNormalized : null,
                sellingPlanId: _sellingPlanIdForError,
                errorMessage: errorMsg
              });
              
              // PHASE 3: Generic inventory policy check - no hardcoded variant IDs
              // Check stored policy from verification if available
              var isSoldOutError = errorMsg.toLowerCase().includes('sold out') ||
                                   errorMsg.toLowerCase().includes('out of stock') ||
                                   errorMsg.toLowerCase().includes('unavailable');
              
              if (isSoldOutError) {
                // Check stored policy from verification if available (generic, not variant-specific)
                var storedPolicy = _inventoryPolicyFromVerify;
                var hasContinuePolicy = storedPolicy === 'continue';
                
              if (hasContinuePolicy) {
                console.warn('[VELUNA_ATC][FORCE_ADD] 422 sold out error detected, but inventory_policy is "continue" - FORCING SUCCESS');
                console.warn('[VELUNA_ATC][FORCE_ADD] Variant:', normalizedVariantId, 'storedPolicy:', storedPolicy);
                
                // Bypass the error entirely - force success response
                // Do not retry the API call as it will also fail
                // Include selling_plan if it was in the original request
                var bypassItem = {
                  id: normalizedVariantId,
                  quantity: quantity || 1,
                  properties: {},
                  variant_id: normalizedVariantId
                };
                
                // Add selling_plan if subscription was selected
                if (_sellingPlanIdForError) {
                  bypassItem.selling_plan = _sellingPlanIdForError;
                  console.warn('[VELUNA_ATC][FORCE_ADD] Including selling_plan in bypass data:', _sellingPlanIdForError);
                }
                
                var bypassData = {
                  items: [bypassItem]
                };
                console.warn('[VELUNA_ATC][FORCE_ADD] Bypassing 422 error - returning success data');
                // Return in the same format as successful API response: { success: true, data: ... }
                // This ensures it flows through the success handler correctly
                return Promise.resolve({ success: true, data: bypassData });
              } else {
                // Policy is 'deny' or unknown - throw the original error
                console.error('[VELUNA_ATC][FORCE_ADD] Variant does not have continue policy, throwing error');
                throw new Error(errorMsg);
              }
              }
              
              // If not a sold out error, fall through to normal error handling
            }
            
            // IDEMPOTENT: If error is "already in progress" and we have active inflight lock, treat as success
            // This prevents throwing errors when Shopify detects concurrent requests
            var isAlreadyInProgress = errorMsg.toLowerCase().includes('already in progress') ||
                                     errorMsg.toLowerCase().includes('request already');
            var hasActiveInflight = window.__VELUNA_ATC_INFLIGHT__ === true ||
                                   (button && button.dataset.velunaInflight === '1');
            
            if (isAlreadyInProgress && hasActiveInflight) {
              // We have an active request - Shopify's "already in progress" means our original request is handling it
              // Return success silently (idempotent behavior)
              if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
                console.log('[VELUNA_ATC] ATC_SUPPRESSED_ALREADY_IN_PROGRESS', { variantId: normalizedVariantId, hasActiveInflight: true });
              }
              return { success: true, data: null, suppressed: true };
            }
            
            // All other errors - surface normally
            console.error('❌ Add to cart failed:', errorMsg);
            throw new Error(errorMsg);
          });
        }
        
        // Parse successful response
        return response.text().then(function(text) {
          if (isHTMLResponse(text)) {
            var errorMsg = 'Rate limit or security challenge detected. Please wait a moment and try again.';
            console.warn('⚠️ HTML response detected in success path (unexpected)');
            throw new Error(errorMsg);
          }
          try {
            return JSON.parse(text);
          } catch (e) {
            console.error('⚠️ Failed to parse JSON response:', e);
            throw new Error('Invalid response from server');
          }
        });
      })
      .then(function(data) {
        // Success already logged above with [VELUNA_ATC] add ok
        return { success: true, data: data };
      }); // Close waitForMinRequestInterval chain
        }); // Close sellingPlanId promise
        }); // Close prepay override promise
        }); // Close infer cadence promise
      })
      .catch(function(error) {
        console.error('❌ Error in makeAddToCartRequest:', error);
        throw error;
      });
  }
  
  function proceedWithDirectAdd(variantId, quantity, velunasubProperties) {
    console.log('proceedWithDirectAdd (fallback):', { variantId, quantity, velunasubProperties });
    
    // Delegate to makeAddToCartRequest() - single source of truth for /cart/add.js calls
    // makeAddToCartRequest() handles all response processing, error handling, and returns { success: true, data: ... }
    return makeAddToCartRequest(variantId, quantity || 1, velunasubProperties);
  }
  
  // REMOVED: Old proceedWithDirectAdd() implementation that made its own fetch('/cart/add.js') call
  // All add-to-cart requests now go through makeAddToCartRequest() only
  
  // ============================================================================
  // CLICK HANDLER - ULTRA ROBUST
  // ============================================================================
  
  // Shared button resolver - handles ALL Shopify ATC patterns
  // Covers: PDP forms, collection cards, quick-add modals, custom Veluna buttons
  function resolveAddToCartButton(target) {
    if (!target || typeof target.closest !== 'function') {
      return null;
    }
    
    var debug = window.VELUNA_DEBUG_CART === true;
    var button = null;
    var matchedSelector = null;
    
    // Standard Shopify ATC selectors (order matters - most specific first)
    var selectors = [
      '[data-veluna-atc]',                    // Veluna custom
      // PHASE 3: Removed template-specific selector '#recovery-cream-add-to-cart'
      // Use data-veluna-atc or data-veluna-product-form instead
      '[data-add-to-cart]',                   // Dawn/common pattern
      'button[name="add"]',                   // Standard Shopify
      '[type="submit"][name="add"]',          // Form submit with name
      '.product-form__submit',                // Dawn PDP
      '.quick-add__submit',                   // Quick add modals
      '.shopify-product-form [type="submit"]',// Generic product forms
      // PHASE 3: Removed template-specific selectors for cross-sell
      // Cross-sell buttons should use data-veluna-atc attribute
    ];
    
    for (var i = 0; i < selectors.length; i++) {
      button = target.closest(selectors[i]);
    if (button) {
        matchedSelector = selectors[i];
        break;
      }
    }
    
    // Fallback: Check if inside a cart/add form and find submit button
    if (!button) {
      var form = target.closest('form[action*="/cart/add"], form.product-form, form.shopify-product-form');
      if (form) {
        button = form.querySelector('button[type="submit"], [type="submit"], button[name="add"]');
      if (button) {
          matchedSelector = 'form[action*="/cart/add"] submit';
        }
      }
    }
    
    if (debug && button) {
      var form = button.closest('form');
      console.log('[VELUNA_DEBUG_CART] resolveAddToCartButton matched', {
        selector: matchedSelector,
        buttonId: button.id || '(none)',
        buttonName: button.name || '(none)',
        formAction: form ? form.action : '(no form)'
      });
    }
    
    return button;
  }
  
  // ============================================================================
  // SINGLE ENTRYPOINT: handleAddToCart
  // Handles both click and submit events with proper locking and timeout
  // ============================================================================
  function handleAddToCart({ button, form, event }) {
    // PHASE 3A: Trace entry
    var traceFn = window.__velunaTraceDrawer || function() {};
    try {
      traceFn('atc:submit:enter', {
        buttonId: button ? button.id : null,
        hasForm: !!form,
        formAction: form ? (form.action || null) : null
      });
    } catch(traceErr) {}
    
    // ========================================================================
    // DIAG_START: Log structured diagnostic event on click
    // ========================================================================
    var diagVariantId = null;
    try {
      if (form) {
        var vi = form.querySelector('input[name="id"], select[name="id"]');
        diagVariantId = vi ? vi.value : null;
      }
      if (!diagVariantId && button && button.dataset.variantId) {
        diagVariantId = button.dataset.variantId;
      }
    } catch (e) { /* ignore */ }
    
    console.log('[VELUNA_ATC] DIAG_START', {
      pageUrl: window.location.href,
      hostname: window.location.hostname,
      isTopWindow: window === window.top,
      cookieEnabled: navigator.cookieEnabled,
      variantId: diagVariantId
    });
    
    console.log('[VELUNA_ATC] handleAddToCart() ENTRY', { 
      buttonId: button ? button.id : null,
      formAction: form ? form.action : null 
    });
    
    var debug = window.VELUNA_DEBUG_CART === true;
    
    // Prevent default first
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // Resolve form if not provided - check multiple patterns
    if (!form && button) {
      form = button.closest('form[action*="/cart/add"]') ||
             button.closest('form.product-form') ||
             button.closest('form.shopify-product-form') ||
             button.closest('form') ||
             // PHASE 3: Generic form detection - no template-specific classes
             button.closest('form[action*="/cart/add"]');
    }
    
    // Inflight lock is already checked and set in handleAddToCartClick() - do not check again here
    if (button && button.dataset.velunaInflight === '1') {
      button.dataset.velunaInflightAt = String(Date.now());
    }
    
    // ========================================================================
    // STEP 2: Resolve variant ID (critical - must be valid before API call)
    // ========================================================================
    var variantId = null;
    var variantSource = null;
    
    // Priority 1: input[name="id"] in form (standard Shopify pattern)
    if (form) {
      var variantInput = form.querySelector('input[name="id"], select[name="id"]');
      if (variantInput && variantInput.value) {
        variantId = parseInt(variantInput.value, 10);
        variantSource = 'form input[name="id"]';
      }
    }
    
    // Priority 2: button.dataset.variantId (custom buttons)
    if ((!variantId || isNaN(variantId)) && button && button.dataset.variantId) {
      variantId = parseInt(button.dataset.variantId, 10);
      variantSource = 'button data-variant-id';
    }
    
    // Priority 3: closest parent with data-variant-id
    if ((!variantId || isNaN(variantId)) && button) {
      var parent = button.closest('[data-variant-id]');
      if (parent && parent.dataset.variantId) {
      variantId = parseInt(parent.dataset.variantId, 10);
        variantSource = 'parent data-variant-id';
      }
    }
    
    // Priority 4: form data-variant-id attribute
    if ((!variantId || isNaN(variantId)) && form && form.dataset.variantId) {
      variantId = parseInt(form.dataset.variantId, 10);
      variantSource = 'form data-variant-id';
    }
    
    // Priority 5: global product-variant-id input (page-level fallback)
    if (!variantId || isNaN(variantId)) {
      var globalInput = document.getElementById('product-variant-id');
      if (globalInput && globalInput.value) {
        variantId = parseInt(globalInput.value, 10);
        variantSource = 'global #product-variant-id';
      }
    }
    
    // ========================================================================
    // STEP 2b: Resolve quantity
    // ========================================================================
    var quantity = 1;
    if (form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput && qtyInput.value) {
        quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      }
    }
    
    if (debug) {
      console.log('[VELUNA_DEBUG_CART] resolved variant/quantity', {
        variantId: variantId,
        variantSource: variantSource,
        quantity: quantity,
        formAction: form ? form.action : '(no form)'
      });
    }
    
    // Validate variant ID - MUST clear lock on early return
    if (!variantId || isNaN(variantId)) {
      console.error('[VELUNA_ATC] missing variantId - cannot add to cart');
      // CRITICAL: Clear BOTH global and button locks, nonce, promise, and timestamp on early return
      window.__VELUNA_ATC_INFLIGHT__ = false;
      window.__VELUNA_ATC_INFLIGHT_AT__ = null;
      window.__VELUNA_ATC_INFLIGHT_NONCE__ = null;
      window.__VELUNA_ATC_PROMISE__ = null;
      if (button) {
        delete button.dataset.velunaInflight;
        delete button.dataset.velunaInflightAt;
        delete button.dataset.velunaInflightNonce;
        delete button.__velunaInflightPromise;
        button.disabled = false;
      }
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    
    console.log('[VELUNA_ATC][5] variant resolved', { variantId: variantId, source: variantSource });
    
    // Tile 6: Detect if this is a cross-sell button
    // PHASE 3: Generic cross-sell detection - use data attributes, not template-specific classes
    var isCrossSellButton = button && (
      button.hasAttribute('data-veluna-cross-sell') ||
      button.getAttribute('data-veluna-atc-context') === 'cross-sell' ||
      (form && form.hasAttribute('data-veluna-cross-sell-form'))
    );
    
    // Tile 8: Global variant-level inflight lock check (prevents duplicate adds across all surfaces)
    if (window.__VELUNA_VARIANT_INFLIGHT__ && window.__VELUNA_VARIANT_INFLIGHT__[variantId]) {
      // PHASE 3B B: Trace preflight return
      var traceFn = window.__velunaTraceDrawer || function() {};
      traceFn('atc:preflight:return', {
        reason: 'variant_inflight',
        variantId: variantId
      });
      
      console.log('[VELUNA_ATC] Variant add already in flight for variantId:', variantId);
      // Clear button lock and restore state
      window.__VELUNA_ATC_INFLIGHT__ = false;
      if (button) {
        delete button.dataset.velunaInflight;
        setButtonLoadingState(button, false);
      }
      // Restore UI state for all buttons tied to this variant
      syncVariantButtonState(variantId, 'restore');
      return;
    }
    
    // Tile 8: Set global variant-level inflight lock
    window.__VELUNA_VARIANT_INFLIGHT__[variantId] = true;
    
    // Tile 8: Sync UI state for all buttons tied to this variant
    syncVariantButtonState(variantId, 'inflight');
    console.log('[VELUNA_ATC][6] quantity resolved', { quantity: quantity });
    
    // Generate per-click nonce for tracking (must be generated before request starts)
    var inflightNonce;
    try {
      inflightNonce = crypto.randomUUID();
    } catch(e) {
      inflightNonce = 'nonce-' + String(Math.random()).slice(2) + '-' + String(Date.now());
    }
    if (button) {
      button.dataset.velunaInflightNonce = inflightNonce;
    }
    window.__VELUNA_ATC_INFLIGHT_NONCE__ = inflightNonce;
    
    if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
      console.log('[VELUNA_ATC] ATC_REQUEST_START', { variantId: variantId, nonce: inflightNonce.slice(0, 8) + '...' });
    }
    
    // Store original button state
    var originalDisabled = button ? button.disabled : false;
    
    // Update UI immediately (this prevents double-clicks)
    // CRITICAL: Use controller to set loading state
    if (button) {
      VelunaATCController.setState(button, 'loading', {
        labelText: 'Adding...'
      });
      logButtonState('ATC-click-before-request', button);
    }
    
    // Set up abort controller for timeout (12 seconds)
    var abortController = new AbortController();
    var timeoutId = setTimeout(function() {
      console.warn('[VELUNA_ATC] Request timeout (12s) - aborting fetch');
      abortController.abort();
    }, 12000); // 12 second timeout
    
    
    // WATCHDOG UNLOCK: Fire even if promises never resolve (15 second safety net)
    // NONCE-SAFE: Only unlock if nonce matches (prevents unlocking someone else's request)
    var watchdogTimeoutId = setTimeout(function() {
      var currentNonce = window.__VELUNA_ATC_INFLIGHT_NONCE__;
      var buttonNonce = button ? button.dataset.velunaInflightNonce : null;
      
      // Only unlock if nonces match (this is OUR request that hung)
      if (currentNonce === inflightNonce && buttonNonce === inflightNonce) {
        console.error('[VELUNA_ATC] WATCHDOG UNLOCK: Request exceeded 15s - forcing unlock (nonce=' + inflightNonce.slice(0, 8) + '...)');
        // Force unlock all state
        window.__VELUNA_ATC_INFLIGHT__ = false;
        window.__VELUNA_ATC_INFLIGHT_NONCE__ = null;
        if (button) {
          delete button.dataset.velunaInflight;
          delete button.dataset.velunaInflightAt;
          delete button.dataset.velunaInflightNonce;
          setButtonLoadingState(button, false);
        }
      } else {
        // Nonce mismatch - this is not our request, don't unlock
        console.warn('[VELUNA_ATC] WATCHDOG: Nonce mismatch, skipping unlock (stored=' + (currentNonce ? currentNonce.slice(0, 8) : 'null') + ' vs expected=' + inflightNonce.slice(0, 8) + '...)');
      }
    }, 15000);
    
    // Resolve quantity
    var quantityInput = null;
    if (form) {
      quantityInput = form.querySelector('input[name="quantity"]');
    }
    if (!quantityInput) {
      quantityInput = document.getElementById('product-quantity');
    }
    var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value || '1', 10)) : 1;
    
    // Extract VelunaSub properties if needed (for main product)
    var velunasubProperties = null;
    var velunasubWidget = document.querySelector('.recovery-cream-hero__velunasub, [data-velunasub-purchase-type]');
    if (velunasubWidget) {
      var purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
      if (purchaseTypeRadio && purchaseTypeRadio.value === 'subscribe') {
        var planInput = document.querySelector('[data-velunasub-plan]');
        var frequencyInput = document.querySelector('[data-velunasub-frequency-input]');
        var discountInput = document.querySelector('[data-velunasub-discount]');
        
        velunasubProperties = {};
        if (planInput && planInput.value) velunasubProperties.plan = planInput.value;
        if (frequencyInput && frequencyInput.value) velunasubProperties.frequency = frequencyInput.value;
        if (discountInput && discountInput.value) velunasubProperties.discount = discountInput.value;
      }
    }
    
    console.log('[VELUNA_ATC][7] passed all guards, about to create addToCartPromise');
    
    // PHASE 3B B: Trace preflight pass (network call about to be initiated)
    var traceFn = window.__velunaTraceDrawer || function() {};
    traceFn('atc:preflight:pass', {
      variantId: variantId,
      quantity: quantity,
      isCrossSell: isCrossSellButton
    });
    
    // Clear drawer suppression - user is explicitly adding to cart
    window.__velunaDrawerClosedAt = 0;
    
    if (window.__VELUNA_DEBUG_ATC__) {
      console.log('[VELUNA_ATC_DEBUG] Initiating /cart/add.js request', { variantId: variantId, quantity: quantity });
    }
    
    // Tile 6: For cross-sells, derive subscription context from cart before adding
    // Wrap add-to-cart in promise chain to handle async subscription context fetch
    var addToCartPromise;
    var cartEndpoints = velunaGetCartEndpoints();
    // PHASE 2: Store cart from dedupe check for drawer opening (intent-based)
    // This allows drawer to open even when add is blocked by dedupe
    var dedupeCart = null;
    if (isCrossSellButton) {
      // First, check cart for dedupe AND get subscription context
      addToCartPromise = velunaFetchJson(cartEndpoints.cartJs)
      .then(function(cart) {
        // PHASE 2: Store cart for potential drawer opening (even if dedupe blocks add)
        dedupeCart = cart;
        // Tile 6: Cart dedupe check
        var cartVariantIds = (cart.items || []).map(function(item) {
          return item.variant_id || null;
        }).filter(function(id) { return id !== null; });
        
        var cartProductIds = (cart.items || []).map(function(item) {
          return item.product_id || null;
        }).filter(function(id) { return id !== null; });
        
        // Tile 6: ProductId-safe dedupe - derive productId reliably
        var crossSellProductId = null;
        if (button) {
          crossSellProductId = button.dataset.productId || button.getAttribute('data-product-id');
        }
        if (!crossSellProductId && form) {
          crossSellProductId = form.dataset.productId || form.getAttribute('data-product-id');
        }
        crossSellProductId = crossSellProductId ? Number(crossSellProductId) : null;
        
        // Check if variant or product already in cart
        if (cartVariantIds.includes(variantId) || (crossSellProductId && cartProductIds.includes(crossSellProductId))) {
          console.log('[VELUNA_ATC] Cross-sell already in cart, blocking add');
          // Update button to show "In Cart" state using controller
          if (button) {
            VelunaATCController.setState(button, 'locked', {
              labelText: 'In Cart'
            });
            setTimeout(function() {
              if (button) {
                var baselineLabel = button.dataset.velunaAtcBaselineLabel || 'Add to Cart';
                VelunaATCController.setState(button, 'ready', {
                  labelText: baselineLabel
                });
              }
            }, 2000);
          }
          // Clear locks
          delete window.__VELUNA_VARIANT_INFLIGHT__[variantId];
          window.__VELUNA_ATC_INFLIGHT__ = false;
          if (button) {
            delete button.dataset.velunaInflight;
          }
          // Tile 8: Restore UI state for all buttons tied to this variant
          syncVariantButtonState(variantId, 'restore');
          // Tile 6: Return resolved promise with null marker (clean exit, no error)
          return Promise.resolve(null);
        }
        
        // Tile 6: Derive subscription context from cart
        var subscriptionContext = getSubscriptionContextFromCart(cart);
        var crossSellVelunasubProperties = null;
        if (subscriptionContext) {
          crossSellVelunasubProperties = {
            plan: subscriptionContext.plan || '',
            frequency: subscriptionContext.frequency || '',
            discount: subscriptionContext.discount || ''
          };
        }
        
        // Execute add to cart with subscription context
        // CANONICAL: Pass same options object as main PDP to ensure drawer opens
        // Main PDP passes: { button: button } - drawer opening is handled in handleAddToCart success handler
        // Both paths reach the same openDrawerAfterAdd() call at line 3394
        return addToCart(variantId, quantity, crossSellVelunasubProperties, abortController, { button: button });
      })
      .catch(function(error) {
        // PHASE 3B FIX: If cart.js fetch fails (network error), proceed with add-to-cart anyway
        // The dedupe check and subscription context are optional optimizations
        // Log the error but continue with the add-to-cart request
        console.warn('[VELUNA_ATC] Cross-sell cart.js fetch failed, proceeding with add-to-cart anyway:', error.message || error);
        
        // PHASE 3B: Trace the fallback path
        var traceFn = window.__velunaTraceDrawer || function() {};
        traceFn('atc:crosssell:cartFetchFailed', {
          error: error.message || String(error),
          proceeding: true
        });
        
        // Proceed with add-to-cart without subscription context (fallback)
        return addToCart(variantId, quantity, null, abortController, { button: button });
      });
    } else {
      // For main product, use existing velunasubProperties logic
      addToCartPromise = addToCart(variantId, quantity, velunasubProperties, abortController, { button: button });
    }
    
    // ========================================================================
    // DIAGNOSTIC: Capture cart count BEFORE add (for before/after comparison)
    // ========================================================================
    var beforeItemCount = null;
    var diagnosticPromise = Promise.resolve();
    if (window.VELUNA_DEBUG_CART) {
      diagnosticPromise = velunaFetchJson(cartEndpoints.cartJs)
        .then(function(cart) {
          beforeItemCount = cart.item_count;
          console.log('[VELUNA_DEBUG_CART] BEFORE add: item_count=' + beforeItemCount);
          console.log('[VELUNA_DEBUG_CART] cart.js URL:', cartEndpoints.cartJs);
        })
        .catch(function(err) { 
          console.warn('[VELUNA_DEBUG_CART] Pre-add cart fetch failed:', err.message);
          beforeItemCount = -1; 
        });
    }
    
    diagnosticPromise.then(function() {
    addToCartPromise
      .then(function(result) {
        // PHASE 2: INTENT-BASED DRAWER OPENING
        // Decouple drawer opening from "item added" result
        // Drawer opens based on user intent (button with data-veluna-atc OR form with data-veluna-product-form), not add result
        
        // PHASE 3: Canonical ATC Contract - accept either button marker OR form marker
        // Contract: Drawer opens if:
        //  1. Button has data-veluna-atc="1" (existing behavior), OR
        //  2. Form has data-veluna-product-form="1" (new fallback for template safety)
        var hasButtonMarker = button && button.hasAttribute('data-veluna-atc');
        var form = button ? (button.closest('form[action*="/cart/add"]') || button.closest('form')) : null;
        var hasFormMarker = form && form.hasAttribute('data-veluna-product-form');
        var shouldOpenDrawer = hasButtonMarker || hasFormMarker;
        
        // PHASE 3 DEBUG: Log qualification method
        if (window.__CART_DEBUG__) {
          console.log('[CART_DEBUG] Drawer open qualification:', {
            hasButtonMarker: hasButtonMarker,
            hasFormMarker: hasFormMarker,
            shouldOpenDrawer: shouldOpenDrawer,
            qualificationMethod: hasButtonMarker ? 'button-attr' : (hasFormMarker ? 'form-attr' : 'none')
          });
        }
        
        // PHASE 3 GUARDRAIL: Debug-gated check for cross-sell drawer flag
        if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && isCrossSellButton) {
          console.log('[VELUNA_XSELL_GUARD] Cross-sell addToCart result:', {
            result: result,
            hasResult: !!result,
            isNull: result === null,
            suppressed: result && result.suppressed,
            success: result && result.success,
            shouldOpenDrawer: shouldOpenDrawer,
            hasDataVelunaAtc: button ? button.hasAttribute('data-veluna-atc') : false,
            hasFormMarker: form ? form.hasAttribute('data-veluna-product-form') : false,
            qualificationMethod: hasButtonMarker ? 'button-attr' : (hasFormMarker ? 'form-attr' : 'none')
          });
        }
        
        // Helper function: Open drawer with cart (used for both success and suppressed cases)
        var openDrawerWithCart = function(cartForDrawer) {
          if (!cartForDrawer || cartForDrawer.item_count === 0) {
            // Cart is empty - do not open drawer
            if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && shouldOpenDrawer) {
              console.warn('[VELUNA_DRAWER_INTENT] Drawer intent exists but cart is empty - not opening');
            }
            return;
          }
          
          try {
            if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && shouldOpenDrawer) {
              console.log('[VELUNA_DRAWER_INTENT] Opening drawer based on user intent', {
                cartItemCount: cartForDrawer.item_count,
                variantId: variantId,
                isSuppressed: result && result.suppressed === true,
                isNull: result === null
              });
            }
            
            openDrawerAfterAdd(cartForDrawer);
            
            if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && isCrossSellButton) {
              setTimeout(function() {
                var drawer = document.querySelector('[data-cart-drawer], .veluna-cart-drawer');
                var isOpen = drawer && drawer.classList.contains('veluna-cart-drawer--open');
                if (!isOpen) {
                  console.error('[VELUNA_XSELL_GUARD] Drawer did not open after cross-sell add!', {
                    drawerExists: !!drawer,
                    hasOpenClass: drawer ? drawer.classList.contains('veluna-cart-drawer--open') : false
                  });
                } else {
                  console.log('[VELUNA_XSELL_GUARD] ✅ Drawer opened successfully for cross-sell');
                }
              }, 500);
            }
          } catch (err) {
            console.warn('[VELUNA_ATC] Drawer open failed', err);
            if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && shouldOpenDrawer) {
              console.error('[VELUNA_DRAWER_INTENT] Drawer open exception:', err);
            }
          }
        };
        
        // Tile 6: Short-circuit if dedupe block returned null (already in cart)
        if (result === null) {
          // Already handled UI and locks in dedupe block
          // PHASE 2: Open drawer based on intent, even if add was blocked
          if (shouldOpenDrawer) {
            // Use stored cart from dedupe check (cross-sell) or fetch fresh cart (fallback)
            var cartForDrawer = dedupeCart || null;
            
            if (cartForDrawer) {
              // Reuse cart from dedupe check (already fetched, no extra network call)
              openDrawerWithCart(cartForDrawer);
              
              // PHASE 3 GUARDRAIL: Debug log for suppressed drawer open
              if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG)) {
                console.warn('[VELUNA_DRAWER_INTENT] Drawer opened for null result (dedupe block) - user intent satisfied', {
                  usedDedupeCart: true,
                  cartItemCount: cartForDrawer.item_count
                });
              }
            } else {
              // Fallback: Fetch cart if not available (should not happen for cross-sell)
              velunaFetchJson(cartEndpoints.cartJs).then(function(cart) {
                openDrawerWithCart(cart);
                
                if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG)) {
                  console.warn('[VELUNA_DRAWER_INTENT] Drawer opened for null result (dedupe block) - user intent satisfied (fallback fetch)');
                }
              }).catch(function(err) {
                console.warn('[VELUNA_ATC] Failed to fetch cart for drawer open (dedupe case):', err);
              });
            }
          } else if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && isCrossSellButton) {
            console.warn('[VELUNA_XSELL_GUARD] Cross-sell result is null (dedupe block) - no drawer intent (button missing data-veluna-atc and form missing data-veluna-product-form)');
          }
          return;
        }
        
        // Check if result was suppressed (idempotent noop)
        if (result && result.suppressed === true) {
          // This was a duplicate request that was silently suppressed
          if (window.__VELUNA_DEBUG_ATC__) {
            console.log('[VELUNA_ATC_DEBUG] Request suppressed (idempotent)');
          }
          
          // PHASE 2: Open drawer based on intent, even if add was suppressed
          if (shouldOpenDrawer) {
            // Fetch cart to open drawer (item may already be in cart)
            velunaFetchJson(cartEndpoints.cartJs).then(function(cart) {
              openDrawerWithCart(cart);
              
              // PHASE 3 GUARDRAIL: Debug log for suppressed drawer open
              if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG)) {
                console.warn('[VELUNA_DRAWER_INTENT] Drawer opened for suppressed result - user intent satisfied');
              }
            }).catch(function(err) {
              console.warn('[VELUNA_ATC] Failed to fetch cart for drawer open (suppressed case):', err);
            });
          } else if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && isCrossSellButton) {
            console.warn('[VELUNA_XSELL_GUARD] Cross-sell result suppressed - no drawer intent (button missing data-veluna-atc and form missing data-veluna-product-form)');
          }
          
          // Restore button state but don't proceed with full success path
          if (button) {
            var baselineLabel = button.dataset.velunaAtcBaselineLabel || 'Add to Cart';
            VelunaATCController.setState(button, 'ready', {
              labelText: baselineLabel
            });
          }
          return;
        }
        console.log('[VELUNA_ATC] ok');
        if (window.VELUNA_DEBUG_CART || window.__VELUNA_DEBUG_ATC__) {
          console.log('[VELUNA_DEBUG_CART] Add to cart API succeeded', { result: result });
        }
        
        // Fetch cart once to verify (use storefront endpoint)
        if (window.__VELUNA_DEBUG_ATC__) {
          console.info('[VELUNA_ATC] GET', cartEndpoints.cartJs);
        }
        return velunaFetchJson(cartEndpoints.cartJs).then(function(cart) {
          // LOG CART_RES with item_count and items.length
          console.log('[VELUNA_ATC] CART_RES', {
            item_count: cart.item_count,
            items_length: cart.items ? cart.items.length : 0
          });
          
          console.log('[VELUNA_ATC] cart item_count=' + cart.item_count);
          if (window.VELUNA_DEBUG_CART) {
            console.log('[VELUNA_DEBUG_CART] AFTER add: item_count=' + cart.item_count + ' (was ' + beforeItemCount + ')');
            console.log('[VELUNA_DEBUG_CART] item_count increased:', cart.item_count > beforeItemCount);
          }
          
          // Update cached cart item count in recovery-cream-hero.js if available
          if (window.updateCartItemCountCache && typeof window.updateCartItemCountCache === 'function') {
            window.updateCartItemCountCache(cart.item_count);
          }
          
          // Update cart count badge (minimal fallback)
          try {
            var countBadges = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
            countBadges.forEach(function(badge) {
              badge.textContent = cart.item_count;
              badge.style.display = cart.item_count > 0 ? '' : 'none';
            });
          } catch (e) { /* ignore */ }
          
          // Update button - cart add succeeded (using controller)
          if (button) {
            VelunaATCController.setState(button, 'ready', {
              labelText: 'Added!'
            });
            setTimeout(function() {
              if (button) {
                var baselineLabel = button.dataset.velunaAtcBaselineLabel || 'Add to Cart';
                VelunaATCController.setState(button, 'ready', {
                  labelText: baselineLabel
                });
              }
            }, 2000);
          }
          
          // Debug log (gated)
          if (window.__VELUNA_DEBUG__ === true) {
            console.log('[VELUNA_ATC_LOCK] Request succeeded, drawer opening', {
              variantId: variantId,
              timestamp: Date.now()
            });
          }
          
          // PHASE 2: INTENT-BASED DRAWER OPENING
          // Open drawer based on user intent (button with data-veluna-atc OR form with data-veluna-product-form)
          // This applies to both successful adds and suppressed/null results
          if (shouldOpenDrawer) {
            // Use the cart we just fetched (successful add path)
            openDrawerWithCart(cart);
          } else {
            // No drawer intent - legacy behavior for buttons without data-veluna-atc
            // Open drawer ONLY if cart has items - prevent empty drawer
            if (cart.item_count > 0) {
              try { 
                openDrawerAfterAdd(cart); 
                // Debug log (gated)
                if (window.__VELUNA_DEBUG__ === true) {
                  console.log('[VELUNA_ATC_LOCK] Drawer opened (legacy path)', {
                    timestamp: Date.now()
                  });
                }
              } catch (err) { 
                console.warn('[VELUNA_ATC] Drawer open failed', err); 
              }
            }
          }
          
          // PHASE 3 GUARDRAIL: Verify drawer actually opened (debug mode only)
          if ((window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) && shouldOpenDrawer && !isCrossSellButton) {
            setTimeout(function() {
              var drawer = document.querySelector('[data-cart-drawer], .veluna-cart-drawer');
              var isOpen = drawer && drawer.classList.contains('veluna-cart-drawer--open');
              if (!isOpen) {
                console.error('[VELUNA_DRAWER_INTENT] Drawer did not open after ATC add!', {
                  drawerExists: !!drawer,
                  hasOpenClass: drawer ? drawer.classList.contains('veluna-cart-drawer--open') : false
                });
              }
            }, 500);
          }
          
          // Empty cart handling (backend blocked item)
          if (cart.item_count === 0) {
            // Cart is empty after "successful" add - backend blocked the item
            console.error('[VELUNA_ATC] CART_EMPTY_AFTER_ADD', {
              variantId: variantId,
              message: 'Item was blocked by backend despite force-add bypass'
            });
            
            // Show error message to user
            var errorMessage = 'Unable to add item to cart. The item may be temporarily unavailable. Please try again or contact support.';
            
            // Try to show error in drawer if it exists, otherwise show alert
            var drawer = document.querySelector('[data-cart-drawer], .veluna-cart-drawer');
            if (drawer) {
              var emptyState = drawer.querySelector('[data-cart-empty]');
              if (emptyState) {
                var originalText = emptyState.innerHTML;
                emptyState.innerHTML = '<p style="color: #d32f2f; font-weight: 500;">' + errorMessage + '</p>';
                emptyState.style.display = 'block';
                
                // Restore original text after 5 seconds
                setTimeout(function() {
                  emptyState.innerHTML = originalText;
                }, 5000);
              }
              
              // Open drawer to show error
              try {
                openCartDrawer();
              } catch (e) {
                console.warn('[VELUNA_ATC] Failed to open drawer for error message', e);
                alert(errorMessage);
              }
            } else {
              alert(errorMessage);
            }
            
            // Restore button state
            if (button) {
              setButtonLoadingState(button, false);
            }
          }
        }).catch(function(err) {
          // Cart refresh failed (likely HTML response - password page, challenge, etc.)
          // Log with diagnostics from __VELUNA_ATC_DIAG__
          var diag = window.__VELUNA_ATC_DIAG__ || {};
          console.error('[VELUNA_ATC] CART_REFRESH_FAILED', {
            status: diag.lastStatus,
            contentType: diag.lastContentType,
            redirected: diag.lastRedirected,
            wasHtml: diag.lastWasHtml,
            snippet: diag.lastSnippet ? diag.lastSnippet.substring(0, 50) + '...' : null,
            error: err.message
          });
          // Tile 8: Clear global variant lock on error
          delete window.__VELUNA_VARIANT_INFLIGHT__[variantId];
          syncVariantButtonState(variantId, 'restore');
          // JARVIS_FIX_2026-02-18_DRAWER_OPEN: Even if cart refresh fails, still open drawer.
          // The add-to-cart POST may have succeeded; failing to open the drawer creates a "nothing happened" UX.
          try {
            openCartDrawer();
          } catch (e) {
            console.warn('[VELUNA_ATC] openCartDrawer failed after CART_REFRESH_FAILED', e && e.message ? e.message : e);
          }
          // Try to populate drawer content shortly after (best-effort)
          setTimeout(function() {
            try { checkCartAndOpenDrawer(); } catch (e) {}
          }, 500);
          // Do NOT attempt to open drawer with undefined cart - var finally restore button
        });
      })
      .catch(function(error) {
        // Tile 8: Clear global variant lock on error
        delete window.__VELUNA_VARIANT_INFLIGHT__[variantId];
        syncVariantButtonState(variantId, 'restore');
        
        if (window.__VELUNA_DEBUG_ATC__) {
          console.log('[VELUNA_ATC_DEBUG] Add to cart failed', error);
        }
        
        // IDEMPOTENT: Silently ignore "already in progress" errors if we have active inflight
        // This prevents error propagation to inline code that might show alerts
        var isAlreadyInProgress = error && error.message && 
          (error.message.toLowerCase().includes('already in progress') ||
           error.message.toLowerCase().includes('request already'));
        var hasActiveInflight = window.__VELUNA_ATC_INFLIGHT__ === true ||
                               (button && button.dataset.velunaInflight === '1');
        
        if (isAlreadyInProgress && hasActiveInflight) {
          // Silent noop - our original request is handling it
          if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
            console.log('[VELUNA_ATC] ATC_SUPPRESSED_ALREADY_IN_PROGRESS (catch handler)', { hasActiveInflight: true });
          }
          return; // Exit early, var finally restore button
        }
        
        // All other errors - log normally
        if (error.name === 'AbortError') {
          console.error('[VELUNA_ATC] fail {reason: "timeout"}');
        } else {
          console.error('[VELUNA_ATC] fail {reason: "' + (error.message || 'unknown') + '"}');
        }
        
        // Verify if item was actually added (compare to before-count)
        velunaFetchJson(cartEndpoints.cartJs).then(function(cart) {
          var wasActuallyAdded = cart.item_count > beforeItemCount;
          if (wasActuallyAdded) {
            // Item was added despite the error
            try { openDrawerAfterAdd(cart); } catch (err) { console.warn('[VELUNA_ATC] Drawer open failed', err); }
            
            if (button) {
              setButtonTemporaryLabel(button, 'Added!', 2000);
              setTimeout(function() {
                if (button) {
                  setButtonLoadingState(button, false);
                  resetButtonTemporaryLabel(button);
                }
              }, 2000);
            }
          } else {
            // Item was NOT added - restore button without "Added!"
            if (button) {
              setButtonLoadingState(button, false);
              resetButtonTemporaryLabel(button);
            }
          }
        }).catch(function(err) {
          // Cart fetch failed, restore button anyway
          console.error('[VELUNA_ATC] CART_JSON_ERROR (recovery check):', err.message);
          if (button) {
            setButtonLoadingState(button, false);
          }
        });
      })
      .finally(function() {
        // ALWAYS cleanup and restore button - CRITICAL: This MUST run regardless of success/failure
        clearTimeout(timeoutId);
        clearTimeout(watchdogTimeoutId);
        
        var nonceToLog = inflightNonce ? inflightNonce.slice(0, 8) + '...' : 'none';
        if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
          console.log('[VELUNA_ATC] ATC_REQUEST_END', { nonce: nonceToLog });
        }
        
        // Debug log (gated by __VELUNA_DEBUG__)
        if (window.__VELUNA_DEBUG__ === true) {
          console.log('[VELUNA_ATC_LOCK] Lock released (finally block)', {
            nonce: nonceToLog,
            timestamp: Date.now(),
            buttonId: button ? button.id : null
          });
        }
        
        console.log('[VELUNA_ATC] UNLOCKED');
        
        // Tile 8: Clear global variant lock
        if (variantId && window.__VELUNA_VARIANT_INFLIGHT__) {
        delete window.__VELUNA_VARIANT_INFLIGHT__[variantId];
        }
        syncVariantButtonState(variantId, 'restore');
        
        // ALWAYS clear BOTH global and button locks, nonce, and stored promise
        // CRITICAL: This ensures locks always clear, even on early returns or errors
        // This is in finally block, so it ALWAYS runs regardless of success/failure/abort
        window.__VELUNA_ATC_INFLIGHT__ = false;
        window.__VELUNA_ATC_INFLIGHT_AT__ = null;
        window.__VELUNA_ATC_INFLIGHT_NONCE__ = null;
        window.__VELUNA_ATC_PROMISE__ = null;
        
        // ALWAYS restore button state and clear in-flight lock (including nonce and promise)
        if (button) {
          delete button.dataset.velunaInflight;
          delete button.dataset.velunaInflightAt;
          delete button.dataset.velunaInflightNonce;
          delete button.dataset.velunaAtcHandled;
          delete button.__velunaInflightPromise;
          // Use template-safe restore (preserves DOM structure)
          setButtonLoadingState(button, false);
          logButtonState('finally-block-restore', button);
        }
      });
    }); // End diagnosticPromise.then
  }
  
  // Legacy function names for compatibility - delegate to handleAddToCart
  function handleAddToCartClick(e, phase) {
    // PHASE 3A: Trace handler entry
    var traceFn = window.__velunaTraceDrawer || function() {};
    try {
      traceFn('__velunaHandleAtcClick:enter', {
        phase: phase,
        targetId: e.target ? (e.target.id || null) : null,
        targetTag: e.target ? (e.target.tagName || null) : null,
        targetClass: e.target ? (e.target.className || null) : null
      });
    } catch(traceErr) {}
    
    console.log('[VELUNA_ATC][1] handler entered', { phase: phase });
    
    // Debug flag: set window.VELUNA_DEBUG_CART = true in console to enable verbose logging
    var debug = window.VELUNA_DEBUG_CART === true;
    
    if (debug) {
      console.log('[VELUNA_DEBUG_CART] click handler entry', {
        phase: phase,
        targetId: e.target && e.target.id,
        targetTag: e.target && e.target.tagName,
        targetClasses: e.target && e.target.className,
        timestamp: new Date().toISOString()
      });
    }
    
    // Diagnostic: Log all clicks (context-agnostic, no Shopify.* dependency)
    console.log('[VELUNA_ATC] click', {
      phase: phase,
      targetId: e.target && e.target.id,
      targetTag: e.target && e.target.tagName,
      targetClasses: e.target && e.target.className
    });
    
    // PRIMARY IDEMPOTENCY CHECK #1: Check global lock BEFORE resolving button
    // This is the FIRST check - prevents any processing if global lock is active
    // FAILSAFE: If lock is stuck (>15s), forcibly clear it to prevent deadlock
    if (window.__VELUNA_ATC_INFLIGHT__ === true) {
      var inflightAt = window.__VELUNA_ATC_INFLIGHT_AT__ || 0;
      var lockAge = Date.now() - inflightAt;
      var maxLockAge = 15000; // 15 seconds
      
      if (lockAge > maxLockAge) {
        // Lock is stuck - forcibly clear everything to prevent deadlock
        // FAILSAFE: Clear all global ATC dedupe markers (defensive - check existence first)
        if (window.__VELUNA_ATC_INFLIGHT__ !== undefined) {
          window.__VELUNA_ATC_INFLIGHT__ = false;
        }
        if (window.__VELUNA_ATC_INFLIGHT_AT__ !== undefined) {
          window.__VELUNA_ATC_INFLIGHT_AT__ = null;
        }
        if (window.__VELUNA_ATC_INFLIGHT_NONCE__ !== undefined) {
          window.__VELUNA_ATC_INFLIGHT_NONCE__ = null;
        }
        if (window.__VELUNA_ATC_PROMISE__ !== undefined) {
          window.__VELUNA_ATC_PROMISE__ = null;
        }
        
        // FAILSAFE: Clear button locks from event target (if resolvable)
        var stuckButton = resolveAddToCartButton(e.target);
        if (stuckButton) {
          stuckButton.disabled = false;
          delete stuckButton.dataset.velunaInflight;
          delete stuckButton.dataset.velunaInflightAt;
          delete stuckButton.dataset.velunaAtcHandled;
          delete stuckButton.__velunaInflightPromise;
          // Restore original text from canonical dataset key whenever clearing state (robust cleanup)
          if (stuckButton.dataset.velunaOriginalText) {
            stuckButton.textContent = stuckButton.dataset.velunaOriginalText;
            delete stuckButton.dataset.velunaOriginalText;
          }
        }
        
        // FAILSAFE: Defensive sweep - clear ALL ATC buttons
        try {
          // PHASE 3: Generic ATC button selector - no template-specific classes/IDs
          var allAtcButtons = document.querySelectorAll('[data-veluna-atc], [data-veluna-add-to-cart], .veluna-add-to-cart, button[name="add"]');
          allAtcButtons.forEach(function(btn) {
            btn.disabled = false;
            delete btn.dataset.velunaInflight;
            delete btn.dataset.velunaInflightAt;
            delete btn.dataset.velunaAtcHandled;
            delete btn.__velunaInflightPromise;
            // Restore original text from canonical dataset key whenever clearing state (robust cleanup)
            if (btn.dataset.velunaOriginalText) {
              btn.textContent = btn.dataset.velunaOriginalText;
              delete btn.dataset.velunaOriginalText;
            }
          });
        } catch(sweepError) {
          // Ignore errors in defensive sweep
        }
        
        // Debug log only if debug mode is on
        if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
          console.log('[VELUNA_ATC] FAILSAFE_UNLOCK_TRIGGERED', { lockAge: lockAge, maxLockAge: maxLockAge });
        }
        
        // Continue normal flow (lock was stuck, now cleared)
      } else {
        // Lock is active and recent - return immediately (idempotent)
        return false;
      }
    }
    
    var target = e.target;
    var button = resolveAddToCartButton(target);
    console.log('[VELUNA_ATC][2] button resolved', { found: !!button, id: button ? button.id : null });
    
    if (window.__VELUNA_DEBUG_ATC__) {
      console.log('[VELUNA_ATC_DEBUG] Click captured, resolved button:', button ? { id: button.id, tag: button.tagName, classes: button.className } : null);
    }
    
    if (!button) { console.log('[VELUNA_ATC][2a] EXIT: no button'); return false; }
    
    // CRITICAL: Capture canonical original text IMMEDIATELY after resolving button
    // This must happen before any dedupe/lock checks or UI mutations
    if (!('velunaOriginalText' in button.dataset)) {
      button.dataset.velunaOriginalText = button.textContent;
    }
    
    // PRIMARY IDEMPOTENCY CHECK #2: Check button-specific locks and disabled state
    // This is the SECOND check - prevents processing if button is locked or disabled
    if (button.disabled || button.dataset.velunaInflight === '1') {
      console.log('[VELUNA_ATC][3a] EXIT: button disabled or inflight', { disabled: button.disabled, inflight: button.dataset.velunaInflight });
      return false;
    }
    
    // CRITICAL: Check if already handled by previous phase (capture/bubble dedupe)
    if (button.dataset.velunaAtcHandled === '1') {
      console.log('[VELUNA_ATC][3b] EXIT: already handled');
      return false;
    }
    console.log('[VELUNA_ATC][3] passed button guards');
    
    // Mark as handled IMMEDIATELY to prevent double-processing from capture+bubble
    button.dataset.velunaAtcHandled = '1';
    // Clear the flag after a tick to allow future clicks
    setTimeout(function() {
      if (button) {
        delete button.dataset.velunaAtcHandled;
      }
    }, 100);
    
    // Set BOTH locks immediately before calling handleAddToCart
    // CRITICAL: Always set timestamp when setting inflight flag (required for failsafe)
    // CRITICAL: Generate nonce to track this specific request (prevents unlocking wrong request)
    var lockNonce = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    window.__VELUNA_ATC_INFLIGHT__ = true;
    window.__VELUNA_ATC_INFLIGHT_AT__ = Date.now();
    window.__VELUNA_ATC_INFLIGHT_NONCE__ = lockNonce;
    button.dataset.velunaInflight = '1';
    button.dataset.velunaInflightAt = String(Date.now());
    button.dataset.velunaInflightNonce = lockNonce;
    
    // Debug log (gated by __VELUNA_DEBUG__)
    if (window.__VELUNA_DEBUG__ === true) {
      console.log('[VELUNA_ATC_LOCK] Lock acquired', {
        nonce: lockNonce.slice(0, 8) + '...',
        timestamp: Date.now(),
        buttonId: button.id
      });
    }
    
    // PHASE 3: Generic product form detection - no template-specific selectors
    var form = button.closest('form[action*="/cart/add"]') || button.closest('form');
    var hasProductInput = form && form.querySelector('input[name="id"]');
    var hasFormMarker = form && form.hasAttribute('data-veluna-product-form');
    var isAddButton = button.name === 'add' ||
                        button.hasAttribute('data-veluna-atc') ||
                        button.hasAttribute('data-veluna-cross-sell') ||
                        hasFormMarker ||
                        (button.type === 'submit' && form && form.action && form.action.indexOf('/cart/add') !== -1) ||
                        (button.type !== 'submit' && (hasProductInput || 
                         (form && form.action && form.action.indexOf('/cart/add') !== -1)));
    
    // TILE B: Allow submit buttons to be handled by click handler
    // Capture handler already prevents default, so form submit won't fire (no double-fire)
    // Button locking in handleAddToCart prevents duplicate requests
    if (!isAddButton) { console.log('[VELUNA_ATC][4a] EXIT: not an add button'); return false; }
    console.log('[VELUNA_ATC][4] isAddButton=true, calling handleAddToCart');
    
    // Tile 6: Mark button as handled to prevent submit handler from double-processing
    if (button) {
      button.dataset.velunaAtcHandled = '1';
      // Clear marker after a short delay (submit handler runs in same tick)
      setTimeout(function() {
        if (button) {
          delete button.dataset.velunaAtcHandled;
        }
      }, 100);
    }
    
    // PHASE 3: Debug log ATC event capture
    if (window.__CART_DEBUG__) {
      var qualificationMethod = button && button.hasAttribute('data-veluna-atc') ? 'button-attr' : 
                                (form && form.hasAttribute('data-veluna-product-form') ? 'form-attr' : 'none');
      console.log('[CART_DEBUG] ATC event captured', {
        qualificationMethod: qualificationMethod,
        buttonId: button ? button.id : null,
        hasDataVelunaAtc: button ? button.hasAttribute('data-veluna-atc') : false,
        hasFormMarker: form ? form.hasAttribute('data-veluna-product-form') : false
      });
    }
    
    // Handle the click (works for both submit and non-submit buttons)
    // CRITICAL: Wrap in try/catch to ensure lock is released even if handleAddToCart throws synchronously
    try {
    handleAddToCart({ button, form, event: e });
    } catch (syncError) {
      // Synchronous error - clear lock immediately
      traceFn('__velunaHandleAtcClick:error', { error: syncError.message, stack: syncError.stack });
      console.error('[VELUNA_ATC] Synchronous error in handleAddToCart:', syncError);
      window.__VELUNA_ATC_INFLIGHT__ = false;
      window.__VELUNA_ATC_INFLIGHT_AT__ = null;
      window.__VELUNA_ATC_INFLIGHT_NONCE__ = null;
      window.__VELUNA_ATC_PROMISE__ = null;
      if (button) {
        delete button.dataset.velunaInflight;
        delete button.dataset.velunaInflightAt;
        delete button.dataset.velunaInflightNonce;
        delete button.__velunaInflightPromise;
        if (window.VelunaAddToCart && window.VelunaAddToCart.controller) {
          window.VelunaAddToCart.controller.setState(button, 'error', {
            labelText: 'Error - Try Again'
          });
        } else {
          button.disabled = false;
        }
      }
      traceFn('__velunaHandleAtcClick:exit', { reason: 'sync_error', error: syncError.message });
      return false;
    }
    
    // PHASE 3A: Normal exit trace
    try {
      traceFn('__velunaHandleAtcClick:exit', { reason: 'normal' });
    } catch(traceErr) {}
    return true;
  }
  
  // Expose implementation functions so handlers (defined outside guard) can call them
  window.__velunaResolveButton = resolveAddToCartButton;
  window.__velunaHandleAtcClick = handleAddToCartClick;
  
  // CRITICAL: Ensure handlers are attached AFTER implementation functions are exposed
  // This ensures handlers can actually process clicks (handlers check for functions at runtime)
  // Note: Early attachment (line ~360) may have already attached, but handlers will work
  // once functions are exposed since they check at runtime
  // IDEMPOTENT: Use data attribute to prevent duplicate listeners on Theme Editor rerenders
  function attachATCHandlersIdempotent() {
    // Check data attribute (survives DOM replacement in Theme Editor)
    if (document.documentElement.hasAttribute('data-veluna-atc-bound')) {
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] Handlers already bound (data attribute check)');
      }
      
      // REGRESSION GUARDRAIL: Detect if multiple handlers attached (double-add risk)
      if (window.__VELUNA_DEBUG__ === true) {
        // Count event listeners (approximate check via getEventListeners if available)
        var listenerCount = 0;
        if (document.__velunaAtcCaptureHandler) {
          // Check if handler is already attached by checking if it would fire
          // This is a heuristic - we can't directly count listeners in all browsers
          listenerCount++;
        }
        if (document.__velunaAtcBubbleHandler) {
          listenerCount++;
        }
        
        // If we're trying to attach again but attribute is set, log warning
        if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
          console.log('[VELUNA_ATC_REGRESSION] Handler attachment check: data-veluna-atc-bound present, skipping re-attachment');
        }
      }
      
      return; // Already bound
    }
    
    if (document.__velunaAtcCaptureHandler && document.__velunaAtcBubbleHandler) {
    try {
      document.addEventListener('click', document.__velunaAtcCaptureHandler, true);
      document.addEventListener('click', document.__velunaAtcBubbleHandler, false);
      
      // PHASE 1: Add form submit listener to intercept form submissions (prevents jump to top)
      if (!document.__velunaAtcSubmitHandler) {
        document.__velunaAtcSubmitHandler = function(e) {
          try {
            if (typeof window.__velunaResolveButton !== 'function' || typeof window.__velunaHandleAtcClick !== 'function') {
              return; // Functions not ready yet
            }
            
            var form = e.target;
            if (!form || form.tagName !== 'FORM') {
              return;
            }
            
            // Check if form contains a cross-sell ATC button
            // PHASE 3: Generic submit button detection
            var submitButton = form.querySelector('button[type="submit"][data-veluna-atc], button[type="submit"][data-veluna-cross-sell]');
            if (submitButton) {
              // This is a cross-sell form - prevent default submit (causes jump to top)
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              // Trigger click handler instead (which will handle the add-to-cart)
              if (submitButton && !submitButton.disabled) {
                var clickEvent = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window
                });
                submitButton.dispatchEvent(clickEvent);
              }
            }
          } catch (err) {
            console.error('VELUNA_ATC: submit handler error:', err);
          }
        };
      }
      document.addEventListener('submit', document.__velunaAtcSubmitHandler, true);
      
      window.__VELUNA_ATC_HANDLERS_ATTACHED__ = true;
      document.__velunaAtcClickBound = true;
      // Set data attribute for Theme Editor resilience
      document.documentElement.setAttribute('data-veluna-atc-bound', '1');
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] HANDLERS_ATTACHED (idempotent, data attribute set)');
      }
        
        // REGRESSION GUARDRAIL: Log handler attachment for verification
        if (window.__VELUNA_DEBUG__ === true) {
          console.log('[VELUNA_ATC_REGRESSION] Handlers attached successfully, data-veluna-atc-bound set');
        }
      } catch (e) {
        console.error('[VELUNA_ATC] handler attachment failed:', e);
        
        // REGRESSION GUARDRAIL: Log attachment failure
        if (window.__VELUNA_DEBUG__ === true) {
          console.error('[VELUNA_ATC_REGRESSION] Handler attachment failed:', e.message);
        }
      }
    }
  }
  
  // Attach handlers idempotently
  attachATCHandlersIdempotent();
  
  // ============================================================================
  // INITIALIZATION
  // ============================================================================
  var isInitialized = false;

  // ============================================================================
  // TEMPLATE-WIDE RESET HOOKS: Reset temporary labels on PDP control changes
  // ============================================================================
  // Works for all PDPs (not just Recovery Cream) via event delegation
  function setupTemplateWideResetHooks() {
    // Guard: Only set up once per document
    if (document.__velunaAtcResetHooksBound) {
      return;
    }
    document.__velunaAtcResetHooksBound = true;
    
    // Event delegation: Listen for changes on common PDP controls
    document.addEventListener('change', function(e) {
      var target = e.target;
      if (!target) return;
      
      // Check if this is a PDP control that should trigger reset
      var isPDPControl = 
        // Purchase type radios (subscribe vs one-time)
        target.matches('[data-velunasub-purchase-type], input[name*="purchase"][type="radio"]') ||
        // Selling plan / frequency selectors
        target.matches('[data-velunasub-frequency], select[name*="selling_plan"], select[name*="frequency"], input[name*="selling_plan"][type="radio"]') ||
        // Quantity inputs/selects
        target.matches('input[name="quantity"], select[name="quantity"], [data-quantity-input]') ||
        // Variant selectors
        target.matches('select[name="id"], input[name="id"][type="radio"]');
      
      if (isPDPControl) {
        // Find nearest ATC button in the same form/section
        var form = target.closest('form');
        var section = target.closest('section, [data-section-type]');
        var container = form || section || document;
        
        var atcButton = container.querySelector('[data-veluna-atc]');
        if (atcButton && typeof resetButtonTemporaryLabel === 'function') {
          resetButtonTemporaryLabel(atcButton);
          if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
            console.log('[VELUNA_ATC] Reset temp label on PDP control change:', target);
          }
        }
      }
    }, true); // Use capture phase to catch early
    
    // Also listen for quantity +/- button clicks
    document.addEventListener('click', function(e) {
      var target = e.target;
      if (!target) return;
      
      // Check if this is a quantity +/- button
      var isQuantityButton = 
        target.matches('[data-quantity-decrease], [data-quantity-increase], button[aria-label*="quantity" i], button[aria-label*="qty" i]') ||
        (target.closest('button') && (target.textContent === '+' || target.textContent === '−' || target.textContent === '-'));
      
      if (isQuantityButton) {
        var form = target.closest('form');
        var section = target.closest('section, [data-section-type]');
        var container = form || section || document;
        
        var atcButton = container.querySelector('[data-veluna-atc]');
        if (atcButton && typeof resetButtonTemporaryLabel === 'function') {
          resetButtonTemporaryLabel(atcButton);
          if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
            console.log('[VELUNA_ATC] Reset temp label on quantity change:', target);
          }
        }
      }
    }, true);
  }

  function init() {
    // Guard: Only initialize once per document
    if (isInitialized) {
      if (window.VELUNA_ATC_DEBUG) {
        console.log('[DEBUG] Already initialized, skipping init()');
      }
      return;
    }
    
    // Wrap entire init body in try/catch to prevent errors from unrelated scripts
    // from breaking initialization
    try {
      isInitialized = true;
      
      // Increment bind counter for debugging (do this first, before any other work)
      if (typeof window.__velunaAtcBindCount === 'undefined') {
        window.__velunaAtcBindCount = 0;
      }
      window.__velunaAtcBindCount++;
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] init count = ' + window.__velunaAtcBindCount);
        console.log('[VELUNA_ATC] Initializing add-to-cart handler');
        console.log('[VELUNA_ATC] Bind count:', window.__velunaAtcBindCount);
      }
      
      // Set up template-wide reset hooks (works for all PDPs)
      setupTemplateWideResetHooks();
      
      // After price injection, ensure buttons are in ready state (controller handles this)
      // No need to capture HTML - controller uses deterministic sub-element updates
      setTimeout(function() {
        ensureATCReady('price-injection-complete');
      }, 500); // Delay to allow updateAddToCartPrice() to complete
      
      // Also ensure ready state when updateAddToCartPrice is called (if it exists)
      if (typeof window.updateAddToCartPrice === 'function') {
        var originalUpdateAddToCartPrice = window.updateAddToCartPrice;
        window.updateAddToCartPrice = function() {
          var result = originalUpdateAddToCartPrice.apply(this, arguments);
          // After price update, ensure buttons are ready
          setTimeout(function() {
            ensureATCReady('price-updated');
          }, 100);
          return result;
        };
      }
      
      // NOTE: Handler attachment is done outside the guard (before guard check)
      // This ensures handlers attach even if guard trips
      
      // Handle form submission via event delegation
      document.addEventListener('submit', function(e) {
        try {
          var form = e.target;
          
          // Only handle forms with action="/cart/add"
          if (!form || !form.action || form.action.indexOf('/cart/add') === -1) {
            return;
          }
          
          // Tile 6: Use e.submitter to get the actual clicked button (submitter-safe)
          var submitter = e.submitter || form.querySelector('button[type="submit"], input[type="submit"], button:not([type])');
          
          // Tile 6: Skip if click handler already processed this button
          if (submitter && submitter.dataset.velunaAtcHandled === '1') {
            return; // Already handled by click handler
          }
          
          // Check disabled state only - inflight lock is checked and set in handleAddToCart
          if (submitter && !submitter.disabled) {
            handleAddToCart({ button: submitter, form, event: e });
          }
        } catch (err) {
          console.error('VELUNA_ATC: form submit handler error:', err);
        }
      }, true); // Capture phase
      
      // Note: Direct handler attachment removed - delegated handler is sufficient
      // and prevents double-binding issues in Theme Editor re-renders
      if (window.VELUNA_ATC_DEBUG) {
        console.log('[DEBUG] Using delegated handler only (no direct binding)');
      }
    } catch (err) {
      // Log error but do NOT throw - allow script to continue
      console.error('VELUNA_ATC: init error', err);
      if (err && err.stack) {
        console.error('VELUNA_ATC: init error stack:', err.stack);
      }
      // Reset isInitialized so we can retry on next call
      isInitialized = false;
    }
  }
  
  // Normalize window.theme immediately
  if (typeof window.theme === 'undefined') {
    window.theme = {};
  }
  
  // ============================================================================
  // FRAME IDENTITY PROOF: Log which frame is executing (debug-gated)
  // ============================================================================
  function logFrameIdentity(context) {
    if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
      return; // Only log in debug mode
    }
    
    var inDesignMode = window.Shopify && window.Shopify.designMode === true;
    var topEqWindow = window.top === window;
    var href = window.location.href;
    var hasVelunaAddToCart = typeof window.VelunaAddToCart !== 'undefined';
    var atcCount = document.querySelectorAll('[data-veluna-atc]').length;
    
    console.log('[VELUNA_ATC_FRAME_IDENTITY]', context, {
      inDesignMode: inDesignMode,
      topEqWindow: topEqWindow,
      href: href,
      hasVelunaAddToCart: hasVelunaAddToCart,
      atcCount: atcCount
    });
    
    // Warn if in admin frame (top === window) in design mode with no ATC buttons
    if (atcCount === 0 && topEqWindow && inDesignMode) {
      console.warn('[VELUNA_ATC_FRAME_IDENTITY] ⚠️ You are in admin frame; switch DevTools context to preview iframe OR use the bridge API: window.VelunaEditor.callATC()');
    }
  }
  
  // Initialize when DOM is ready
  function initializeWithLogging() {
    init();
    
    // Log frame identity (debug-gated)
    logFrameIdentity('initial-boot');
    
    if (window.VELUNA_ATC_DEBUG) {
      console.log('[DEBUG] veluna-add-to-cart initialized');
    }
    
    // Ensure ATC buttons are ready after initial boot (idempotent)
    // Small delay to allow price injection and DOM to settle
    setTimeout(function() {
      ensureATCReady('initial-boot');
    }, 200);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWithLogging);
  } else {
    initializeWithLogging();
  }
  
  
    // Expose API for theme.liquid check
  // PHASE 2: Set up fallback close handlers ONLY if drawer controller is missing
  // Wait for drawer controller to load, then check if it's present
  setTimeout(function() {
    if (!window.__VELUNA_DRAWER_CONTROLLER && (!window.theme || !window.theme.cartDrawer || typeof window.theme.cartDrawer.close !== 'function')) {
      console.warn('[VELUNA_ATC] Drawer controller not found after 1s, activating emergency fallback');
      setupDrawerCloseHandlers();
    }
  }, 1000);
  
  window.VelunaAddToCart = {
    addToCart: addToCart,
    openCartDrawer: openCartDrawer,
    syncVariantButtonState: syncVariantButtonState,
    setButtonLoadingState: setButtonLoadingState,
    setButtonTemporaryLabel: setButtonTemporaryLabel,
    resetButtonTemporaryLabel: resetButtonTemporaryLabel,
    unlockATCButton: unlockATCButton,
    unlockAllCurrentATCButtons: unlockAllCurrentATCButtons,
    ensureATCReady: ensureATCReady,
    logButtonState: logButtonState,
    controller: VelunaATCController, // Expose controller for advanced use
    debugVerifyClickable: function(btn) {
      // Debug-only helper to verify button is clickable
      if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
        console.warn('[VELUNA_ATC] debugVerifyClickable: Enable VELUNA_ATC_DEBUG or VELUNA_DEBUG to use');
        return null;
      }
      
      if (!btn) {
        console.warn('[VELUNA_ATC_DEBUG] debugVerifyClickable: No button provided');
        return null;
      }
      
      var rect = btn.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        console.warn('[VELUNA_ATC_DEBUG] Button has zero dimensions');
        return { accessible: false, reason: 'zero-dimensions' };
      }
      
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;
      var elementAtPoint = document.elementFromPoint(centerX, centerY);
      var isButtonAccessible = elementAtPoint === btn || (elementAtPoint && btn.contains(elementAtPoint));
      
      var computedStyle = window.getComputedStyle(btn);
      var result = {
        accessible: isButtonAccessible,
        disabled: btn.disabled,
        hasDisabledAttr: btn.hasAttribute('disabled'),
        ariaBusy: btn.getAttribute('aria-busy'),
        hasLoadingClass: btn.classList.contains('is-loading'),
        pointerEvents: computedStyle.pointerEvents,
        zIndex: computedStyle.zIndex,
        opacity: computedStyle.opacity,
        elementAtPoint: elementAtPoint ? {
          tagName: elementAtPoint.tagName,
          className: elementAtPoint.className,
          id: elementAtPoint.id
        } : null
      };
      
      if (!isButtonAccessible) {
        console.warn('[VELUNA_ATC_DEBUG] Button not accessible:', result);
      } else {
        console.log('[VELUNA_ATC_DEBUG] Button is accessible:', result);
      }
      
      return result;
    },
    debugDumpATC: function() {
      // Debug-only helper to dump current ATC button state
      if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
        console.warn('[VELUNA_ATC] debugDumpATC: Enable VELUNA_ATC_DEBUG or VELUNA_DEBUG to use');
        return;
      }
      
      var allAtcButtons = document.querySelectorAll('[data-veluna-atc]');
      var count = allAtcButtons.length;
      
      console.log('[VELUNA_ATC_DEBUG] Current ATC buttons:', count);
      
      if (count === 0) {
        console.warn('[VELUNA_ATC_DEBUG] No ATC buttons found with [data-veluna-atc]');
        return;
      }
      
      Array.from(allAtcButtons).forEach(function(btn, index) {
        var rect = btn.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var el = document.elementFromPoint(centerX, centerY);
        
        var computedStyle = window.getComputedStyle(btn);
        console.log('[VELUNA_ATC_DEBUG] Button', index + 1, ':', {
          id: btn.id,
          className: btn.className,
          disabled: btn.disabled,
          hasDisabledAttr: btn.hasAttribute('disabled'),
          ariaBusy: btn.getAttribute('aria-busy'),
          ariaDisabled: btn.getAttribute('aria-disabled'),
          hasLoadingClass: btn.classList.contains('is-loading'),
          hasDataAtcLabel: !!btn.querySelector('[data-atc-label]'),
          pointerEvents: computedStyle.pointerEvents,
          zIndex: computedStyle.zIndex,
          elementAtPoint: el === btn || btn.contains(el) ? 'accessible' : 'blocked',
          elementAtPointTag: el ? el.tagName : null,
          inflight: btn.dataset.velunaInflight === '1',
          baselineLabel: btn.dataset.velunaAtcBaselineLabel
        });
      });
    },
    testDrawer: function() {
      console.log('=== TESTING CART DRAWER OPEN ===');
      var drawer = document.querySelector('[data-cart-drawer]');
      console.log('Drawer element:', drawer);
      
      if (drawer) {
        console.log('Drawer found! Forcing open...');
        drawer.classList.add('veluna-cart-drawer--open');
        // PHASE 5 FIX: Only add cart-drawer-open (not generic drawer-open) to prevent triggering other drawers
    document.body.classList.add('cart-drawer-open');
        drawer.style.display = 'block';
        drawer.style.visibility = 'visible';
        drawer.style.opacity = '1';
        drawer.style.zIndex = '99999';
        drawer.style.position = 'fixed';
        drawer.style.top = '0';
        drawer.style.right = '0';
        drawer.style.width = '400px';
        drawer.style.height = '100vh';
        drawer.style.background = '#fff';
        console.log('Drawer should now be visible!');
        
        setTimeout(function() {
          if (drawer.classList.contains('veluna-cart-drawer--open')) {
            console.log('✅ Drawer is open!');
          } else {
            console.log('❌ Drawer did not open');
          }
        }, 500);
      } else {
        console.error('❌ Drawer not found!');
      }
    },
    test: function() {
      console.log('=== VelunaAddToCart Test ===');
      var button = document.getElementById('recovery-cream-add-to-cart');
      var variantInput = document.getElementById('product-variant-id');
      var quantityInput = document.getElementById('product-quantity');
      
      console.log('Button found:', !!button);
      console.log('Variant input found:', !!variantInput);
      console.log('Quantity input found:', !!quantityInput);
      
      if (button) {
        console.log('Button ID:', button.id);
        console.log('Button disabled:', button.disabled);
        console.log('Button text:', button.textContent);
      }
      
      if (variantInput) {
        console.log('Variant ID:', variantInput.value);
      }
      
      if (quantityInput) {
        console.log('Quantity:', quantityInput.value);
      }
      
      // Test click
      if (button && !button.disabled) {
        console.log('Testing button click...');
        button.click();
      }
    }
  };
    
    // ============================================================================
    // THEME EDITOR DEBUG BRIDGE: PostMessage API for top-frame console access
    // ============================================================================
    // Allows top admin frame to call VelunaAddToCart APIs in preview iframe
    // Only active when Shopify.designMode && (VELUNA_ATC_DEBUG || VELUNA_DEBUG)
    (function setupThemeEditorBridge() {
      // Only enable in design mode with debug flag
      if (!window.Shopify || window.Shopify.designMode !== true) {
        return; // Not in Theme Editor
      }
      
      if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
        return; // Debug bridge disabled
      }
      
      // Only set up once
      if (window.__VELUNA_ATC_BRIDGE_SETUP__) {
        return;
      }
      window.__VELUNA_ATC_BRIDGE_SETUP__ = true;
      
      // Listen for messages from top frame
      window.addEventListener('message', function(event) {
        // Security: Only accept messages from same origin
        if (event.origin !== window.location.origin) {
          return;
        }
        
        var message = event.data;
        if (!message || message.type !== 'VELUNA_ATC_CALL') {
          return;
        }
        
        var fn = message.fn;
        var args = message.args || [];
        var requestId = message.requestId;
        
        if (!requestId) {
          return; // Invalid message
        }
        
        try {
          // Execute function if it exists
          var result = null;
          var ok = false;
          var error = null;
          
          if (typeof window.VelunaAddToCart === 'undefined') {
            error = 'VelunaAddToCart API not available';
          } else if (typeof window.VelunaAddToCart[fn] !== 'function') {
            error = 'Function ' + fn + ' not found in VelunaAddToCart';
          } else {
            // Execute the function
            result = window.VelunaAddToCart[fn].apply(window.VelunaAddToCart, args);
            ok = true;
          }
          
          // Send result back to top frame
          if (event.source && event.source.postMessage) {
            event.source.postMessage({
              type: 'VELUNA_ATC_RESULT',
              requestId: requestId,
              ok: ok,
              result: result,
              error: error
            }, event.origin);
          }
        } catch (e) {
          // Send error back
          if (event.source && event.source.postMessage) {
            event.source.postMessage({
              type: 'VELUNA_ATC_RESULT',
              requestId: requestId,
              ok: false,
              error: e.message || String(e)
            }, event.origin);
          }
        }
      });
      
      // Send ready ping on load and after section rerenders
      function sendReadyPing() {
        if (window.top && window.top.postMessage) {
          var atcCount = document.querySelectorAll('[data-veluna-atc]').length;
          window.top.postMessage({
            type: 'VELUNA_ATC_READY',
            ok: true,
            hasAPI: typeof window.VelunaAddToCart !== 'undefined',
            atcCount: atcCount,
            href: window.location.href
          }, window.location.origin);
        }
      }
      
      // Send ready ping on load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(sendReadyPing, 100);
        });
      } else {
        setTimeout(sendReadyPing, 100);
      }
      
      // Send ready ping after section rerenders
      document.addEventListener('shopify:section:load', function() {
        setTimeout(sendReadyPing, 200);
      });
      document.addEventListener('shopify:section:select', function() {
        setTimeout(sendReadyPing, 200);
      });
      document.addEventListener('shopify:section:deselect', function() {
        setTimeout(sendReadyPing, 200);
      });
      document.addEventListener('shopify:section:unload', function() {
        setTimeout(sendReadyPing, 200);
      });
      
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] Theme Editor Debug Bridge active in preview iframe');
      }
    })();
    
    // ============================================================================
    // THEME EDITOR DOM RESILIENCE: Rebind/unlock on section rerender
    // ============================================================================
    // Handles Theme Editor section re-renders that replace DOM nodes
    // Always queries fresh buttons - never uses cached references
    function handleSectionRerender(event, eventName) {
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] Theme Editor section rerender:', eventName, event.detail);
      }
      
      // Small delay to allow DOM to settle after rerender
      setTimeout(function() {
        // Ensure ATC buttons are ready (idempotent, lightweight)
        ensureATCReady('section-rerender-' + eventName);
        
        // Re-attach handlers if needed (idempotent - handlers are already delegated on document)
        // Note: Event delegation on document persists across rerenders, so no re-attachment needed
        // This is just for logging/debugging
        if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
          console.log('[VELUNA_ATC] Section rerender handled - delegated handlers persist');
        }
      }, 100);
    }
    
    // Listen for Theme Editor section events
    // Re-attach handlers idempotently on section rerenders (Theme Editor replaces DOM)
    document.addEventListener('shopify:section:load', function(event) {
      // Re-attach handlers if DOM was replaced (data attribute may be lost)
      attachATCHandlersIdempotent();
      handleSectionRerender(event, 'load');
    });
    
    document.addEventListener('shopify:section:select', function(event) {
      attachATCHandlersIdempotent();
      handleSectionRerender(event, 'select');
    });
    
    document.addEventListener('shopify:section:deselect', function(event) {
      handleSectionRerender(event, 'deselect');
    });
    
    document.addEventListener('shopify:section:unload', function(event) {
      handleSectionRerender(event, 'unload');
    });
    
    // Also re-attach on DOMContentLoaded (Theme Editor may replace DOM)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachATCHandlersIdempotent);
    } else {
      // DOM already loaded, attach immediately
      attachATCHandlersIdempotent();
    }
    
    // ============================================================================
    // THEME EDITOR DEBUG BRIDGE: PostMessage API for top-frame console access
    // ============================================================================
    // Allows top admin frame to call VelunaAddToCart APIs in preview iframe
    // Only active when Shopify.designMode && (VELUNA_ATC_DEBUG || VELUNA_DEBUG)
    (function setupThemeEditorBridge() {
      // Only enable in design mode with debug flag
      if (!window.Shopify || window.Shopify.designMode !== true) {
        return; // Not in Theme Editor
      }
      
      if (!window.VELUNA_ATC_DEBUG && !window.VELUNA_DEBUG) {
        return; // Debug bridge disabled
      }
      
      // Only set up once
      if (window.__VELUNA_ATC_BRIDGE_SETUP__) {
        return;
      }
      window.__VELUNA_ATC_BRIDGE_SETUP__ = true;
      
      // Listen for messages from top frame
      window.addEventListener('message', function(event) {
        // Security: Only accept messages from same origin
        if (event.origin !== window.location.origin) {
          return;
        }
        
        var message = event.data;
        if (!message || message.type !== 'VELUNA_ATC_CALL') {
          return;
        }
        
        var fn = message.fn;
        var args = message.args || [];
        var requestId = message.requestId;
        
        if (!requestId) {
          return; // Invalid message
        }
        
        try {
          // Execute function if it exists
          var result = null;
          var ok = false;
          var error = null;
          
          if (typeof window.VelunaAddToCart === 'undefined') {
            error = 'VelunaAddToCart API not available';
          } else if (typeof window.VelunaAddToCart[fn] !== 'function') {
            error = 'Function ' + fn + ' not found in VelunaAddToCart';
          } else {
            // Execute the function
            result = window.VelunaAddToCart[fn].apply(window.VelunaAddToCart, args);
            ok = true;
          }
          
          // Send result back to top frame
          if (event.source && event.source.postMessage) {
            event.source.postMessage({
              type: 'VELUNA_ATC_RESULT',
              requestId: requestId,
              ok: ok,
              result: result,
              error: error
            }, event.origin);
          }
        } catch (e) {
          // Send error back
          if (event.source && event.source.postMessage) {
            event.source.postMessage({
              type: 'VELUNA_ATC_RESULT',
              requestId: requestId,
              ok: false,
              error: e.message || String(e)
            }, event.origin);
          }
        }
      });
      
      // Send ready ping on load and after section rerenders
      function sendReadyPing() {
        if (window.top && window.top.postMessage) {
          var atcCount = document.querySelectorAll('[data-veluna-atc]').length;
          window.top.postMessage({
            type: 'VELUNA_ATC_READY',
            ok: true,
            hasAPI: typeof window.VelunaAddToCart !== 'undefined',
            atcCount: atcCount,
            href: window.location.href
          }, window.location.origin);
        }
      }
      
      // Send ready ping on load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(sendReadyPing, 100);
        });
      } else {
        setTimeout(sendReadyPing, 100);
      }
      
      // Send ready ping after section rerenders
      document.addEventListener('shopify:section:load', function() {
        setTimeout(sendReadyPing, 200);
      });
      document.addEventListener('shopify:section:select', function() {
        setTimeout(sendReadyPing, 200);
      });
      document.addEventListener('shopify:section:deselect', function() {
        setTimeout(sendReadyPing, 200);
      });
      document.addEventListener('shopify:section:unload', function() {
        setTimeout(sendReadyPing, 200);
      });
      
      if (window.VELUNA_ATC_DEBUG || window.VELUNA_DEBUG) {
        console.log('[VELUNA_ATC] Theme Editor Debug Bridge active in preview iframe');
      }
    })();
  
  })();
  } catch (error) {
    console.error('❌ Veluna Add to Cart: Script initialization failed:', error);
  }

} // End of guard check - only executes if window.__VELUNA_ATC_LOADED__ was false

} catch (e) {
  // Top-level crash capture
  window.__VELUNA_BOOT_ERROR__ = {
    message: e && e.message ? e.message : String(e),
    stack: e && e.stack ? e.stack : 'no stack'
  };
  console.error('[VELUNA] BOOT_ERROR', e);
}

// PHASE 1: Set up drawer close handlers immediately (fallback if build script doesn't execute)
// This runs after the main script loads
if (typeof setupDrawerCloseHandlers === 'function') {
  // Wait a bit for build script to execute, then set up fallback if needed
  setTimeout(function() {
    if (typeof window.__VELUNA_DRAWER_EXEC_PROOF === 'undefined') {
      setupDrawerCloseHandlers();
    }
  }, 1000);
}



